(() => {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequireea44"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequireea44"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("ojnWK", function(module, exports) {

$parcel$export(module.exports, "focus", () => src_default);
$parcel$export(module.exports, "default", () => module_default);
// node_modules/tabbable/dist/index.esm.js
var candidateSelectors = [
    "input",
    "select",
    "textarea",
    "a[href]",
    "button",
    "[tabindex]:not(slot)",
    "audio[controls]",
    "video[controls]",
    '[contenteditable]:not([contenteditable="false"])',
    "details>summary:first-of-type",
    "details"
];
var candidateSelector = /* @__PURE__ */ candidateSelectors.join(",");
var NoElement = typeof Element === "undefined";
var matches = NoElement ? function() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var getRootNode = !NoElement && Element.prototype.getRootNode ? function(element) {
    return element.getRootNode();
} : function(element) {
    return element.ownerDocument;
};
var getCandidates = function getCandidates2(el, includeContainer, filter) {
    var candidates = Array.prototype.slice.apply(el.querySelectorAll(candidateSelector));
    if (includeContainer && matches.call(el, candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
var getCandidatesIteratively = function getCandidatesIteratively2(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if (element.tagName === "SLOT") {
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = getCandidatesIteratively2(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scope: element,
                candidates: nestedCandidates
            });
        } else {
            var validCandidate = matches.call(element, candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === "function" && options.getShadowRoot(element);
            var validShadowRoot = !options.shadowRootFilter || options.shadowRootFilter(element);
            if (shadowRoot && validShadowRoot) {
                var _nestedCandidates = getCandidatesIteratively2(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scope: element,
                    candidates: _nestedCandidates
                });
            } else elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
var getTabindex = function getTabindex2(node, isScope) {
    if (node.tabIndex < 0) {
        if ((isScope || /^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || node.isContentEditable) && isNaN(parseInt(node.getAttribute("tabindex"), 10))) return 0;
    }
    return node.tabIndex;
};
var sortOrderedTabbables = function sortOrderedTabbables2(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var isInput = function isInput2(node) {
    return node.tagName === "INPUT";
};
var isHiddenInput = function isHiddenInput2(node) {
    return isInput(node) && node.type === "hidden";
};
var isDetailsWithSummary = function isDetailsWithSummary2(node) {
    var r = node.tagName === "DETAILS" && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === "SUMMARY";
    });
    return r;
};
var getCheckedRadio = function getCheckedRadio2(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var isTabbableRadio = function isTabbableRadio2(node) {
    if (!node.name) return true;
    var radioScope = node.form || getRootNode(node);
    var queryRadios = function queryRadios2(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== "undefined" && typeof window.CSS !== "undefined" && typeof window.CSS.escape === "function") radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        console.error("Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s", err.message);
        return false;
    }
    var checked = getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var isRadio = function isRadio2(node) {
    return isInput(node) && node.type === "radio";
};
var isNonTabbableRadio = function isNonTabbableRadio2(node) {
    return isRadio(node) && !isTabbableRadio(node);
};
var isZeroArea = function isZeroArea2(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var isHidden = function isHidden2(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (getComputedStyle(node).visibility === "hidden") return true;
    var isDirectSummary = matches.call(node, "details>summary:first-of-type");
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if (matches.call(nodeUnderDetails, "details:not([open]) *")) return true;
    var nodeRootHost = getRootNode(node).host;
    var nodeIsAttached = (nodeRootHost === null || nodeRootHost === void 0 ? void 0 : nodeRootHost.ownerDocument.contains(nodeRootHost)) || node.ownerDocument.contains(node);
    if (!displayCheck || displayCheck === "full") {
        if (typeof getShadowRoot === "function") {
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true) return isZeroArea(node);
                else if (node.assignedSlot) node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) node = rootNode.host;
                else node = parentElement;
            }
            node = originalNode;
        }
        if (nodeIsAttached) return !node.getClientRects().length;
    } else if (displayCheck === "non-zero-area") return isZeroArea(node);
    return false;
};
var isDisabledFromFieldset = function isDisabledFromFieldset2(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        while(parentNode){
            if (parentNode.tagName === "FIELDSET" && parentNode.disabled) {
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    if (child.tagName === "LEGEND") return matches.call(parentNode, "fieldset[disabled] *") ? true : !child.contains(node);
                }
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    return false;
};
var isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable2(options, node) {
    if (node.disabled || isHiddenInput(node) || isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    isDetailsWithSummary(node) || isDisabledFromFieldset(node)) return false;
    return true;
};
var isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable2(options, node) {
    if (isNonTabbableRadio(node) || getTabindex(node) < 0 || !isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var isValidShadowRootTabbable = function isValidShadowRootTabbable2(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute("tabindex"), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    return false;
};
var sortByOrder = function sortByOrder2(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scope;
        var element = isScope ? item.scope : item;
        var candidateTabindex = getTabindex(element, isScope);
        var elements = isScope ? sortByOrder2(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort(sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var tabbable = function tabbable2(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: isValidShadowRootTabbable
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorTabbable.bind(null, options));
    return sortByOrder(candidates);
};
var focusable = function focusable2(el, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = getCandidatesIteratively([
        el
    ], options.includeContainer, {
        filter: isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = getCandidates(el, options.includeContainer, isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var isTabbable = function isTabbable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, candidateSelector) === false) return false;
    return isNodeMatchingSelectorTabbable(options, node);
};
var focusableCandidateSelector = /* @__PURE__ */ candidateSelectors.concat("iframe").join(",");
var isFocusable = function isFocusable2(node, options) {
    options = options || {};
    if (!node) throw new Error("No node provided");
    if (matches.call(node, focusableCandidateSelector) === false) return false;
    return isNodeMatchingSelectorFocusable(options, node);
};
// node_modules/focus-trap/dist/focus-trap.esm.js
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? ownKeys(Object(source), true).forEach(function(key) {
            _defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var activeFocusTraps = function() {
    var trapQueue = [];
    return {
        activateTrap: function activateTrap(trap) {
            if (trapQueue.length > 0) {
                var activeTrap = trapQueue[trapQueue.length - 1];
                if (activeTrap !== trap) activeTrap.pause();
            }
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex === -1) trapQueue.push(trap);
            else {
                trapQueue.splice(trapIndex, 1);
                trapQueue.push(trap);
            }
        },
        deactivateTrap: function deactivateTrap(trap) {
            var trapIndex = trapQueue.indexOf(trap);
            if (trapIndex !== -1) trapQueue.splice(trapIndex, 1);
            if (trapQueue.length > 0) trapQueue[trapQueue.length - 1].unpause();
        }
    };
}();
var isSelectableInput = function isSelectableInput2(node) {
    return node.tagName && node.tagName.toLowerCase() === "input" && typeof node.select === "function";
};
var isEscapeEvent = function isEscapeEvent2(e) {
    return e.key === "Escape" || e.key === "Esc" || e.keyCode === 27;
};
var isTabEvent = function isTabEvent2(e) {
    return e.key === "Tab" || e.keyCode === 9;
};
var delay = function delay2(fn) {
    return setTimeout(fn, 0);
};
var findIndex = function findIndex2(arr, fn) {
    var idx = -1;
    arr.every(function(value, i) {
        if (fn(value)) {
            idx = i;
            return false;
        }
        return true;
    });
    return idx;
};
var valueOrHandler = function valueOrHandler2(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === "function" ? value.apply(void 0, params) : value;
};
var getActualTarget = function getActualTarget2(event) {
    return event.target.shadowRoot && typeof event.composedPath === "function" ? event.composedPath()[0] : event.target;
};
var createFocusTrap = function createFocusTrap2(elements, userOptions) {
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var config = _objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        // @type {Array<HTMLElement>}
        containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        // @type {Array<{
        //   container: HTMLElement,
        //   tabbableNodes: Array<HTMLElement>, // empty if none
        //   focusableNodes: Array<HTMLElement>, // empty if none
        //   firstTabbableNode: HTMLElement|null,
        //   lastTabbableNode: HTMLElement|null,
        //   nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
        // }>}
        containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: void 0
    };
    var trap;
    var getOption = function getOption2(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== void 0 ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    var findContainerIndex = function findContainerIndex2(element) {
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || // fall back to explicit tabbable search which will take into consideration any
            //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    var getNodeForOption = function getNodeForOption2(optionName) {
        var optionValue = config[optionName];
        if (typeof optionValue === "function") {
            for(var _len2 = arguments.length, params = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)params[_key2 - 1] = arguments[_key2];
            optionValue = optionValue.apply(void 0, params);
        }
        if (optionValue === true) optionValue = void 0;
        if (!optionValue) {
            if (optionValue === void 0 || optionValue === false) return optionValue;
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue;
        if (typeof optionValue === "string") {
            node = doc.querySelector(optionValue);
            if (!node) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
        }
        return node;
    };
    var getInitialFocusNode = function getInitialFocusNode2() {
        var node = getNodeForOption("initialFocus");
        if (node === false) return false;
        if (node === void 0) {
            if (findContainerIndex(doc.activeElement) >= 0) node = doc.activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                node = firstTabbableNode || getNodeForOption("fallbackFocus");
            }
        }
        if (!node) throw new Error("Your focus-trap needs to have at least one focusable element");
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes2() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = tabbable(container, config.tabbableOptions);
            var focusableNodes = focusable(container, config.tabbableOptions);
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                firstTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[0] : null,
                lastTabbableNode: tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : null,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                    var nodeIdx = focusableNodes.findIndex(function(n) {
                        return n === node;
                    });
                    if (nodeIdx < 0) return void 0;
                    if (forward) return focusableNodes.slice(nodeIdx + 1).find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                    return focusableNodes.slice(0, nodeIdx).reverse().find(function(n) {
                        return isTabbable(n, config.tabbableOptions);
                    });
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        if (state.tabbableGroups.length <= 0 && !getNodeForOption("fallbackFocus")) throw new Error("Your focus-trap must have at least one container with at least one tabbable node in it at all times");
    };
    var tryFocus = function tryFocus2(node) {
        if (node === false) return;
        if (node === doc.activeElement) return;
        if (!node || !node.focus) {
            tryFocus2(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        state.mostRecentlyFocusedNode = node;
        if (isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode2(previousActiveElement) {
        var node = getNodeForOption("setReturnFocus", previousActiveElement);
        return node ? node : node === false ? false : previousActiveElement;
    };
    var checkPointerDown = function checkPointerDown2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) {
            trap.deactivate({
                // if, on deactivation, we should return focus to the node originally-focused
                //  when the trap was activated (or the configured `setReturnFocus` node),
                //  then assume it's also OK to return focus to the outside node that was
                //  just clicked, causing deactivation, as long as that node is focusable;
                //  if it isn't focusable, then return focus to the original node focused
                //  on activation (or the configured `setReturnFocus` node)
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked, whether it's focusable or not; by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node)
                returnFocus: config.returnFocusOnDeactivate && !isFocusable(target, config.tabbableOptions)
            });
            return;
        }
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
    };
    var checkFocusIn = function checkFocusIn2(e) {
        var target = getActualTarget(e);
        var targetContained = findContainerIndex(target) >= 0;
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            e.stopImmediatePropagation();
            tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
    };
    var checkTab = function checkTab2(e) {
        var target = getActualTarget(e);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            var containerIndex = findContainerIndex(target);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : void 0;
            if (containerIndex < 0) {
                if (e.shiftKey) destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (e.shiftKey) {
                var startOfGroupIndex = findIndex(state.tabbableGroups, function(_ref2) {
                    var firstTabbableNode = _ref2.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = destinationGroup.lastTabbableNode;
                }
            } else {
                var lastOfGroupIndex = findIndex(state.tabbableGroups, function(_ref3) {
                    var lastTabbableNode = _ref3.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || isFocusable(target, config.tabbableOptions) && !isTabbable(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = _destinationGroup.firstTabbableNode;
                }
            }
        } else destinationNode = getNodeForOption("fallbackFocus");
        if (destinationNode) {
            e.preventDefault();
            tryFocus(destinationNode);
        }
    };
    var checkKey = function checkKey2(e) {
        if (isEscapeEvent(e) && valueOrHandler(config.escapeDeactivates, e) !== false) {
            e.preventDefault();
            trap.deactivate();
            return;
        }
        if (isTabEvent(e)) {
            checkTab(e);
            return;
        }
    };
    var checkClick = function checkClick2(e) {
        var target = getActualTarget(e);
        if (findContainerIndex(target) >= 0) return;
        if (valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if (valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    var addListeners = function addListeners2() {
        if (!state.active) return;
        activeFocusTraps.activateTrap(trap);
        state.delayInitialFocusTimer = config.delayInitialFocus ? delay(function() {
            tryFocus(getInitialFocusNode());
        }) : tryFocus(getInitialFocusNode());
        doc.addEventListener("focusin", checkFocusIn, true);
        doc.addEventListener("mousedown", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("touchstart", checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener("click", checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener("keydown", checkKey, {
            capture: true,
            passive: false
        });
        return trap;
    };
    var removeListeners = function removeListeners2() {
        if (!state.active) return;
        doc.removeEventListener("focusin", checkFocusIn, true);
        doc.removeEventListener("mousedown", checkPointerDown, true);
        doc.removeEventListener("touchstart", checkPointerDown, true);
        doc.removeEventListener("click", checkClick, true);
        doc.removeEventListener("keydown", checkKey, true);
        return trap;
    };
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, "onActivate");
            var onPostActivate = getOption(activateOptions, "onPostActivate");
            var checkCanFocusTrap = getOption(activateOptions, "checkCanFocusTrap");
            if (!checkCanFocusTrap) updateTabbableNodes();
            state.active = true;
            state.paused = false;
            state.nodeFocusedBeforeActivation = doc.activeElement;
            if (onActivate) onActivate();
            var finishActivation = function finishActivation2() {
                if (checkCanFocusTrap) updateTabbableNodes();
                addListeners();
                if (onPostActivate) onPostActivate();
            };
            if (checkCanFocusTrap) {
                checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                return this;
            }
            finishActivation();
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = _objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer);
            state.delayInitialFocusTimer = void 0;
            removeListeners();
            state.active = false;
            state.paused = false;
            activeFocusTraps.deactivateTrap(trap);
            var onDeactivate = getOption(options, "onDeactivate");
            var onPostDeactivate = getOption(options, "onPostDeactivate");
            var checkCanReturnFocus = getOption(options, "checkCanReturnFocus");
            var returnFocus = getOption(options, "returnFocus", "returnFocusOnDeactivate");
            if (onDeactivate) onDeactivate();
            var finishDeactivation = function finishDeactivation2() {
                delay(function() {
                    if (returnFocus) tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                    if (onPostDeactivate) onPostDeactivate();
                });
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause() {
            if (state.paused || !state.active) return this;
            state.paused = true;
            removeListeners();
            return this;
        },
        unpause: function unpause() {
            if (!state.paused || !state.active) return this;
            state.paused = false;
            updateTabbableNodes();
            addListeners();
            return this;
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === "string" ? doc.querySelector(element) : element;
            });
            if (state.active) updateTabbableNodes();
            return this;
        }
    };
    trap.updateContainerElements(elements);
    return trap;
};
// packages/focus/src/index.js
function src_default(Alpine) {
    let lastFocused;
    let currentFocused;
    window.addEventListener("focusin", ()=>{
        lastFocused = currentFocused;
        currentFocused = document.activeElement;
    });
    Alpine.magic("focus", (el)=>{
        let within = el;
        return {
            __noscroll: false,
            __wrapAround: false,
            within (el2) {
                within = el2;
                return this;
            },
            withoutScrolling () {
                this.__noscroll = true;
                return this;
            },
            noscroll () {
                this.__noscroll = true;
                return this;
            },
            withWrapAround () {
                this.__wrapAround = true;
                return this;
            },
            wrap () {
                return this.withWrapAround();
            },
            focusable (el2) {
                return isFocusable(el2);
            },
            previouslyFocused () {
                return lastFocused;
            },
            lastFocused () {
                return lastFocused;
            },
            focused () {
                return currentFocused;
            },
            focusables () {
                if (Array.isArray(within)) return within;
                return focusable(within, {
                    displayCheck: "none"
                });
            },
            all () {
                return this.focusables();
            },
            isFirst (el2) {
                let els = this.all();
                return els[0] && els[0].isSameNode(el2);
            },
            isLast (el2) {
                let els = this.all();
                return els.length && els.slice(-1)[0].isSameNode(el2);
            },
            getFirst () {
                return this.all()[0];
            },
            getLast () {
                return this.all().slice(-1)[0];
            },
            getNext () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === list.length - 1) return list[0];
                return list[list.indexOf(current) + 1];
            },
            getPrevious () {
                let list = this.all();
                let current = document.activeElement;
                if (list.indexOf(current) === -1) return;
                if (this.__wrapAround && list.indexOf(current) === 0) return list.slice(-1)[0];
                return list[list.indexOf(current) - 1];
            },
            first () {
                this.focus(this.getFirst());
            },
            last () {
                this.focus(this.getLast());
            },
            next () {
                this.focus(this.getNext());
            },
            previous () {
                this.focus(this.getPrevious());
            },
            prev () {
                return this.previous();
            },
            focus (el2) {
                if (!el2) return;
                setTimeout(()=>{
                    if (!el2.hasAttribute("tabindex")) el2.setAttribute("tabindex", "0");
                    el2.focus({
                        preventScroll: this.__noscroll
                    });
                });
            }
        };
    });
    Alpine.directive("trap", Alpine.skipDuringClone((el, { expression, modifiers }, { effect, evaluateLater, cleanup })=>{
        let evaluator = evaluateLater(expression);
        let oldValue = false;
        let options = {
            escapeDeactivates: false,
            allowOutsideClick: true,
            fallbackFocus: ()=>el
        };
        let undoInert = ()=>{};
        if (modifiers.includes("noautofocus")) options.initialFocus = false;
        else {
            let autofocusEl = el.querySelector("[autofocus]");
            if (autofocusEl) options.initialFocus = autofocusEl;
        }
        if (modifiers.includes("inert")) options.onPostActivate = ()=>{
            Alpine.nextTick(()=>{
                undoInert = setInert(el);
            });
        };
        let trap = createFocusTrap(el, options);
        let undoDisableScrolling = ()=>{};
        const releaseFocus = ()=>{
            undoInert();
            undoInert = ()=>{};
            undoDisableScrolling();
            undoDisableScrolling = ()=>{};
            trap.deactivate({
                returnFocus: !modifiers.includes("noreturn")
            });
        };
        effect(()=>evaluator((value)=>{
                if (oldValue === value) return;
                if (value && !oldValue) {
                    if (modifiers.includes("noscroll")) undoDisableScrolling = disableScrolling();
                    setTimeout(()=>{
                        trap.activate();
                    }, 15);
                }
                if (!value && oldValue) releaseFocus();
                oldValue = !!value;
            }));
        cleanup(releaseFocus);
    }, // When cloning, we only want to add aria-hidden attributes to the
    // DOM and not try to actually trap, as trapping can mess with the
    // live DOM and isn't just isolated to the cloned DOM.
    (el, { expression, modifiers }, { evaluate })=>{
        if (modifiers.includes("inert") && evaluate(expression)) setInert(el);
    }));
}
function setInert(el) {
    let undos = [];
    crawlSiblingsUp(el, (sibling)=>{
        let cache = sibling.hasAttribute("aria-hidden");
        sibling.setAttribute("aria-hidden", "true");
        undos.push(()=>cache || sibling.removeAttribute("aria-hidden"));
    });
    return ()=>{
        while(undos.length)undos.pop()();
    };
}
function crawlSiblingsUp(el, callback) {
    if (el.isSameNode(document.body) || !el.parentNode) return;
    Array.from(el.parentNode.children).forEach((sibling)=>{
        if (sibling.isSameNode(el)) crawlSiblingsUp(el.parentNode, callback);
        else callback(sibling);
    });
}
function disableScrolling() {
    let overflow = document.documentElement.style.overflow;
    let paddingRight = document.documentElement.style.paddingRight;
    let scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = "hidden";
    document.documentElement.style.paddingRight = `${scrollbarWidth}px`;
    return ()=>{
        document.documentElement.style.overflow = overflow;
        document.documentElement.style.paddingRight = paddingRight;
    };
}
// packages/focus/builds/module.js
var module_default = src_default;
 /*! Bundled license information:

tabbable/dist/index.esm.js:
  (*!
  * tabbable 5.3.3
  * @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
  *)

focus-trap/dist/focus-trap.esm.js:
  (*!
  * focus-trap 6.9.4
  * @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
  *)
*/ 
});

// packages/alpinejs/src/scheduler.js
var $f347e48613385d9c$var$flushPending = false;
var $f347e48613385d9c$var$flushing = false;
var $f347e48613385d9c$var$queue = [];
var $f347e48613385d9c$var$lastFlushedIndex = -1;
function $f347e48613385d9c$var$scheduler(callback) {
    $f347e48613385d9c$var$queueJob(callback);
}
function $f347e48613385d9c$var$queueJob(job) {
    if (!$f347e48613385d9c$var$queue.includes(job)) $f347e48613385d9c$var$queue.push(job);
    $f347e48613385d9c$var$queueFlush();
}
function $f347e48613385d9c$var$dequeueJob(job) {
    let index = $f347e48613385d9c$var$queue.indexOf(job);
    if (index !== -1 && index > $f347e48613385d9c$var$lastFlushedIndex) $f347e48613385d9c$var$queue.splice(index, 1);
}
function $f347e48613385d9c$var$queueFlush() {
    if (!$f347e48613385d9c$var$flushing && !$f347e48613385d9c$var$flushPending) {
        $f347e48613385d9c$var$flushPending = true;
        queueMicrotask($f347e48613385d9c$var$flushJobs);
    }
}
function $f347e48613385d9c$var$flushJobs() {
    $f347e48613385d9c$var$flushPending = false;
    $f347e48613385d9c$var$flushing = true;
    for(let i = 0; i < $f347e48613385d9c$var$queue.length; i++){
        $f347e48613385d9c$var$queue[i]();
        $f347e48613385d9c$var$lastFlushedIndex = i;
    }
    $f347e48613385d9c$var$queue.length = 0;
    $f347e48613385d9c$var$lastFlushedIndex = -1;
    $f347e48613385d9c$var$flushing = false;
}
// packages/alpinejs/src/reactivity.js
var $f347e48613385d9c$var$reactive;
var $f347e48613385d9c$var$effect;
var $f347e48613385d9c$var$release;
var $f347e48613385d9c$var$raw;
var $f347e48613385d9c$var$shouldSchedule = true;
function $f347e48613385d9c$var$disableEffectScheduling(callback) {
    $f347e48613385d9c$var$shouldSchedule = false;
    callback();
    $f347e48613385d9c$var$shouldSchedule = true;
}
function $f347e48613385d9c$var$setReactivityEngine(engine) {
    $f347e48613385d9c$var$reactive = engine.reactive;
    $f347e48613385d9c$var$release = engine.release;
    $f347e48613385d9c$var$effect = (callback)=>engine.effect(callback, {
            scheduler: (task)=>{
                if ($f347e48613385d9c$var$shouldSchedule) $f347e48613385d9c$var$scheduler(task);
                else task();
            }
        });
    $f347e48613385d9c$var$raw = engine.raw;
}
function $f347e48613385d9c$var$overrideEffect(override) {
    $f347e48613385d9c$var$effect = override;
}
function $f347e48613385d9c$var$elementBoundEffect(el) {
    let cleanup2 = ()=>{};
    let wrappedEffect = (callback)=>{
        let effectReference = $f347e48613385d9c$var$effect(callback);
        if (!el._x_effects) {
            el._x_effects = /* @__PURE__ */ new Set();
            el._x_runEffects = ()=>{
                el._x_effects.forEach((i)=>i());
            };
        }
        el._x_effects.add(effectReference);
        cleanup2 = ()=>{
            if (effectReference === void 0) return;
            el._x_effects.delete(effectReference);
            $f347e48613385d9c$var$release(effectReference);
        };
        return effectReference;
    };
    return [
        wrappedEffect,
        ()=>{
            cleanup2();
        }
    ];
}
function $f347e48613385d9c$var$watch(getter, callback) {
    let firstTime = true;
    let oldValue;
    let effectReference = $f347e48613385d9c$var$effect(()=>{
        let value = getter();
        JSON.stringify(value);
        if (!firstTime) queueMicrotask(()=>{
            callback(value, oldValue);
            oldValue = value;
        });
        else oldValue = value;
        firstTime = false;
    });
    return ()=>$f347e48613385d9c$var$release(effectReference);
}
// packages/alpinejs/src/mutation.js
var $f347e48613385d9c$var$onAttributeAddeds = [];
var $f347e48613385d9c$var$onElRemoveds = [];
var $f347e48613385d9c$var$onElAddeds = [];
function $f347e48613385d9c$var$onElAdded(callback) {
    $f347e48613385d9c$var$onElAddeds.push(callback);
}
function $f347e48613385d9c$var$onElRemoved(el, callback) {
    if (typeof callback === "function") {
        if (!el._x_cleanups) el._x_cleanups = [];
        el._x_cleanups.push(callback);
    } else {
        callback = el;
        $f347e48613385d9c$var$onElRemoveds.push(callback);
    }
}
function $f347e48613385d9c$var$onAttributesAdded(callback) {
    $f347e48613385d9c$var$onAttributeAddeds.push(callback);
}
function $f347e48613385d9c$var$onAttributeRemoved(el, name, callback) {
    if (!el._x_attributeCleanups) el._x_attributeCleanups = {};
    if (!el._x_attributeCleanups[name]) el._x_attributeCleanups[name] = [];
    el._x_attributeCleanups[name].push(callback);
}
function $f347e48613385d9c$var$cleanupAttributes(el, names) {
    if (!el._x_attributeCleanups) return;
    Object.entries(el._x_attributeCleanups).forEach(([name, value])=>{
        if (names === void 0 || names.includes(name)) {
            value.forEach((i)=>i());
            delete el._x_attributeCleanups[name];
        }
    });
}
function $f347e48613385d9c$var$cleanupElement(el) {
    el._x_effects?.forEach($f347e48613385d9c$var$dequeueJob);
    while(el._x_cleanups?.length)el._x_cleanups.pop()();
}
var $f347e48613385d9c$var$observer = new MutationObserver($f347e48613385d9c$var$onMutate);
var $f347e48613385d9c$var$currentlyObserving = false;
function $f347e48613385d9c$var$startObservingMutations() {
    $f347e48613385d9c$var$observer.observe(document, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeOldValue: true
    });
    $f347e48613385d9c$var$currentlyObserving = true;
}
function $f347e48613385d9c$var$stopObservingMutations() {
    $f347e48613385d9c$var$flushObserver();
    $f347e48613385d9c$var$observer.disconnect();
    $f347e48613385d9c$var$currentlyObserving = false;
}
var $f347e48613385d9c$var$queuedMutations = [];
function $f347e48613385d9c$var$flushObserver() {
    let records = $f347e48613385d9c$var$observer.takeRecords();
    $f347e48613385d9c$var$queuedMutations.push(()=>records.length > 0 && $f347e48613385d9c$var$onMutate(records));
    let queueLengthWhenTriggered = $f347e48613385d9c$var$queuedMutations.length;
    queueMicrotask(()=>{
        if ($f347e48613385d9c$var$queuedMutations.length === queueLengthWhenTriggered) while($f347e48613385d9c$var$queuedMutations.length > 0)$f347e48613385d9c$var$queuedMutations.shift()();
    });
}
function $f347e48613385d9c$var$mutateDom(callback) {
    if (!$f347e48613385d9c$var$currentlyObserving) return callback();
    $f347e48613385d9c$var$stopObservingMutations();
    let result = callback();
    $f347e48613385d9c$var$startObservingMutations();
    return result;
}
var $f347e48613385d9c$var$isCollecting = false;
var $f347e48613385d9c$var$deferredMutations = [];
function $f347e48613385d9c$var$deferMutations() {
    $f347e48613385d9c$var$isCollecting = true;
}
function $f347e48613385d9c$var$flushAndStopDeferringMutations() {
    $f347e48613385d9c$var$isCollecting = false;
    $f347e48613385d9c$var$onMutate($f347e48613385d9c$var$deferredMutations);
    $f347e48613385d9c$var$deferredMutations = [];
}
function $f347e48613385d9c$var$onMutate(mutations) {
    if ($f347e48613385d9c$var$isCollecting) {
        $f347e48613385d9c$var$deferredMutations = $f347e48613385d9c$var$deferredMutations.concat(mutations);
        return;
    }
    let addedNodes = [];
    let removedNodes = /* @__PURE__ */ new Set();
    let addedAttributes = /* @__PURE__ */ new Map();
    let removedAttributes = /* @__PURE__ */ new Map();
    for(let i = 0; i < mutations.length; i++){
        if (mutations[i].target._x_ignoreMutationObserver) continue;
        if (mutations[i].type === "childList") {
            mutations[i].removedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (!node._x_marker) return;
                removedNodes.add(node);
            });
            mutations[i].addedNodes.forEach((node)=>{
                if (node.nodeType !== 1) return;
                if (removedNodes.has(node)) {
                    removedNodes.delete(node);
                    return;
                }
                if (node._x_marker) return;
                addedNodes.push(node);
            });
        }
        if (mutations[i].type === "attributes") {
            let el = mutations[i].target;
            let name = mutations[i].attributeName;
            let oldValue = mutations[i].oldValue;
            let add2 = ()=>{
                if (!addedAttributes.has(el)) addedAttributes.set(el, []);
                addedAttributes.get(el).push({
                    name: name,
                    value: el.getAttribute(name)
                });
            };
            let remove = ()=>{
                if (!removedAttributes.has(el)) removedAttributes.set(el, []);
                removedAttributes.get(el).push(name);
            };
            if (el.hasAttribute(name) && oldValue === null) add2();
            else if (el.hasAttribute(name)) {
                remove();
                add2();
            } else remove();
        }
    }
    removedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$cleanupAttributes(el, attrs);
    });
    addedAttributes.forEach((attrs, el)=>{
        $f347e48613385d9c$var$onAttributeAddeds.forEach((i)=>i(el, attrs));
    });
    for (let node of removedNodes){
        if (addedNodes.some((i)=>i.contains(node))) continue;
        $f347e48613385d9c$var$onElRemoveds.forEach((i)=>i(node));
    }
    for (let node of addedNodes){
        if (!node.isConnected) continue;
        $f347e48613385d9c$var$onElAddeds.forEach((i)=>i(node));
    }
    addedNodes = null;
    removedNodes = null;
    addedAttributes = null;
    removedAttributes = null;
}
// packages/alpinejs/src/scope.js
function $f347e48613385d9c$var$scope(node) {
    return $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$closestDataStack(node));
}
function $f347e48613385d9c$var$addScopeToNode(node, data2, referenceNode) {
    node._x_dataStack = [
        data2,
        ...$f347e48613385d9c$var$closestDataStack(referenceNode || node)
    ];
    return ()=>{
        node._x_dataStack = node._x_dataStack.filter((i)=>i !== data2);
    };
}
function $f347e48613385d9c$var$closestDataStack(node) {
    if (node._x_dataStack) return node._x_dataStack;
    if (typeof ShadowRoot === "function" && node instanceof ShadowRoot) return $f347e48613385d9c$var$closestDataStack(node.host);
    if (!node.parentNode) return [];
    return $f347e48613385d9c$var$closestDataStack(node.parentNode);
}
function $f347e48613385d9c$var$mergeProxies(objects) {
    return new Proxy({
        objects: objects
    }, $f347e48613385d9c$var$mergeProxyTrap);
}
var $f347e48613385d9c$var$mergeProxyTrap = {
    ownKeys ({ objects: objects }) {
        return Array.from(new Set(objects.flatMap((i)=>Object.keys(i))));
    },
    has ({ objects: objects }, name) {
        if (name == Symbol.unscopables) return false;
        return objects.some((obj)=>Object.prototype.hasOwnProperty.call(obj, name) || Reflect.has(obj, name));
    },
    get ({ objects: objects }, name, thisProxy) {
        if (name == "toJSON") return $f347e48613385d9c$var$collapseProxies;
        return Reflect.get(objects.find((obj)=>Reflect.has(obj, name)) || {}, name, thisProxy);
    },
    set ({ objects: objects }, name, value, thisProxy) {
        const target = objects.find((obj)=>Object.prototype.hasOwnProperty.call(obj, name)) || objects[objects.length - 1];
        const descriptor = Object.getOwnPropertyDescriptor(target, name);
        if (descriptor?.set && descriptor?.get) return descriptor.set.call(thisProxy, value) || true;
        return Reflect.set(target, name, value);
    }
};
function $f347e48613385d9c$var$collapseProxies() {
    let keys = Reflect.ownKeys(this);
    return keys.reduce((acc, key)=>{
        acc[key] = Reflect.get(this, key);
        return acc;
    }, {});
}
// packages/alpinejs/src/interceptor.js
function $f347e48613385d9c$var$initInterceptors(data2) {
    let isObject2 = (val)=>typeof val === "object" && !Array.isArray(val) && val !== null;
    let recurse = (obj, basePath = "")=>{
        Object.entries(Object.getOwnPropertyDescriptors(obj)).forEach(([key, { value: value, enumerable: enumerable }])=>{
            if (enumerable === false || value === void 0) return;
            if (typeof value === "object" && value !== null && value.__v_skip) return;
            let path = basePath === "" ? key : `${basePath}.${key}`;
            if (typeof value === "object" && value !== null && value._x_interceptor) obj[key] = value.initialize(data2, path, key);
            else if (isObject2(value) && value !== obj && !(value instanceof Element)) recurse(value, path);
        });
    };
    return recurse(data2);
}
function $f347e48613385d9c$var$interceptor(callback, mutateObj = ()=>{}) {
    let obj = {
        initialValue: void 0,
        _x_interceptor: true,
        initialize (data2, path, key) {
            return callback(this.initialValue, ()=>$f347e48613385d9c$var$get(data2, path), (value)=>$f347e48613385d9c$var$set(data2, path, value), path, key);
        }
    };
    mutateObj(obj);
    return (initialValue)=>{
        if (typeof initialValue === "object" && initialValue !== null && initialValue._x_interceptor) {
            let initialize = obj.initialize.bind(obj);
            obj.initialize = (data2, path, key)=>{
                let innerValue = initialValue.initialize(data2, path, key);
                obj.initialValue = innerValue;
                return initialize(data2, path, key);
            };
        } else obj.initialValue = initialValue;
        return obj;
    };
}
function $f347e48613385d9c$var$get(obj, path) {
    return path.split(".").reduce((carry, segment)=>carry[segment], obj);
}
function $f347e48613385d9c$var$set(obj, path, value) {
    if (typeof path === "string") path = path.split(".");
    if (path.length === 1) obj[path[0]] = value;
    else if (path.length === 0) throw error;
    else {
        if (obj[path[0]]) return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        else {
            obj[path[0]] = {};
            return $f347e48613385d9c$var$set(obj[path[0]], path.slice(1), value);
        }
    }
}
// packages/alpinejs/src/magics.js
var $f347e48613385d9c$var$magics = {};
function $f347e48613385d9c$var$magic(name, callback) {
    $f347e48613385d9c$var$magics[name] = callback;
}
function $f347e48613385d9c$var$injectMagics(obj, el) {
    let memoizedUtilities = $f347e48613385d9c$var$getUtilities(el);
    Object.entries($f347e48613385d9c$var$magics).forEach(([name, callback])=>{
        Object.defineProperty(obj, `$${name}`, {
            get () {
                return callback(el, memoizedUtilities);
            },
            enumerable: false
        });
    });
    return obj;
}
function $f347e48613385d9c$var$getUtilities(el) {
    let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
    let utils = {
        interceptor: $f347e48613385d9c$var$interceptor,
        ...utilities
    };
    $f347e48613385d9c$var$onElRemoved(el, cleanup2);
    return utils;
}
// packages/alpinejs/src/utils/error.js
function $f347e48613385d9c$var$tryCatch(el, expression, callback, ...args) {
    try {
        return callback(...args);
    } catch (e) {
        $f347e48613385d9c$var$handleError(e, el, expression);
    }
}
function $f347e48613385d9c$var$handleError(error2, el, expression) {
    error2 = Object.assign(error2 ?? {
        message: "No error message given."
    }, {
        el: el,
        expression: expression
    });
    console.warn(`Alpine Expression Error: ${error2.message}

${expression ? 'Expression: "' + expression + '"\n\n' : ""}`, el);
    setTimeout(()=>{
        throw error2;
    }, 0);
}
// packages/alpinejs/src/evaluator.js
var $f347e48613385d9c$var$shouldAutoEvaluateFunctions = true;
function $f347e48613385d9c$var$dontAutoEvaluateFunctions(callback) {
    let cache = $f347e48613385d9c$var$shouldAutoEvaluateFunctions;
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = false;
    let result = callback();
    $f347e48613385d9c$var$shouldAutoEvaluateFunctions = cache;
    return result;
}
function $f347e48613385d9c$var$evaluate(el, expression, extras = {}) {
    let result;
    $f347e48613385d9c$var$evaluateLater(el, expression)((value)=>result = value, extras);
    return result;
}
function $f347e48613385d9c$var$evaluateLater(...args) {
    return $f347e48613385d9c$var$theEvaluatorFunction(...args);
}
var $f347e48613385d9c$var$theEvaluatorFunction = $f347e48613385d9c$var$normalEvaluator;
function $f347e48613385d9c$var$setEvaluator(newEvaluator) {
    $f347e48613385d9c$var$theEvaluatorFunction = newEvaluator;
}
function $f347e48613385d9c$var$normalEvaluator(el, expression) {
    let overriddenMagics = {};
    $f347e48613385d9c$var$injectMagics(overriddenMagics, el);
    let dataStack = [
        overriddenMagics,
        ...$f347e48613385d9c$var$closestDataStack(el)
    ];
    let evaluator = typeof expression === "function" ? $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, expression) : $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el);
    return $f347e48613385d9c$var$tryCatch.bind(null, el, expression, evaluator);
}
function $f347e48613385d9c$var$generateEvaluatorFromFunction(dataStack, func) {
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        let result = func.apply($f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]), params);
        $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result);
    };
}
var $f347e48613385d9c$var$evaluatorMemo = {};
function $f347e48613385d9c$var$generateFunctionFromString(expression, el) {
    if ($f347e48613385d9c$var$evaluatorMemo[expression]) return $f347e48613385d9c$var$evaluatorMemo[expression];
    let AsyncFunction = Object.getPrototypeOf(async function() {}).constructor;
    let rightSideSafeExpression = /^[\n\s]*if.*\(.*\)/.test(expression.trim()) || /^(let|const)\s/.test(expression.trim()) ? `(async()=>{ ${expression} })()` : expression;
    const safeAsyncFunction = ()=>{
        try {
            let func2 = new AsyncFunction([
                "__self",
                "scope"
            ], `with (scope) { __self.result = ${rightSideSafeExpression} }; __self.finished = true; return __self.result;`);
            Object.defineProperty(func2, "name", {
                value: `[Alpine] ${expression}`
            });
            return func2;
        } catch (error2) {
            $f347e48613385d9c$var$handleError(error2, el, expression);
            return Promise.resolve();
        }
    };
    let func = safeAsyncFunction();
    $f347e48613385d9c$var$evaluatorMemo[expression] = func;
    return func;
}
function $f347e48613385d9c$var$generateEvaluatorFromString(dataStack, expression, el) {
    let func = $f347e48613385d9c$var$generateFunctionFromString(expression, el);
    return (receiver = ()=>{}, { scope: scope2 = {}, params: params = [], context: context } = {})=>{
        func.result = void 0;
        func.finished = false;
        let completeScope = $f347e48613385d9c$var$mergeProxies([
            scope2,
            ...dataStack
        ]);
        if (typeof func === "function") {
            let promise = func.call(context, func, completeScope).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression));
            if (func.finished) {
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, func.result, completeScope, params, el);
                func.result = void 0;
            } else promise.then((result)=>{
                $f347e48613385d9c$var$runIfTypeOfFunction(receiver, result, completeScope, params, el);
            }).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, expression)).finally(()=>func.result = void 0);
        }
    };
}
function $f347e48613385d9c$var$runIfTypeOfFunction(receiver, value, scope2, params, el) {
    if ($f347e48613385d9c$var$shouldAutoEvaluateFunctions && typeof value === "function") {
        let result = value.apply(scope2, params);
        if (result instanceof Promise) result.then((i)=>$f347e48613385d9c$var$runIfTypeOfFunction(receiver, i, scope2, params)).catch((error2)=>$f347e48613385d9c$var$handleError(error2, el, value));
        else receiver(result);
    } else if (typeof value === "object" && value instanceof Promise) value.then((i)=>receiver(i));
    else receiver(value);
}
// packages/alpinejs/src/directives.js
var $f347e48613385d9c$var$prefixAsString = "x-";
function $f347e48613385d9c$var$prefix(subject = "") {
    return $f347e48613385d9c$var$prefixAsString + subject;
}
function $f347e48613385d9c$var$setPrefix(newPrefix) {
    $f347e48613385d9c$var$prefixAsString = newPrefix;
}
var $f347e48613385d9c$var$directiveHandlers = {};
function $f347e48613385d9c$var$directive(name, callback) {
    $f347e48613385d9c$var$directiveHandlers[name] = callback;
    return {
        before (directive2) {
            if (!$f347e48613385d9c$var$directiveHandlers[directive2]) {
                console.warn(String.raw`Cannot find directive \`${directive2}\`. \`${name}\` will use the default order of execution`);
                return;
            }
            const pos = $f347e48613385d9c$var$directiveOrder.indexOf(directive2);
            $f347e48613385d9c$var$directiveOrder.splice(pos >= 0 ? pos : $f347e48613385d9c$var$directiveOrder.indexOf("DEFAULT"), 0, name);
        }
    };
}
function $f347e48613385d9c$var$directiveExists(name) {
    return Object.keys($f347e48613385d9c$var$directiveHandlers).includes(name);
}
function $f347e48613385d9c$var$directives(el, attributes, originalAttributeOverride) {
    attributes = Array.from(attributes);
    if (el._x_virtualDirectives) {
        let vAttributes = Object.entries(el._x_virtualDirectives).map(([name, value])=>({
                name: name,
                value: value
            }));
        let staticAttributes = $f347e48613385d9c$var$attributesOnly(vAttributes);
        vAttributes = vAttributes.map((attribute)=>{
            if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
                name: `x-bind:${attribute.name}`,
                value: `"${attribute.value}"`
            };
            return attribute;
        });
        attributes = attributes.concat(vAttributes);
    }
    let transformedAttributeMap = {};
    let directives2 = attributes.map($f347e48613385d9c$var$toTransformedAttributes((newName, oldName)=>transformedAttributeMap[newName] = oldName)).filter($f347e48613385d9c$var$outNonAlpineAttributes).map($f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride)).sort($f347e48613385d9c$var$byPriority);
    return directives2.map((directive2)=>{
        return $f347e48613385d9c$var$getDirectiveHandler(el, directive2);
    });
}
function $f347e48613385d9c$var$attributesOnly(attributes) {
    return Array.from(attributes).map($f347e48613385d9c$var$toTransformedAttributes()).filter((attr)=>!$f347e48613385d9c$var$outNonAlpineAttributes(attr));
}
var $f347e48613385d9c$var$isDeferringHandlers = false;
var $f347e48613385d9c$var$directiveHandlerStacks = /* @__PURE__ */ new Map();
var $f347e48613385d9c$var$currentHandlerStackKey = Symbol();
function $f347e48613385d9c$var$deferHandlingDirectives(callback) {
    $f347e48613385d9c$var$isDeferringHandlers = true;
    let key = Symbol();
    $f347e48613385d9c$var$currentHandlerStackKey = key;
    $f347e48613385d9c$var$directiveHandlerStacks.set(key, []);
    let flushHandlers = ()=>{
        while($f347e48613385d9c$var$directiveHandlerStacks.get(key).length)$f347e48613385d9c$var$directiveHandlerStacks.get(key).shift()();
        $f347e48613385d9c$var$directiveHandlerStacks.delete(key);
    };
    let stopDeferring = ()=>{
        $f347e48613385d9c$var$isDeferringHandlers = false;
        flushHandlers();
    };
    callback(flushHandlers);
    stopDeferring();
}
function $f347e48613385d9c$var$getElementBoundUtilities(el) {
    let cleanups = [];
    let cleanup2 = (callback)=>cleanups.push(callback);
    let [effect3, cleanupEffect] = $f347e48613385d9c$var$elementBoundEffect(el);
    cleanups.push(cleanupEffect);
    let utilities = {
        Alpine: $f347e48613385d9c$var$alpine_default,
        effect: effect3,
        cleanup: cleanup2,
        evaluateLater: $f347e48613385d9c$var$evaluateLater.bind($f347e48613385d9c$var$evaluateLater, el),
        evaluate: $f347e48613385d9c$var$evaluate.bind($f347e48613385d9c$var$evaluate, el)
    };
    let doCleanup = ()=>cleanups.forEach((i)=>i());
    return [
        utilities,
        doCleanup
    ];
}
function $f347e48613385d9c$var$getDirectiveHandler(el, directive2) {
    let noop = ()=>{};
    let handler4 = $f347e48613385d9c$var$directiveHandlers[directive2.type] || noop;
    let [utilities, cleanup2] = $f347e48613385d9c$var$getElementBoundUtilities(el);
    $f347e48613385d9c$var$onAttributeRemoved(el, directive2.original, cleanup2);
    let fullHandler = ()=>{
        if (el._x_ignore || el._x_ignoreSelf) return;
        handler4.inline && handler4.inline(el, directive2, utilities);
        handler4 = handler4.bind(handler4, el, directive2, utilities);
        $f347e48613385d9c$var$isDeferringHandlers ? $f347e48613385d9c$var$directiveHandlerStacks.get($f347e48613385d9c$var$currentHandlerStackKey).push(handler4) : handler4();
    };
    fullHandler.runCleanups = cleanup2;
    return fullHandler;
}
var $f347e48613385d9c$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
var $f347e48613385d9c$var$into = (i)=>i;
function $f347e48613385d9c$var$toTransformedAttributes(callback = ()=>{}) {
    return ({ name: name, value: value })=>{
        let { name: newName, value: newValue } = $f347e48613385d9c$var$attributeTransformers.reduce((carry, transform)=>{
            return transform(carry);
        }, {
            name: name,
            value: value
        });
        if (newName !== name) callback(newName, name);
        return {
            name: newName,
            value: newValue
        };
    };
}
var $f347e48613385d9c$var$attributeTransformers = [];
function $f347e48613385d9c$var$mapAttributes(callback) {
    $f347e48613385d9c$var$attributeTransformers.push(callback);
}
function $f347e48613385d9c$var$outNonAlpineAttributes({ name: name }) {
    return $f347e48613385d9c$var$alpineAttributeRegex().test(name);
}
var $f347e48613385d9c$var$alpineAttributeRegex = ()=>new RegExp(`^${$f347e48613385d9c$var$prefixAsString}([^:^.]+)\\b`);
function $f347e48613385d9c$var$toParsedDirectives(transformedAttributeMap, originalAttributeOverride) {
    return ({ name: name, value: value })=>{
        let typeMatch = name.match($f347e48613385d9c$var$alpineAttributeRegex());
        let valueMatch = name.match(/:([a-zA-Z0-9\-_:]+)/);
        let modifiers = name.match(/\.[^.\]]+(?=[^\]]*$)/g) || [];
        let original = originalAttributeOverride || transformedAttributeMap[name] || name;
        return {
            type: typeMatch ? typeMatch[1] : null,
            value: valueMatch ? valueMatch[1] : null,
            modifiers: modifiers.map((i)=>i.replace(".", "")),
            expression: value,
            original: original
        };
    };
}
var $f347e48613385d9c$var$DEFAULT = "DEFAULT";
var $f347e48613385d9c$var$directiveOrder = [
    "ignore",
    "ref",
    "data",
    "id",
    "anchor",
    "bind",
    "init",
    "for",
    "model",
    "modelable",
    "transition",
    "show",
    "if",
    $f347e48613385d9c$var$DEFAULT,
    "teleport"
];
function $f347e48613385d9c$var$byPriority(a, b) {
    let typeA = $f347e48613385d9c$var$directiveOrder.indexOf(a.type) === -1 ? $f347e48613385d9c$var$DEFAULT : a.type;
    let typeB = $f347e48613385d9c$var$directiveOrder.indexOf(b.type) === -1 ? $f347e48613385d9c$var$DEFAULT : b.type;
    return $f347e48613385d9c$var$directiveOrder.indexOf(typeA) - $f347e48613385d9c$var$directiveOrder.indexOf(typeB);
}
// packages/alpinejs/src/utils/dispatch.js
function $f347e48613385d9c$var$dispatch(el, name, detail = {}) {
    el.dispatchEvent(new CustomEvent(name, {
        detail: detail,
        bubbles: true,
        // Allows events to pass the shadow DOM barrier.
        composed: true,
        cancelable: true
    }));
}
// packages/alpinejs/src/utils/walk.js
function $f347e48613385d9c$var$walk(el, callback) {
    if (typeof ShadowRoot === "function" && el instanceof ShadowRoot) {
        Array.from(el.children).forEach((el2)=>$f347e48613385d9c$var$walk(el2, callback));
        return;
    }
    let skip = false;
    callback(el, ()=>skip = true);
    if (skip) return;
    let node = el.firstElementChild;
    while(node){
        $f347e48613385d9c$var$walk(node, callback, false);
        node = node.nextElementSibling;
    }
}
// packages/alpinejs/src/utils/warn.js
function $f347e48613385d9c$var$warn(message, ...args) {
    console.warn(`Alpine Warning: ${message}`, ...args);
}
// packages/alpinejs/src/lifecycle.js
var $f347e48613385d9c$var$started = false;
function $f347e48613385d9c$var$start() {
    if ($f347e48613385d9c$var$started) $f347e48613385d9c$var$warn("Alpine has already been initialized on this page. Calling Alpine.start() more than once can cause problems.");
    $f347e48613385d9c$var$started = true;
    if (!document.body) $f347e48613385d9c$var$warn("Unable to initialize. Trying to load Alpine before `<body>` is available. Did you forget to add `defer` in Alpine's `<script>` tag?");
    $f347e48613385d9c$var$dispatch(document, "alpine:init");
    $f347e48613385d9c$var$dispatch(document, "alpine:initializing");
    $f347e48613385d9c$var$startObservingMutations();
    $f347e48613385d9c$var$onElAdded((el)=>$f347e48613385d9c$var$initTree(el, $f347e48613385d9c$var$walk));
    $f347e48613385d9c$var$onElRemoved((el)=>$f347e48613385d9c$var$destroyTree(el));
    $f347e48613385d9c$var$onAttributesAdded((el, attrs)=>{
        $f347e48613385d9c$var$directives(el, attrs).forEach((handle)=>handle());
    });
    let outNestedComponents = (el)=>!$f347e48613385d9c$var$closestRoot(el.parentElement, true);
    Array.from(document.querySelectorAll($f347e48613385d9c$var$allSelectors().join(","))).filter(outNestedComponents).forEach((el)=>{
        $f347e48613385d9c$var$initTree(el);
    });
    $f347e48613385d9c$var$dispatch(document, "alpine:initialized");
    setTimeout(()=>{
        $f347e48613385d9c$var$warnAboutMissingPlugins();
    });
}
var $f347e48613385d9c$var$rootSelectorCallbacks = [];
var $f347e48613385d9c$var$initSelectorCallbacks = [];
function $f347e48613385d9c$var$rootSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.map((fn)=>fn());
}
function $f347e48613385d9c$var$allSelectors() {
    return $f347e48613385d9c$var$rootSelectorCallbacks.concat($f347e48613385d9c$var$initSelectorCallbacks).map((fn)=>fn());
}
function $f347e48613385d9c$var$addRootSelector(selectorCallback) {
    $f347e48613385d9c$var$rootSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$addInitSelector(selectorCallback) {
    $f347e48613385d9c$var$initSelectorCallbacks.push(selectorCallback);
}
function $f347e48613385d9c$var$closestRoot(el, includeInitSelectors = false) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        const selectors = includeInitSelectors ? $f347e48613385d9c$var$allSelectors() : $f347e48613385d9c$var$rootSelectors();
        if (selectors.some((selector)=>element.matches(selector))) return true;
    });
}
function $f347e48613385d9c$var$findClosest(el, callback) {
    if (!el) return;
    if (callback(el)) return el;
    if (el._x_teleportBack) el = el._x_teleportBack;
    if (!el.parentElement) return;
    return $f347e48613385d9c$var$findClosest(el.parentElement, callback);
}
function $f347e48613385d9c$var$isRoot(el) {
    return $f347e48613385d9c$var$rootSelectors().some((selector)=>el.matches(selector));
}
var $f347e48613385d9c$var$initInterceptors2 = [];
function $f347e48613385d9c$var$interceptInit(callback) {
    $f347e48613385d9c$var$initInterceptors2.push(callback);
}
var $f347e48613385d9c$var$markerDispenser = 1;
function $f347e48613385d9c$var$initTree(el, walker = $f347e48613385d9c$var$walk, intercept = ()=>{}) {
    if ($f347e48613385d9c$var$findClosest(el, (i)=>i._x_ignore)) return;
    $f347e48613385d9c$var$deferHandlingDirectives(()=>{
        walker(el, (el2, skip)=>{
            if (el2._x_marker) return;
            intercept(el2, skip);
            $f347e48613385d9c$var$initInterceptors2.forEach((i)=>i(el2, skip));
            $f347e48613385d9c$var$directives(el2, el2.attributes).forEach((handle)=>handle());
            if (!el2._x_ignore) el2._x_marker = $f347e48613385d9c$var$markerDispenser++;
            el2._x_ignore && skip();
        });
    });
}
function $f347e48613385d9c$var$destroyTree(root, walker = $f347e48613385d9c$var$walk) {
    walker(root, (el)=>{
        $f347e48613385d9c$var$cleanupElement(el);
        $f347e48613385d9c$var$cleanupAttributes(el);
        delete el._x_marker;
    });
}
function $f347e48613385d9c$var$warnAboutMissingPlugins() {
    let pluginDirectives = [
        [
            "ui",
            "dialog",
            [
                "[x-dialog], [x-popover]"
            ]
        ],
        [
            "anchor",
            "anchor",
            [
                "[x-anchor]"
            ]
        ],
        [
            "sort",
            "sort",
            [
                "[x-sort]"
            ]
        ]
    ];
    pluginDirectives.forEach(([plugin2, directive2, selectors])=>{
        if ($f347e48613385d9c$var$directiveExists(directive2)) return;
        selectors.some((selector)=>{
            if (document.querySelector(selector)) {
                $f347e48613385d9c$var$warn(`found "${selector}", but missing ${plugin2} plugin`);
                return true;
            }
        });
    });
}
// packages/alpinejs/src/nextTick.js
var $f347e48613385d9c$var$tickStack = [];
var $f347e48613385d9c$var$isHolding = false;
function $f347e48613385d9c$var$nextTick(callback = ()=>{}) {
    queueMicrotask(()=>{
        $f347e48613385d9c$var$isHolding || setTimeout(()=>{
            $f347e48613385d9c$var$releaseNextTicks();
        });
    });
    return new Promise((res)=>{
        $f347e48613385d9c$var$tickStack.push(()=>{
            callback();
            res();
        });
    });
}
function $f347e48613385d9c$var$releaseNextTicks() {
    $f347e48613385d9c$var$isHolding = false;
    while($f347e48613385d9c$var$tickStack.length)$f347e48613385d9c$var$tickStack.shift()();
}
function $f347e48613385d9c$var$holdNextTicks() {
    $f347e48613385d9c$var$isHolding = true;
}
// packages/alpinejs/src/utils/classes.js
function $f347e48613385d9c$var$setClasses(el, value) {
    if (Array.isArray(value)) return $f347e48613385d9c$var$setClassesFromString(el, value.join(" "));
    else if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setClassesFromObject(el, value);
    else if (typeof value === "function") return $f347e48613385d9c$var$setClasses(el, value());
    return $f347e48613385d9c$var$setClassesFromString(el, value);
}
function $f347e48613385d9c$var$setClassesFromString(el, classString) {
    let split = (classString2)=>classString2.split(" ").filter(Boolean);
    let missingClasses = (classString2)=>classString2.split(" ").filter((i)=>!el.classList.contains(i)).filter(Boolean);
    let addClassesAndReturnUndo = (classes)=>{
        el.classList.add(...classes);
        return ()=>{
            el.classList.remove(...classes);
        };
    };
    classString = classString === true ? classString = "" : classString || "";
    return addClassesAndReturnUndo(missingClasses(classString));
}
function $f347e48613385d9c$var$setClassesFromObject(el, classObject) {
    let split = (classString)=>classString.split(" ").filter(Boolean);
    let forAdd = Object.entries(classObject).flatMap(([classString, bool])=>bool ? split(classString) : false).filter(Boolean);
    let forRemove = Object.entries(classObject).flatMap(([classString, bool])=>!bool ? split(classString) : false).filter(Boolean);
    let added = [];
    let removed = [];
    forRemove.forEach((i)=>{
        if (el.classList.contains(i)) {
            el.classList.remove(i);
            removed.push(i);
        }
    });
    forAdd.forEach((i)=>{
        if (!el.classList.contains(i)) {
            el.classList.add(i);
            added.push(i);
        }
    });
    return ()=>{
        removed.forEach((i)=>el.classList.add(i));
        added.forEach((i)=>el.classList.remove(i));
    };
}
// packages/alpinejs/src/utils/styles.js
function $f347e48613385d9c$var$setStyles(el, value) {
    if (typeof value === "object" && value !== null) return $f347e48613385d9c$var$setStylesFromObject(el, value);
    return $f347e48613385d9c$var$setStylesFromString(el, value);
}
function $f347e48613385d9c$var$setStylesFromObject(el, value) {
    let previousStyles = {};
    Object.entries(value).forEach(([key, value2])=>{
        previousStyles[key] = el.style[key];
        if (!key.startsWith("--")) key = $f347e48613385d9c$var$kebabCase(key);
        el.style.setProperty(key, value2);
    });
    setTimeout(()=>{
        if (el.style.length === 0) el.removeAttribute("style");
    });
    return ()=>{
        $f347e48613385d9c$var$setStyles(el, previousStyles);
    };
}
function $f347e48613385d9c$var$setStylesFromString(el, value) {
    let cache = el.getAttribute("style", value);
    el.setAttribute("style", value);
    return ()=>{
        el.setAttribute("style", cache || "");
    };
}
function $f347e48613385d9c$var$kebabCase(subject) {
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
}
// packages/alpinejs/src/utils/once.js
function $f347e48613385d9c$var$once(callback, fallback = ()=>{}) {
    let called = false;
    return function() {
        if (!called) {
            called = true;
            callback.apply(this, arguments);
        } else fallback.apply(this, arguments);
    };
}
// packages/alpinejs/src/directives/x-transition.js
$f347e48613385d9c$var$directive("transition", (el, { value: value, modifiers: modifiers, expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "function") expression = evaluate2(expression);
    if (expression === false) return;
    if (!expression || typeof expression === "boolean") $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, value);
    else $f347e48613385d9c$var$registerTransitionsFromClassString(el, expression, value);
});
function $f347e48613385d9c$var$registerTransitionsFromClassString(el, classString, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setClasses, "");
    let directiveStorageMap = {
        "enter": (classes)=>{
            el._x_transition.enter.during = classes;
        },
        "enter-start": (classes)=>{
            el._x_transition.enter.start = classes;
        },
        "enter-end": (classes)=>{
            el._x_transition.enter.end = classes;
        },
        "leave": (classes)=>{
            el._x_transition.leave.during = classes;
        },
        "leave-start": (classes)=>{
            el._x_transition.leave.start = classes;
        },
        "leave-end": (classes)=>{
            el._x_transition.leave.end = classes;
        }
    };
    directiveStorageMap[stage](classString);
}
function $f347e48613385d9c$var$registerTransitionsFromHelper(el, modifiers, stage) {
    $f347e48613385d9c$var$registerTransitionObject(el, $f347e48613385d9c$var$setStyles);
    let doesntSpecify = !modifiers.includes("in") && !modifiers.includes("out") && !stage;
    let transitioningIn = doesntSpecify || modifiers.includes("in") || [
        "enter"
    ].includes(stage);
    let transitioningOut = doesntSpecify || modifiers.includes("out") || [
        "leave"
    ].includes(stage);
    if (modifiers.includes("in") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index < modifiers.indexOf("out"));
    if (modifiers.includes("out") && !doesntSpecify) modifiers = modifiers.filter((i, index)=>index > modifiers.indexOf("out"));
    let wantsAll = !modifiers.includes("opacity") && !modifiers.includes("scale");
    let wantsOpacity = wantsAll || modifiers.includes("opacity");
    let wantsScale = wantsAll || modifiers.includes("scale");
    let opacityValue = wantsOpacity ? 0 : 1;
    let scaleValue = wantsScale ? $f347e48613385d9c$var$modifierValue(modifiers, "scale", 95) / 100 : 1;
    let delay = $f347e48613385d9c$var$modifierValue(modifiers, "delay", 0) / 1e3;
    let origin = $f347e48613385d9c$var$modifierValue(modifiers, "origin", "center");
    let property = "opacity, transform";
    let durationIn = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 150) / 1e3;
    let durationOut = $f347e48613385d9c$var$modifierValue(modifiers, "duration", 75) / 1e3;
    let easing = `cubic-bezier(0.4, 0.0, 0.2, 1)`;
    if (transitioningIn) {
        el._x_transition.enter.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationIn}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.enter.start = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
        el._x_transition.enter.end = {
            opacity: 1,
            transform: `scale(1)`
        };
    }
    if (transitioningOut) {
        el._x_transition.leave.during = {
            transformOrigin: origin,
            transitionDelay: `${delay}s`,
            transitionProperty: property,
            transitionDuration: `${durationOut}s`,
            transitionTimingFunction: easing
        };
        el._x_transition.leave.start = {
            opacity: 1,
            transform: `scale(1)`
        };
        el._x_transition.leave.end = {
            opacity: opacityValue,
            transform: `scale(${scaleValue})`
        };
    }
}
function $f347e48613385d9c$var$registerTransitionObject(el, setFunction, defaultValue = {}) {
    if (!el._x_transition) el._x_transition = {
        enter: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        leave: {
            during: defaultValue,
            start: defaultValue,
            end: defaultValue
        },
        in (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.enter.during,
                start: this.enter.start,
                end: this.enter.end
            }, before, after);
        },
        out (before = ()=>{}, after = ()=>{}) {
            $f347e48613385d9c$var$transition(el, setFunction, {
                during: this.leave.during,
                start: this.leave.start,
                end: this.leave.end
            }, before, after);
        }
    };
}
window.Element.prototype._x_toggleAndCascadeWithTransitions = function(el, value, show, hide) {
    const nextTick2 = document.visibilityState === "visible" ? requestAnimationFrame : setTimeout;
    let clickAwayCompatibleShow = ()=>nextTick2(show);
    if (value) {
        if (el._x_transition && (el._x_transition.enter || el._x_transition.leave)) el._x_transition.enter && (Object.entries(el._x_transition.enter.during).length || Object.entries(el._x_transition.enter.start).length || Object.entries(el._x_transition.enter.end).length) ? el._x_transition.in(show) : clickAwayCompatibleShow();
        else el._x_transition ? el._x_transition.in(show) : clickAwayCompatibleShow();
        return;
    }
    el._x_hidePromise = el._x_transition ? new Promise((resolve, reject)=>{
        el._x_transition.out(()=>{}, ()=>resolve(hide));
        el._x_transitioning && el._x_transitioning.beforeCancel(()=>reject({
                isFromCancelledTransition: true
            }));
    }) : Promise.resolve(hide);
    queueMicrotask(()=>{
        let closest = $f347e48613385d9c$var$closestHide(el);
        if (closest) {
            if (!closest._x_hideChildren) closest._x_hideChildren = [];
            closest._x_hideChildren.push(el);
        } else nextTick2(()=>{
            let hideAfterChildren = (el2)=>{
                let carry = Promise.all([
                    el2._x_hidePromise,
                    ...(el2._x_hideChildren || []).map(hideAfterChildren)
                ]).then(([i])=>i?.());
                delete el2._x_hidePromise;
                delete el2._x_hideChildren;
                return carry;
            };
            hideAfterChildren(el).catch((e)=>{
                if (!e.isFromCancelledTransition) throw e;
            });
        });
    });
};
function $f347e48613385d9c$var$closestHide(el) {
    let parent = el.parentNode;
    if (!parent) return;
    return parent._x_hidePromise ? parent : $f347e48613385d9c$var$closestHide(parent);
}
function $f347e48613385d9c$var$transition(el, setFunction, { during: during, start: start2, end: end } = {}, before = ()=>{}, after = ()=>{}) {
    if (el._x_transitioning) el._x_transitioning.cancel();
    if (Object.keys(during).length === 0 && Object.keys(start2).length === 0 && Object.keys(end).length === 0) {
        before();
        after();
        return;
    }
    let undoStart, undoDuring, undoEnd;
    $f347e48613385d9c$var$performTransition(el, {
        start () {
            undoStart = setFunction(el, start2);
        },
        during () {
            undoDuring = setFunction(el, during);
        },
        before: before,
        end () {
            undoStart();
            undoEnd = setFunction(el, end);
        },
        after: after,
        cleanup () {
            undoDuring();
            undoEnd();
        }
    });
}
function $f347e48613385d9c$var$performTransition(el, stages) {
    let interrupted, reachedBefore, reachedEnd;
    let finish = $f347e48613385d9c$var$once(()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            interrupted = true;
            if (!reachedBefore) stages.before();
            if (!reachedEnd) {
                stages.end();
                $f347e48613385d9c$var$releaseNextTicks();
            }
            stages.after();
            if (el.isConnected) stages.cleanup();
            delete el._x_transitioning;
        });
    });
    el._x_transitioning = {
        beforeCancels: [],
        beforeCancel (callback) {
            this.beforeCancels.push(callback);
        },
        cancel: $f347e48613385d9c$var$once(function() {
            while(this.beforeCancels.length)this.beforeCancels.shift()();
            finish();
        }),
        finish: finish
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        stages.start();
        stages.during();
    });
    $f347e48613385d9c$var$holdNextTicks();
    requestAnimationFrame(()=>{
        if (interrupted) return;
        let duration = Number(getComputedStyle(el).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3;
        let delay = Number(getComputedStyle(el).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
        if (duration === 0) duration = Number(getComputedStyle(el).animationDuration.replace("s", "")) * 1e3;
        $f347e48613385d9c$var$mutateDom(()=>{
            stages.before();
        });
        reachedBefore = true;
        requestAnimationFrame(()=>{
            if (interrupted) return;
            $f347e48613385d9c$var$mutateDom(()=>{
                stages.end();
            });
            $f347e48613385d9c$var$releaseNextTicks();
            setTimeout(el._x_transitioning.finish, duration + delay);
            reachedEnd = true;
        });
    });
}
function $f347e48613385d9c$var$modifierValue(modifiers, key, fallback) {
    if (modifiers.indexOf(key) === -1) return fallback;
    const rawValue = modifiers[modifiers.indexOf(key) + 1];
    if (!rawValue) return fallback;
    if (key === "scale") {
        if (isNaN(rawValue)) return fallback;
    }
    if (key === "duration" || key === "delay") {
        let match = rawValue.match(/([0-9]+)ms/);
        if (match) return match[1];
    }
    if (key === "origin") {
        if ([
            "top",
            "right",
            "left",
            "center",
            "bottom"
        ].includes(modifiers[modifiers.indexOf(key) + 2])) return [
            rawValue,
            modifiers[modifiers.indexOf(key) + 2]
        ].join(" ");
    }
    return rawValue;
}
// packages/alpinejs/src/clone.js
var $f347e48613385d9c$var$isCloning = false;
function $f347e48613385d9c$var$skipDuringClone(callback, fallback = ()=>{}) {
    return (...args)=>$f347e48613385d9c$var$isCloning ? fallback(...args) : callback(...args);
}
function $f347e48613385d9c$var$onlyDuringClone(callback) {
    return (...args)=>$f347e48613385d9c$var$isCloning && callback(...args);
}
var $f347e48613385d9c$var$interceptors = [];
function $f347e48613385d9c$var$interceptClone(callback) {
    $f347e48613385d9c$var$interceptors.push(callback);
}
function $f347e48613385d9c$var$cloneNode(from, to) {
    $f347e48613385d9c$var$interceptors.forEach((i)=>i(from, to));
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$initTree(to, (el, callback)=>{
            callback(el, ()=>{});
        });
    });
    $f347e48613385d9c$var$isCloning = false;
}
var $f347e48613385d9c$var$isCloningLegacy = false;
function $f347e48613385d9c$var$clone(oldEl, newEl) {
    if (!newEl._x_dataStack) newEl._x_dataStack = oldEl._x_dataStack;
    $f347e48613385d9c$var$isCloning = true;
    $f347e48613385d9c$var$isCloningLegacy = true;
    $f347e48613385d9c$var$dontRegisterReactiveSideEffects(()=>{
        $f347e48613385d9c$var$cloneTree(newEl);
    });
    $f347e48613385d9c$var$isCloning = false;
    $f347e48613385d9c$var$isCloningLegacy = false;
}
function $f347e48613385d9c$var$cloneTree(el) {
    let hasRunThroughFirstEl = false;
    let shallowWalker = (el2, callback)=>{
        $f347e48613385d9c$var$walk(el2, (el3, skip)=>{
            if (hasRunThroughFirstEl && $f347e48613385d9c$var$isRoot(el3)) return skip();
            hasRunThroughFirstEl = true;
            callback(el3, skip);
        });
    };
    $f347e48613385d9c$var$initTree(el, shallowWalker);
}
function $f347e48613385d9c$var$dontRegisterReactiveSideEffects(callback) {
    let cache = $f347e48613385d9c$var$effect;
    $f347e48613385d9c$var$overrideEffect((callback2, el)=>{
        let storedEffect = cache(callback2);
        $f347e48613385d9c$var$release(storedEffect);
        return ()=>{};
    });
    callback();
    $f347e48613385d9c$var$overrideEffect(cache);
}
// packages/alpinejs/src/utils/bind.js
function $f347e48613385d9c$var$bind(el, name, value, modifiers = []) {
    if (!el._x_bindings) el._x_bindings = $f347e48613385d9c$var$reactive({});
    el._x_bindings[name] = value;
    name = modifiers.includes("camel") ? $f347e48613385d9c$var$camelCase(name) : name;
    switch(name){
        case "value":
            $f347e48613385d9c$var$bindInputValue(el, value);
            break;
        case "style":
            $f347e48613385d9c$var$bindStyles(el, value);
            break;
        case "class":
            $f347e48613385d9c$var$bindClasses(el, value);
            break;
        case "selected":
        case "checked":
            $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value);
            break;
        default:
            $f347e48613385d9c$var$bindAttribute(el, name, value);
            break;
    }
}
function $f347e48613385d9c$var$bindInputValue(el, value) {
    if ($f347e48613385d9c$var$isRadio(el)) {
        if (el.attributes.value === void 0) el.value = value;
        if (window.fromModel) {
            if (typeof value === "boolean") el.checked = $f347e48613385d9c$var$safeParseBoolean(el.value) === value;
            else el.checked = $f347e48613385d9c$var$checkedAttrLooseCompare(el.value, value);
        }
    } else if ($f347e48613385d9c$var$isCheckbox(el)) {
        if (Number.isInteger(value)) el.value = value;
        else if (!Array.isArray(value) && typeof value !== "boolean" && ![
            null,
            void 0
        ].includes(value)) el.value = String(value);
        else if (Array.isArray(value)) el.checked = value.some((val)=>$f347e48613385d9c$var$checkedAttrLooseCompare(val, el.value));
        else el.checked = !!value;
    } else if (el.tagName === "SELECT") $f347e48613385d9c$var$updateSelect(el, value);
    else {
        if (el.value === value) return;
        el.value = value === void 0 ? "" : value;
    }
}
function $f347e48613385d9c$var$bindClasses(el, value) {
    if (el._x_undoAddedClasses) el._x_undoAddedClasses();
    el._x_undoAddedClasses = $f347e48613385d9c$var$setClasses(el, value);
}
function $f347e48613385d9c$var$bindStyles(el, value) {
    if (el._x_undoAddedStyles) el._x_undoAddedStyles();
    el._x_undoAddedStyles = $f347e48613385d9c$var$setStyles(el, value);
}
function $f347e48613385d9c$var$bindAttributeAndProperty(el, name, value) {
    $f347e48613385d9c$var$bindAttribute(el, name, value);
    $f347e48613385d9c$var$setPropertyIfChanged(el, name, value);
}
function $f347e48613385d9c$var$bindAttribute(el, name, value) {
    if ([
        null,
        void 0,
        false
    ].includes(value) && $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name)) el.removeAttribute(name);
    else {
        if ($f347e48613385d9c$var$isBooleanAttr(name)) value = name;
        $f347e48613385d9c$var$setIfChanged(el, name, value);
    }
}
function $f347e48613385d9c$var$setIfChanged(el, attrName, value) {
    if (el.getAttribute(attrName) != value) el.setAttribute(attrName, value);
}
function $f347e48613385d9c$var$setPropertyIfChanged(el, propName, value) {
    if (el[propName] !== value) el[propName] = value;
}
function $f347e48613385d9c$var$updateSelect(el, value) {
    const arrayWrappedValue = [].concat(value).map((value2)=>{
        return value2 + "";
    });
    Array.from(el.options).forEach((option)=>{
        option.selected = arrayWrappedValue.includes(option.value);
    });
}
function $f347e48613385d9c$var$camelCase(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$checkedAttrLooseCompare(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$safeParseBoolean(rawValue) {
    if ([
        1,
        "1",
        "true",
        "on",
        "yes",
        true
    ].includes(rawValue)) return true;
    if ([
        0,
        "0",
        "false",
        "off",
        "no",
        false
    ].includes(rawValue)) return false;
    return rawValue ? Boolean(rawValue) : null;
}
var $f347e48613385d9c$var$booleanAttributes = /* @__PURE__ */ new Set([
    "allowfullscreen",
    "async",
    "autofocus",
    "autoplay",
    "checked",
    "controls",
    "default",
    "defer",
    "disabled",
    "formnovalidate",
    "inert",
    "ismap",
    "itemscope",
    "loop",
    "multiple",
    "muted",
    "nomodule",
    "novalidate",
    "open",
    "playsinline",
    "readonly",
    "required",
    "reversed",
    "selected",
    "shadowrootclonable",
    "shadowrootdelegatesfocus",
    "shadowrootserializable"
]);
function $f347e48613385d9c$var$isBooleanAttr(attrName) {
    return $f347e48613385d9c$var$booleanAttributes.has(attrName);
}
function $f347e48613385d9c$var$attributeShouldntBePreservedIfFalsy(name) {
    return ![
        "aria-pressed",
        "aria-checked",
        "aria-expanded",
        "aria-selected"
    ].includes(name);
}
function $f347e48613385d9c$var$getBinding(el, name, fallback) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$extractProp(el, name, fallback, extract = true) {
    if (el._x_bindings && el._x_bindings[name] !== void 0) return el._x_bindings[name];
    if (el._x_inlineBindings && el._x_inlineBindings[name] !== void 0) {
        let binding = el._x_inlineBindings[name];
        binding.extract = extract;
        return $f347e48613385d9c$var$dontAutoEvaluateFunctions(()=>{
            return $f347e48613385d9c$var$evaluate(el, binding.expression);
        });
    }
    return $f347e48613385d9c$var$getAttributeBinding(el, name, fallback);
}
function $f347e48613385d9c$var$getAttributeBinding(el, name, fallback) {
    let attr = el.getAttribute(name);
    if (attr === null) return typeof fallback === "function" ? fallback() : fallback;
    if (attr === "") return true;
    if ($f347e48613385d9c$var$isBooleanAttr(name)) return !![
        name,
        "true"
    ].includes(attr);
    return attr;
}
function $f347e48613385d9c$var$isCheckbox(el) {
    return el.type === "checkbox" || el.localName === "ui-checkbox" || el.localName === "ui-switch";
}
function $f347e48613385d9c$var$isRadio(el) {
    return el.type === "radio" || el.localName === "ui-radio";
}
// packages/alpinejs/src/utils/debounce.js
function $f347e48613385d9c$var$debounce(func, wait) {
    let timeout;
    return function() {
        const context = this, args = arguments;
        const later = function() {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}
// packages/alpinejs/src/utils/throttle.js
function $f347e48613385d9c$var$throttle(func, limit) {
    let inThrottle;
    return function() {
        let context = this, args = arguments;
        if (!inThrottle) {
            func.apply(context, args);
            inThrottle = true;
            setTimeout(()=>inThrottle = false, limit);
        }
    };
}
// packages/alpinejs/src/entangle.js
function $f347e48613385d9c$var$entangle({ get: outerGet, set: outerSet }, { get: innerGet, set: innerSet }) {
    let firstRun = true;
    let outerHash;
    let innerHash;
    let reference = $f347e48613385d9c$var$effect(()=>{
        let outer = outerGet();
        let inner = innerGet();
        if (firstRun) {
            innerSet($f347e48613385d9c$var$cloneIfObject(outer));
            firstRun = false;
        } else {
            let outerHashLatest = JSON.stringify(outer);
            let innerHashLatest = JSON.stringify(inner);
            if (outerHashLatest !== outerHash) innerSet($f347e48613385d9c$var$cloneIfObject(outer));
            else if (outerHashLatest !== innerHashLatest) outerSet($f347e48613385d9c$var$cloneIfObject(inner));
        }
        outerHash = JSON.stringify(outerGet());
        innerHash = JSON.stringify(innerGet());
    });
    return ()=>{
        $f347e48613385d9c$var$release(reference);
    };
}
function $f347e48613385d9c$var$cloneIfObject(value) {
    return typeof value === "object" ? JSON.parse(JSON.stringify(value)) : value;
}
// packages/alpinejs/src/plugin.js
function $f347e48613385d9c$var$plugin(callback) {
    let callbacks = Array.isArray(callback) ? callback : [
        callback
    ];
    callbacks.forEach((i)=>i($f347e48613385d9c$var$alpine_default));
}
// packages/alpinejs/src/store.js
var $f347e48613385d9c$var$stores = {};
var $f347e48613385d9c$var$isReactive = false;
function $f347e48613385d9c$var$store(name, value) {
    if (!$f347e48613385d9c$var$isReactive) {
        $f347e48613385d9c$var$stores = $f347e48613385d9c$var$reactive($f347e48613385d9c$var$stores);
        $f347e48613385d9c$var$isReactive = true;
    }
    if (value === void 0) return $f347e48613385d9c$var$stores[name];
    $f347e48613385d9c$var$stores[name] = value;
    $f347e48613385d9c$var$initInterceptors($f347e48613385d9c$var$stores[name]);
    if (typeof value === "object" && value !== null && value.hasOwnProperty("init") && typeof value.init === "function") $f347e48613385d9c$var$stores[name].init();
}
function $f347e48613385d9c$var$getStores() {
    return $f347e48613385d9c$var$stores;
}
// packages/alpinejs/src/binds.js
var $f347e48613385d9c$var$binds = {};
function $f347e48613385d9c$var$bind2(name, bindings) {
    let getBindings = typeof bindings !== "function" ? ()=>bindings : bindings;
    if (name instanceof Element) return $f347e48613385d9c$var$applyBindingsObject(name, getBindings());
    else $f347e48613385d9c$var$binds[name] = getBindings;
    return ()=>{};
}
function $f347e48613385d9c$var$injectBindingProviders(obj) {
    Object.entries($f347e48613385d9c$var$binds).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback(...args);
                };
            }
        });
    });
    return obj;
}
function $f347e48613385d9c$var$applyBindingsObject(el, obj, original) {
    let cleanupRunners = [];
    while(cleanupRunners.length)cleanupRunners.pop()();
    let attributes = Object.entries(obj).map(([name, value])=>({
            name: name,
            value: value
        }));
    let staticAttributes = $f347e48613385d9c$var$attributesOnly(attributes);
    attributes = attributes.map((attribute)=>{
        if (staticAttributes.find((attr)=>attr.name === attribute.name)) return {
            name: `x-bind:${attribute.name}`,
            value: `"${attribute.value}"`
        };
        return attribute;
    });
    $f347e48613385d9c$var$directives(el, attributes, original).map((handle)=>{
        cleanupRunners.push(handle.runCleanups);
        handle();
    });
    return ()=>{
        while(cleanupRunners.length)cleanupRunners.pop()();
    };
}
// packages/alpinejs/src/datas.js
var $f347e48613385d9c$var$datas = {};
function $f347e48613385d9c$var$data(name, callback) {
    $f347e48613385d9c$var$datas[name] = callback;
}
function $f347e48613385d9c$var$injectDataProviders(obj, context) {
    Object.entries($f347e48613385d9c$var$datas).forEach(([name, callback])=>{
        Object.defineProperty(obj, name, {
            get () {
                return (...args)=>{
                    return callback.bind(context)(...args);
                };
            },
            enumerable: false
        });
    });
    return obj;
}
// packages/alpinejs/src/alpine.js
var $f347e48613385d9c$var$Alpine = {
    get reactive () {
        return $f347e48613385d9c$var$reactive;
    },
    get release () {
        return $f347e48613385d9c$var$release;
    },
    get effect () {
        return $f347e48613385d9c$var$effect;
    },
    get raw () {
        return $f347e48613385d9c$var$raw;
    },
    version: "3.15.0",
    flushAndStopDeferringMutations: $f347e48613385d9c$var$flushAndStopDeferringMutations,
    dontAutoEvaluateFunctions: $f347e48613385d9c$var$dontAutoEvaluateFunctions,
    disableEffectScheduling: $f347e48613385d9c$var$disableEffectScheduling,
    startObservingMutations: $f347e48613385d9c$var$startObservingMutations,
    stopObservingMutations: $f347e48613385d9c$var$stopObservingMutations,
    setReactivityEngine: $f347e48613385d9c$var$setReactivityEngine,
    onAttributeRemoved: $f347e48613385d9c$var$onAttributeRemoved,
    onAttributesAdded: $f347e48613385d9c$var$onAttributesAdded,
    closestDataStack: $f347e48613385d9c$var$closestDataStack,
    skipDuringClone: $f347e48613385d9c$var$skipDuringClone,
    onlyDuringClone: $f347e48613385d9c$var$onlyDuringClone,
    addRootSelector: $f347e48613385d9c$var$addRootSelector,
    addInitSelector: $f347e48613385d9c$var$addInitSelector,
    interceptClone: $f347e48613385d9c$var$interceptClone,
    addScopeToNode: $f347e48613385d9c$var$addScopeToNode,
    deferMutations: $f347e48613385d9c$var$deferMutations,
    mapAttributes: $f347e48613385d9c$var$mapAttributes,
    evaluateLater: $f347e48613385d9c$var$evaluateLater,
    interceptInit: $f347e48613385d9c$var$interceptInit,
    setEvaluator: $f347e48613385d9c$var$setEvaluator,
    mergeProxies: $f347e48613385d9c$var$mergeProxies,
    extractProp: $f347e48613385d9c$var$extractProp,
    findClosest: $f347e48613385d9c$var$findClosest,
    onElRemoved: $f347e48613385d9c$var$onElRemoved,
    closestRoot: $f347e48613385d9c$var$closestRoot,
    destroyTree: $f347e48613385d9c$var$destroyTree,
    interceptor: $f347e48613385d9c$var$interceptor,
    transition: // INTERNAL: not public API and is subject to change without major release.
    $f347e48613385d9c$var$transition,
    setStyles: // INTERNAL
    $f347e48613385d9c$var$setStyles,
    mutateDom: // INTERNAL
    $f347e48613385d9c$var$mutateDom,
    directive: $f347e48613385d9c$var$directive,
    entangle: $f347e48613385d9c$var$entangle,
    throttle: $f347e48613385d9c$var$throttle,
    debounce: $f347e48613385d9c$var$debounce,
    evaluate: $f347e48613385d9c$var$evaluate,
    initTree: $f347e48613385d9c$var$initTree,
    nextTick: $f347e48613385d9c$var$nextTick,
    prefixed: $f347e48613385d9c$var$prefix,
    prefix: $f347e48613385d9c$var$setPrefix,
    plugin: $f347e48613385d9c$var$plugin,
    magic: $f347e48613385d9c$var$magic,
    store: $f347e48613385d9c$var$store,
    start: $f347e48613385d9c$var$start,
    clone: $f347e48613385d9c$var$clone,
    cloneNode: // INTERNAL
    $f347e48613385d9c$var$cloneNode,
    // INTERNAL
    bound: $f347e48613385d9c$var$getBinding,
    $data: $f347e48613385d9c$var$scope,
    watch: $f347e48613385d9c$var$watch,
    walk: $f347e48613385d9c$var$walk,
    data: $f347e48613385d9c$var$data,
    bind: $f347e48613385d9c$var$bind2
};
var $f347e48613385d9c$var$alpine_default = $f347e48613385d9c$var$Alpine;
// node_modules/@vue/shared/dist/shared.esm-bundler.js
function $f347e48613385d9c$var$makeMap(str, expectsLowerCase) {
    const map = /* @__PURE__ */ Object.create(null);
    const list = str.split(",");
    for(let i = 0; i < list.length; i++)map[list[i]] = true;
    return expectsLowerCase ? (val)=>!!map[val.toLowerCase()] : (val)=>!!map[val];
}
var $f347e48613385d9c$var$specialBooleanAttrs = `itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly`;
var $f347e48613385d9c$var$isBooleanAttr2 = /* @__PURE__ */ $f347e48613385d9c$var$makeMap($f347e48613385d9c$var$specialBooleanAttrs + `,async,autofocus,autoplay,controls,default,defer,disabled,hidden,loop,open,required,reversed,scoped,seamless,checked,muted,multiple,selected`);
var $f347e48613385d9c$var$EMPTY_OBJ = Object.freeze({});
var $f347e48613385d9c$var$EMPTY_ARR = Object.freeze([]);
var $f347e48613385d9c$var$hasOwnProperty = Object.prototype.hasOwnProperty;
var $f347e48613385d9c$var$hasOwn = (val, key)=>$f347e48613385d9c$var$hasOwnProperty.call(val, key);
var $f347e48613385d9c$var$isArray = Array.isArray;
var $f347e48613385d9c$var$isMap = (val)=>$f347e48613385d9c$var$toTypeString(val) === "[object Map]";
var $f347e48613385d9c$var$isString = (val)=>typeof val === "string";
var $f347e48613385d9c$var$isSymbol = (val)=>typeof val === "symbol";
var $f347e48613385d9c$var$isObject = (val)=>val !== null && typeof val === "object";
var $f347e48613385d9c$var$objectToString = Object.prototype.toString;
var $f347e48613385d9c$var$toTypeString = (value)=>$f347e48613385d9c$var$objectToString.call(value);
var $f347e48613385d9c$var$toRawType = (value)=>{
    return $f347e48613385d9c$var$toTypeString(value).slice(8, -1);
};
var $f347e48613385d9c$var$isIntegerKey = (key)=>$f347e48613385d9c$var$isString(key) && key !== "NaN" && key[0] !== "-" && "" + parseInt(key, 10) === key;
var $f347e48613385d9c$var$cacheStringFunction = (fn)=>{
    const cache = /* @__PURE__ */ Object.create(null);
    return (str)=>{
        const hit = cache[str];
        return hit || (cache[str] = fn(str));
    };
};
var $f347e48613385d9c$var$camelizeRE = /-(\w)/g;
var $f347e48613385d9c$var$camelize = $f347e48613385d9c$var$cacheStringFunction((str)=>{
    return str.replace($f347e48613385d9c$var$camelizeRE, (_, c)=>c ? c.toUpperCase() : "");
});
var $f347e48613385d9c$var$hyphenateRE = /\B([A-Z])/g;
var $f347e48613385d9c$var$hyphenate = $f347e48613385d9c$var$cacheStringFunction((str)=>str.replace($f347e48613385d9c$var$hyphenateRE, "-$1").toLowerCase());
var $f347e48613385d9c$var$capitalize = $f347e48613385d9c$var$cacheStringFunction((str)=>str.charAt(0).toUpperCase() + str.slice(1));
var $f347e48613385d9c$var$toHandlerKey = $f347e48613385d9c$var$cacheStringFunction((str)=>str ? `on${$f347e48613385d9c$var$capitalize(str)}` : ``);
var $f347e48613385d9c$var$hasChanged = (value, oldValue)=>value !== oldValue && (value === value || oldValue === oldValue);
// node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js
var $f347e48613385d9c$var$targetMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$effectStack = [];
var $f347e48613385d9c$var$activeEffect;
var $f347e48613385d9c$var$ITERATE_KEY = Symbol("iterate");
var $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY = Symbol("Map key iterate");
function $f347e48613385d9c$var$isEffect(fn) {
    return fn && fn._isEffect === true;
}
function $f347e48613385d9c$var$effect2(fn, options = $f347e48613385d9c$var$EMPTY_OBJ) {
    if ($f347e48613385d9c$var$isEffect(fn)) fn = fn.raw;
    const effect3 = $f347e48613385d9c$var$createReactiveEffect(fn, options);
    if (!options.lazy) effect3();
    return effect3;
}
function $f347e48613385d9c$var$stop(effect3) {
    if (effect3.active) {
        $f347e48613385d9c$var$cleanup(effect3);
        if (effect3.options.onStop) effect3.options.onStop();
        effect3.active = false;
    }
}
var $f347e48613385d9c$var$uid = 0;
function $f347e48613385d9c$var$createReactiveEffect(fn, options) {
    const effect3 = function reactiveEffect() {
        if (!effect3.active) return fn();
        if (!$f347e48613385d9c$var$effectStack.includes(effect3)) {
            $f347e48613385d9c$var$cleanup(effect3);
            try {
                $f347e48613385d9c$var$enableTracking();
                $f347e48613385d9c$var$effectStack.push(effect3);
                $f347e48613385d9c$var$activeEffect = effect3;
                return fn();
            } finally{
                $f347e48613385d9c$var$effectStack.pop();
                $f347e48613385d9c$var$resetTracking();
                $f347e48613385d9c$var$activeEffect = $f347e48613385d9c$var$effectStack[$f347e48613385d9c$var$effectStack.length - 1];
            }
        }
    };
    effect3.id = $f347e48613385d9c$var$uid++;
    effect3.allowRecurse = !!options.allowRecurse;
    effect3._isEffect = true;
    effect3.active = true;
    effect3.raw = fn;
    effect3.deps = [];
    effect3.options = options;
    return effect3;
}
function $f347e48613385d9c$var$cleanup(effect3) {
    const { deps: deps } = effect3;
    if (deps.length) {
        for(let i = 0; i < deps.length; i++)deps[i].delete(effect3);
        deps.length = 0;
    }
}
var $f347e48613385d9c$var$shouldTrack = true;
var $f347e48613385d9c$var$trackStack = [];
function $f347e48613385d9c$var$pauseTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = false;
}
function $f347e48613385d9c$var$enableTracking() {
    $f347e48613385d9c$var$trackStack.push($f347e48613385d9c$var$shouldTrack);
    $f347e48613385d9c$var$shouldTrack = true;
}
function $f347e48613385d9c$var$resetTracking() {
    const last = $f347e48613385d9c$var$trackStack.pop();
    $f347e48613385d9c$var$shouldTrack = last === void 0 ? true : last;
}
function $f347e48613385d9c$var$track(target, type, key) {
    if (!$f347e48613385d9c$var$shouldTrack || $f347e48613385d9c$var$activeEffect === void 0) return;
    let depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) $f347e48613385d9c$var$targetMap.set(target, depsMap = /* @__PURE__ */ new Map());
    let dep = depsMap.get(key);
    if (!dep) depsMap.set(key, dep = /* @__PURE__ */ new Set());
    if (!dep.has($f347e48613385d9c$var$activeEffect)) {
        dep.add($f347e48613385d9c$var$activeEffect);
        $f347e48613385d9c$var$activeEffect.deps.push(dep);
        if ($f347e48613385d9c$var$activeEffect.options.onTrack) $f347e48613385d9c$var$activeEffect.options.onTrack({
            effect: $f347e48613385d9c$var$activeEffect,
            target: target,
            type: type,
            key: key
        });
    }
}
function $f347e48613385d9c$var$trigger(target, type, key, newValue, oldValue, oldTarget) {
    const depsMap = $f347e48613385d9c$var$targetMap.get(target);
    if (!depsMap) return;
    const effects = /* @__PURE__ */ new Set();
    const add2 = (effectsToAdd)=>{
        if (effectsToAdd) effectsToAdd.forEach((effect3)=>{
            if (effect3 !== $f347e48613385d9c$var$activeEffect || effect3.allowRecurse) effects.add(effect3);
        });
    };
    if (type === "clear") depsMap.forEach(add2);
    else if (key === "length" && $f347e48613385d9c$var$isArray(target)) depsMap.forEach((dep, key2)=>{
        if (key2 === "length" || key2 >= newValue) add2(dep);
    });
    else {
        if (key !== void 0) add2(depsMap.get(key));
        switch(type){
            case "add":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                } else if ($f347e48613385d9c$var$isIntegerKey(key)) add2(depsMap.get("length"));
                break;
            case "delete":
                if (!$f347e48613385d9c$var$isArray(target)) {
                    add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                    if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$MAP_KEY_ITERATE_KEY));
                }
                break;
            case "set":
                if ($f347e48613385d9c$var$isMap(target)) add2(depsMap.get($f347e48613385d9c$var$ITERATE_KEY));
                break;
        }
    }
    const run = (effect3)=>{
        if (effect3.options.onTrigger) effect3.options.onTrigger({
            effect: effect3,
            target: target,
            key: key,
            type: type,
            newValue: newValue,
            oldValue: oldValue,
            oldTarget: oldTarget
        });
        if (effect3.options.scheduler) effect3.options.scheduler(effect3);
        else effect3();
    };
    effects.forEach(run);
}
var $f347e48613385d9c$var$isNonTrackableKeys = /* @__PURE__ */ $f347e48613385d9c$var$makeMap(`__proto__,__v_isRef,__isVue`);
var $f347e48613385d9c$var$builtInSymbols = new Set(Object.getOwnPropertyNames(Symbol).map((key)=>Symbol[key]).filter($f347e48613385d9c$var$isSymbol));
var $f347e48613385d9c$var$get2 = /* @__PURE__ */ $f347e48613385d9c$var$createGetter();
var $f347e48613385d9c$var$readonlyGet = /* @__PURE__ */ $f347e48613385d9c$var$createGetter(true);
var $f347e48613385d9c$var$arrayInstrumentations = /* @__PURE__ */ $f347e48613385d9c$var$createArrayInstrumentations();
function $f347e48613385d9c$var$createArrayInstrumentations() {
    const instrumentations = {};
    [
        "includes",
        "indexOf",
        "lastIndexOf"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            const arr = $f347e48613385d9c$var$toRaw(this);
            for(let i = 0, l = this.length; i < l; i++)$f347e48613385d9c$var$track(arr, "get", i + "");
            const res = arr[key](...args);
            if (res === -1 || res === false) return arr[key](...args.map($f347e48613385d9c$var$toRaw));
            else return res;
        };
    });
    [
        "push",
        "pop",
        "shift",
        "unshift",
        "splice"
    ].forEach((key)=>{
        instrumentations[key] = function(...args) {
            $f347e48613385d9c$var$pauseTracking();
            const res = $f347e48613385d9c$var$toRaw(this)[key].apply(this, args);
            $f347e48613385d9c$var$resetTracking();
            return res;
        };
    });
    return instrumentations;
}
function $f347e48613385d9c$var$createGetter(isReadonly = false, shallow = false) {
    return function get3(target, key, receiver) {
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw" && receiver === (isReadonly ? shallow ? $f347e48613385d9c$var$shallowReadonlyMap : $f347e48613385d9c$var$readonlyMap : shallow ? $f347e48613385d9c$var$shallowReactiveMap : $f347e48613385d9c$var$reactiveMap).get(target)) return target;
        const targetIsArray = $f347e48613385d9c$var$isArray(target);
        if (!isReadonly && targetIsArray && $f347e48613385d9c$var$hasOwn($f347e48613385d9c$var$arrayInstrumentations, key)) return Reflect.get($f347e48613385d9c$var$arrayInstrumentations, key, receiver);
        const res = Reflect.get(target, key, receiver);
        if ($f347e48613385d9c$var$isSymbol(key) ? $f347e48613385d9c$var$builtInSymbols.has(key) : $f347e48613385d9c$var$isNonTrackableKeys(key)) return res;
        if (!isReadonly) $f347e48613385d9c$var$track(target, "get", key);
        if (shallow) return res;
        if ($f347e48613385d9c$var$isRef(res)) {
            const shouldUnwrap = !targetIsArray || !$f347e48613385d9c$var$isIntegerKey(key);
            return shouldUnwrap ? res.value : res;
        }
        if ($f347e48613385d9c$var$isObject(res)) return isReadonly ? $f347e48613385d9c$var$readonly(res) : $f347e48613385d9c$var$reactive2(res);
        return res;
    };
}
var $f347e48613385d9c$var$set2 = /* @__PURE__ */ $f347e48613385d9c$var$createSetter();
function $f347e48613385d9c$var$createSetter(shallow = false) {
    return function set3(target, key, value, receiver) {
        let oldValue = target[key];
        if (!shallow) {
            value = $f347e48613385d9c$var$toRaw(value);
            oldValue = $f347e48613385d9c$var$toRaw(oldValue);
            if (!$f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isRef(oldValue) && !$f347e48613385d9c$var$isRef(value)) {
                oldValue.value = value;
                return true;
            }
        }
        const hadKey = $f347e48613385d9c$var$isArray(target) && $f347e48613385d9c$var$isIntegerKey(key) ? Number(key) < target.length : $f347e48613385d9c$var$hasOwn(target, key);
        const result = Reflect.set(target, key, value, receiver);
        if (target === $f347e48613385d9c$var$toRaw(receiver)) {
            if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
            else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
        }
        return result;
    };
}
function $f347e48613385d9c$var$deleteProperty(target, key) {
    const hadKey = $f347e48613385d9c$var$hasOwn(target, key);
    const oldValue = target[key];
    const result = Reflect.deleteProperty(target, key);
    if (result && hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$has(target, key) {
    const result = Reflect.has(target, key);
    if (!$f347e48613385d9c$var$isSymbol(key) || !$f347e48613385d9c$var$builtInSymbols.has(key)) $f347e48613385d9c$var$track(target, "has", key);
    return result;
}
function $f347e48613385d9c$var$ownKeys(target) {
    $f347e48613385d9c$var$track(target, "iterate", $f347e48613385d9c$var$isArray(target) ? "length" : $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.ownKeys(target);
}
var $f347e48613385d9c$var$mutableHandlers = {
    get: $f347e48613385d9c$var$get2,
    set: $f347e48613385d9c$var$set2,
    deleteProperty: $f347e48613385d9c$var$deleteProperty,
    has: $f347e48613385d9c$var$has,
    ownKeys: $f347e48613385d9c$var$ownKeys
};
var $f347e48613385d9c$var$readonlyHandlers = {
    get: $f347e48613385d9c$var$readonlyGet,
    set (target, key) {
        console.warn(`Set operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    },
    deleteProperty (target, key) {
        console.warn(`Delete operation on key "${String(key)}" failed: target is readonly.`, target);
        return true;
    }
};
var $f347e48613385d9c$var$toReactive = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$reactive2(value) : value;
var $f347e48613385d9c$var$toReadonly = (value)=>$f347e48613385d9c$var$isObject(value) ? $f347e48613385d9c$var$readonly(value) : value;
var $f347e48613385d9c$var$toShallow = (value)=>value;
var $f347e48613385d9c$var$getProto = (v)=>Reflect.getPrototypeOf(v);
function $f347e48613385d9c$var$get$1(target, key, isReadonly = false, isShallow = false) {
    target = target["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "get", rawKey);
    const { has: has2 } = $f347e48613385d9c$var$getProto(rawTarget);
    const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
    if (has2.call(rawTarget, key)) return wrap(target.get(key));
    else if (has2.call(rawTarget, rawKey)) return wrap(target.get(rawKey));
    else if (target !== rawTarget) target.get(key);
}
function $f347e48613385d9c$var$has$1(key, isReadonly = false) {
    const target = this["__v_raw"];
    const rawTarget = $f347e48613385d9c$var$toRaw(target);
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (key !== rawKey) !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", key);
    !isReadonly && $f347e48613385d9c$var$track(rawTarget, "has", rawKey);
    return key === rawKey ? target.has(key) : target.has(key) || target.has(rawKey);
}
function $f347e48613385d9c$var$size(target, isReadonly = false) {
    target = target["__v_raw"];
    !isReadonly && $f347e48613385d9c$var$track($f347e48613385d9c$var$toRaw(target), "iterate", $f347e48613385d9c$var$ITERATE_KEY);
    return Reflect.get(target, "size", target);
}
function $f347e48613385d9c$var$add(value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const proto = $f347e48613385d9c$var$getProto(target);
    const hadKey = proto.has.call(target, value);
    if (!hadKey) {
        target.add(value);
        $f347e48613385d9c$var$trigger(target, "add", value, value);
    }
    return this;
}
function $f347e48613385d9c$var$set$1(key, value) {
    value = $f347e48613385d9c$var$toRaw(value);
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3.call(target, key);
    target.set(key, value);
    if (!hadKey) $f347e48613385d9c$var$trigger(target, "add", key, value);
    else if ($f347e48613385d9c$var$hasChanged(value, oldValue)) $f347e48613385d9c$var$trigger(target, "set", key, value, oldValue);
    return this;
}
function $f347e48613385d9c$var$deleteEntry(key) {
    const target = $f347e48613385d9c$var$toRaw(this);
    const { has: has2, get: get3 } = $f347e48613385d9c$var$getProto(target);
    let hadKey = has2.call(target, key);
    if (!hadKey) {
        key = $f347e48613385d9c$var$toRaw(key);
        hadKey = has2.call(target, key);
    } else $f347e48613385d9c$var$checkIdentityKeys(target, has2, key);
    const oldValue = get3 ? get3.call(target, key) : void 0;
    const result = target.delete(key);
    if (hadKey) $f347e48613385d9c$var$trigger(target, "delete", key, void 0, oldValue);
    return result;
}
function $f347e48613385d9c$var$clear() {
    const target = $f347e48613385d9c$var$toRaw(this);
    const hadItems = target.size !== 0;
    const oldTarget = $f347e48613385d9c$var$isMap(target) ? new Map(target) : new Set(target);
    const result = target.clear();
    if (hadItems) $f347e48613385d9c$var$trigger(target, "clear", void 0, void 0, oldTarget);
    return result;
}
function $f347e48613385d9c$var$createForEach(isReadonly, isShallow) {
    return function forEach(callback, thisArg) {
        const observed = this;
        const target = observed["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", $f347e48613385d9c$var$ITERATE_KEY);
        return target.forEach((value, key)=>{
            return callback.call(thisArg, wrap(value), wrap(key), observed);
        });
    };
}
function $f347e48613385d9c$var$createIterableMethod(method, isReadonly, isShallow) {
    return function(...args) {
        const target = this["__v_raw"];
        const rawTarget = $f347e48613385d9c$var$toRaw(target);
        const targetIsMap = $f347e48613385d9c$var$isMap(rawTarget);
        const isPair = method === "entries" || method === Symbol.iterator && targetIsMap;
        const isKeyOnly = method === "keys" && targetIsMap;
        const innerIterator = target[method](...args);
        const wrap = isShallow ? $f347e48613385d9c$var$toShallow : isReadonly ? $f347e48613385d9c$var$toReadonly : $f347e48613385d9c$var$toReactive;
        !isReadonly && $f347e48613385d9c$var$track(rawTarget, "iterate", isKeyOnly ? $f347e48613385d9c$var$MAP_KEY_ITERATE_KEY : $f347e48613385d9c$var$ITERATE_KEY);
        return {
            // iterator protocol
            next () {
                const { value: value, done: done } = innerIterator.next();
                return done ? {
                    value: value,
                    done: done
                } : {
                    value: isPair ? [
                        wrap(value[0]),
                        wrap(value[1])
                    ] : wrap(value),
                    done: done
                };
            },
            // iterable protocol
            [Symbol.iterator] () {
                return this;
            }
        };
    };
}
function $f347e48613385d9c$var$createReadonlyMethod(type) {
    return function(...args) {
        {
            const key = args[0] ? `on key "${args[0]}" ` : ``;
            console.warn(`${$f347e48613385d9c$var$capitalize(type)} operation ${key}failed: target is readonly.`, $f347e48613385d9c$var$toRaw(this));
        }
        return type === "delete" ? false : this;
    };
}
function $f347e48613385d9c$var$createInstrumentations() {
    const mutableInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key);
        },
        get size () {
            return $f347e48613385d9c$var$size(this);
        },
        has: $f347e48613385d9c$var$has$1,
        add: $f347e48613385d9c$var$add,
        set: $f347e48613385d9c$var$set$1,
        delete: $f347e48613385d9c$var$deleteEntry,
        clear: $f347e48613385d9c$var$clear,
        forEach: $f347e48613385d9c$var$createForEach(false, false)
    };
    const shallowInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, false, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this);
        },
        has: $f347e48613385d9c$var$has$1,
        add: $f347e48613385d9c$var$add,
        set: $f347e48613385d9c$var$set$1,
        delete: $f347e48613385d9c$var$deleteEntry,
        clear: $f347e48613385d9c$var$clear,
        forEach: $f347e48613385d9c$var$createForEach(false, true)
    };
    const readonlyInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this, true);
        },
        has (key) {
            return $f347e48613385d9c$var$has$1.call(this, key, true);
        },
        add: $f347e48613385d9c$var$createReadonlyMethod("add"),
        set: $f347e48613385d9c$var$createReadonlyMethod("set"),
        delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
        clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
        forEach: $f347e48613385d9c$var$createForEach(true, false)
    };
    const shallowReadonlyInstrumentations2 = {
        get (key) {
            return $f347e48613385d9c$var$get$1(this, key, true, true);
        },
        get size () {
            return $f347e48613385d9c$var$size(this, true);
        },
        has (key) {
            return $f347e48613385d9c$var$has$1.call(this, key, true);
        },
        add: $f347e48613385d9c$var$createReadonlyMethod("add"),
        set: $f347e48613385d9c$var$createReadonlyMethod("set"),
        delete: $f347e48613385d9c$var$createReadonlyMethod("delete"),
        clear: $f347e48613385d9c$var$createReadonlyMethod("clear"),
        forEach: $f347e48613385d9c$var$createForEach(true, true)
    };
    const iteratorMethods = [
        "keys",
        "values",
        "entries",
        Symbol.iterator
    ];
    iteratorMethods.forEach((method)=>{
        mutableInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, false, false);
        readonlyInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, true, false);
        shallowInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, false, true);
        shallowReadonlyInstrumentations2[method] = $f347e48613385d9c$var$createIterableMethod(method, true, true);
    });
    return [
        mutableInstrumentations2,
        readonlyInstrumentations2,
        shallowInstrumentations2,
        shallowReadonlyInstrumentations2
    ];
}
var [$f347e48613385d9c$var$mutableInstrumentations, $f347e48613385d9c$var$readonlyInstrumentations, $f347e48613385d9c$var$shallowInstrumentations, $f347e48613385d9c$var$shallowReadonlyInstrumentations] = /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentations();
function $f347e48613385d9c$var$createInstrumentationGetter(isReadonly, shallow) {
    const instrumentations = shallow ? isReadonly ? $f347e48613385d9c$var$shallowReadonlyInstrumentations : $f347e48613385d9c$var$shallowInstrumentations : isReadonly ? $f347e48613385d9c$var$readonlyInstrumentations : $f347e48613385d9c$var$mutableInstrumentations;
    return (target, key, receiver)=>{
        if (key === "__v_isReactive") return !isReadonly;
        else if (key === "__v_isReadonly") return isReadonly;
        else if (key === "__v_raw") return target;
        return Reflect.get($f347e48613385d9c$var$hasOwn(instrumentations, key) && key in target ? instrumentations : target, key, receiver);
    };
}
var $f347e48613385d9c$var$mutableCollectionHandlers = {
    get: /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentationGetter(false, false)
};
var $f347e48613385d9c$var$readonlyCollectionHandlers = {
    get: /* @__PURE__ */ $f347e48613385d9c$var$createInstrumentationGetter(true, false)
};
function $f347e48613385d9c$var$checkIdentityKeys(target, has2, key) {
    const rawKey = $f347e48613385d9c$var$toRaw(key);
    if (rawKey !== key && has2.call(target, rawKey)) {
        const type = $f347e48613385d9c$var$toRawType(target);
        console.warn(`Reactive ${type} contains both the raw and reactive versions of the same object${type === `Map` ? ` as keys` : ``}, which can lead to inconsistencies. Avoid differentiating between the raw and reactive versions of an object and only use the reactive version if possible.`);
    }
}
var $f347e48613385d9c$var$reactiveMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$shallowReactiveMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$readonlyMap = /* @__PURE__ */ new WeakMap();
var $f347e48613385d9c$var$shallowReadonlyMap = /* @__PURE__ */ new WeakMap();
function $f347e48613385d9c$var$targetTypeMap(rawType) {
    switch(rawType){
        case "Object":
        case "Array":
            return 1;
        case "Map":
        case "Set":
        case "WeakMap":
        case "WeakSet":
            return 2;
        default:
            return 0;
    }
}
function $f347e48613385d9c$var$getTargetType(value) {
    return value["__v_skip"] || !Object.isExtensible(value) ? 0 : $f347e48613385d9c$var$targetTypeMap($f347e48613385d9c$var$toRawType(value));
}
function $f347e48613385d9c$var$reactive2(target) {
    if (target && target["__v_isReadonly"]) return target;
    return $f347e48613385d9c$var$createReactiveObject(target, false, $f347e48613385d9c$var$mutableHandlers, $f347e48613385d9c$var$mutableCollectionHandlers, $f347e48613385d9c$var$reactiveMap);
}
function $f347e48613385d9c$var$readonly(target) {
    return $f347e48613385d9c$var$createReactiveObject(target, true, $f347e48613385d9c$var$readonlyHandlers, $f347e48613385d9c$var$readonlyCollectionHandlers, $f347e48613385d9c$var$readonlyMap);
}
function $f347e48613385d9c$var$createReactiveObject(target, isReadonly, baseHandlers, collectionHandlers, proxyMap) {
    if (!$f347e48613385d9c$var$isObject(target)) {
        console.warn(`value cannot be made reactive: ${String(target)}`);
        return target;
    }
    if (target["__v_raw"] && !(isReadonly && target["__v_isReactive"])) return target;
    const existingProxy = proxyMap.get(target);
    if (existingProxy) return existingProxy;
    const targetType = $f347e48613385d9c$var$getTargetType(target);
    if (targetType === 0) return target;
    const proxy = new Proxy(target, targetType === 2 ? collectionHandlers : baseHandlers);
    proxyMap.set(target, proxy);
    return proxy;
}
function $f347e48613385d9c$var$toRaw(observed) {
    return observed && $f347e48613385d9c$var$toRaw(observed["__v_raw"]) || observed;
}
function $f347e48613385d9c$var$isRef(r) {
    return Boolean(r && r.__v_isRef === true);
}
// packages/alpinejs/src/magics/$nextTick.js
$f347e48613385d9c$var$magic("nextTick", ()=>$f347e48613385d9c$var$nextTick);
// packages/alpinejs/src/magics/$dispatch.js
$f347e48613385d9c$var$magic("dispatch", (el)=>$f347e48613385d9c$var$dispatch.bind($f347e48613385d9c$var$dispatch, el));
// packages/alpinejs/src/magics/$watch.js
$f347e48613385d9c$var$magic("watch", (el, { evaluateLater: evaluateLater2, cleanup: cleanup2 })=>(key, callback)=>{
        let evaluate2 = evaluateLater2(key);
        let getter = ()=>{
            let value;
            evaluate2((i)=>value = i);
            return value;
        };
        let unwatch = $f347e48613385d9c$var$watch(getter, callback);
        cleanup2(unwatch);
    });
// packages/alpinejs/src/magics/$store.js
$f347e48613385d9c$var$magic("store", $f347e48613385d9c$var$getStores);
// packages/alpinejs/src/magics/$data.js
$f347e48613385d9c$var$magic("data", (el)=>$f347e48613385d9c$var$scope(el));
// packages/alpinejs/src/magics/$root.js
$f347e48613385d9c$var$magic("root", (el)=>$f347e48613385d9c$var$closestRoot(el));
// packages/alpinejs/src/magics/$refs.js
$f347e48613385d9c$var$magic("refs", (el)=>{
    if (el._x_refs_proxy) return el._x_refs_proxy;
    el._x_refs_proxy = $f347e48613385d9c$var$mergeProxies($f347e48613385d9c$var$getArrayOfRefObject(el));
    return el._x_refs_proxy;
});
function $f347e48613385d9c$var$getArrayOfRefObject(el) {
    let refObjects = [];
    $f347e48613385d9c$var$findClosest(el, (i)=>{
        if (i._x_refs) refObjects.push(i._x_refs);
    });
    return refObjects;
}
// packages/alpinejs/src/ids.js
var $f347e48613385d9c$var$globalIdMemo = {};
function $f347e48613385d9c$var$findAndIncrementId(name) {
    if (!$f347e48613385d9c$var$globalIdMemo[name]) $f347e48613385d9c$var$globalIdMemo[name] = 0;
    return ++$f347e48613385d9c$var$globalIdMemo[name];
}
function $f347e48613385d9c$var$closestIdRoot(el, name) {
    return $f347e48613385d9c$var$findClosest(el, (element)=>{
        if (element._x_ids && element._x_ids[name]) return true;
    });
}
function $f347e48613385d9c$var$setIdRoot(el, name) {
    if (!el._x_ids) el._x_ids = {};
    if (!el._x_ids[name]) el._x_ids[name] = $f347e48613385d9c$var$findAndIncrementId(name);
}
// packages/alpinejs/src/magics/$id.js
$f347e48613385d9c$var$magic("id", (el, { cleanup: cleanup2 })=>(name, key = null)=>{
        let cacheKey = `${name}${key ? `-${key}` : ""}`;
        return $f347e48613385d9c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, ()=>{
            let root = $f347e48613385d9c$var$closestIdRoot(el, name);
            let id = root ? root._x_ids[name] : $f347e48613385d9c$var$findAndIncrementId(name);
            return key ? `${name}-${id}-${key}` : `${name}-${id}`;
        });
    });
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_id) to._x_id = from._x_id;
});
function $f347e48613385d9c$var$cacheIdByNameOnElement(el, cacheKey, cleanup2, callback) {
    if (!el._x_id) el._x_id = {};
    if (el._x_id[cacheKey]) return el._x_id[cacheKey];
    let output = callback();
    el._x_id[cacheKey] = output;
    cleanup2(()=>{
        delete el._x_id[cacheKey];
    });
    return output;
}
// packages/alpinejs/src/magics/$el.js
$f347e48613385d9c$var$magic("el", (el)=>el);
// packages/alpinejs/src/magics/index.js
$f347e48613385d9c$var$warnMissingPluginMagic("Focus", "focus", "focus");
$f347e48613385d9c$var$warnMissingPluginMagic("Persist", "persist", "persist");
function $f347e48613385d9c$var$warnMissingPluginMagic(name, magicName, slug) {
    $f347e48613385d9c$var$magic(magicName, (el)=>$f347e48613385d9c$var$warn(`You can't use [$${magicName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/directives/x-modelable.js
$f347e48613385d9c$var$directive("modelable", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2, cleanup: cleanup2 })=>{
    let func = evaluateLater2(expression);
    let innerGet = ()=>{
        let result;
        func((i)=>result = i);
        return result;
    };
    let evaluateInnerSet = evaluateLater2(`${expression} = __placeholder`);
    let innerSet = (val)=>evaluateInnerSet(()=>{}, {
            scope: {
                "__placeholder": val
            }
        });
    let initialValue = innerGet();
    innerSet(initialValue);
    queueMicrotask(()=>{
        if (!el._x_model) return;
        el._x_removeModelListeners["default"]();
        let outerGet = el._x_model.get;
        let outerSet = el._x_model.set;
        let releaseEntanglement = $f347e48613385d9c$var$entangle({
            get () {
                return outerGet();
            },
            set (value) {
                outerSet(value);
            }
        }, {
            get () {
                return innerGet();
            },
            set (value) {
                innerSet(value);
            }
        });
        cleanup2(releaseEntanglement);
    });
});
// packages/alpinejs/src/directives/x-teleport.js
$f347e48613385d9c$var$directive("teleport", (el, { modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-teleport can only be used on a <template> tag", el);
    let target = $f347e48613385d9c$var$getTarget(expression);
    let clone2 = el.content.cloneNode(true).firstElementChild;
    el._x_teleport = clone2;
    clone2._x_teleportBack = el;
    el.setAttribute("data-teleport-template", true);
    clone2.setAttribute("data-teleport-target", true);
    if (el._x_forwardEvents) el._x_forwardEvents.forEach((eventName)=>{
        clone2.addEventListener(eventName, (e)=>{
            e.stopPropagation();
            el.dispatchEvent(new e.constructor(e.type, e));
        });
    });
    $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
    let placeInDom = (clone3, target2, modifiers2)=>{
        if (modifiers2.includes("prepend")) target2.parentNode.insertBefore(clone3, target2);
        else if (modifiers2.includes("append")) target2.parentNode.insertBefore(clone3, target2.nextSibling);
        else target2.appendChild(clone3);
    };
    $f347e48613385d9c$var$mutateDom(()=>{
        placeInDom(clone2, target, modifiers);
        $f347e48613385d9c$var$skipDuringClone(()=>{
            $f347e48613385d9c$var$initTree(clone2);
        })();
    });
    el._x_teleportPutBack = ()=>{
        let target2 = $f347e48613385d9c$var$getTarget(expression);
        $f347e48613385d9c$var$mutateDom(()=>{
            placeInDom(el._x_teleport, target2, modifiers);
        });
    };
    cleanup2(()=>$f347e48613385d9c$var$mutateDom(()=>{
            clone2.remove();
            $f347e48613385d9c$var$destroyTree(clone2);
        }));
});
var $f347e48613385d9c$var$teleportContainerDuringClone = document.createElement("div");
function $f347e48613385d9c$var$getTarget(expression) {
    let target = $f347e48613385d9c$var$skipDuringClone(()=>{
        return document.querySelector(expression);
    }, ()=>{
        return $f347e48613385d9c$var$teleportContainerDuringClone;
    })();
    if (!target) $f347e48613385d9c$var$warn(`Cannot find x-teleport element for selector: "${expression}"`);
    return target;
}
// packages/alpinejs/src/directives/x-ignore.js
var $f347e48613385d9c$var$handler = ()=>{};
$f347e48613385d9c$var$handler.inline = (el, { modifiers: modifiers }, { cleanup: cleanup2 })=>{
    modifiers.includes("self") ? el._x_ignoreSelf = true : el._x_ignore = true;
    cleanup2(()=>{
        modifiers.includes("self") ? delete el._x_ignoreSelf : delete el._x_ignore;
    });
};
$f347e48613385d9c$var$directive("ignore", $f347e48613385d9c$var$handler);
// packages/alpinejs/src/directives/x-effect.js
$f347e48613385d9c$var$directive("effect", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { effect: effect3 })=>{
    effect3($f347e48613385d9c$var$evaluateLater(el, expression));
}));
// packages/alpinejs/src/utils/on.js
function $f347e48613385d9c$var$on(el, event, modifiers, callback) {
    let listenerTarget = el;
    let handler4 = (e)=>callback(e);
    let options = {};
    let wrapHandler = (callback2, wrapper)=>(e)=>wrapper(callback2, e);
    if (modifiers.includes("dot")) event = $f347e48613385d9c$var$dotSyntax(event);
    if (modifiers.includes("camel")) event = $f347e48613385d9c$var$camelCase2(event);
    if (modifiers.includes("passive")) options.passive = true;
    if (modifiers.includes("capture")) options.capture = true;
    if (modifiers.includes("window")) listenerTarget = window;
    if (modifiers.includes("document")) listenerTarget = document;
    if (modifiers.includes("debounce")) {
        let nextModifier = modifiers[modifiers.indexOf("debounce") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$debounce(handler4, wait);
    }
    if (modifiers.includes("throttle")) {
        let nextModifier = modifiers[modifiers.indexOf("throttle") + 1] || "invalid-wait";
        let wait = $f347e48613385d9c$var$isNumeric(nextModifier.split("ms")[0]) ? Number(nextModifier.split("ms")[0]) : 250;
        handler4 = $f347e48613385d9c$var$throttle(handler4, wait);
    }
    if (modifiers.includes("prevent")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.preventDefault();
        next(e);
    });
    if (modifiers.includes("stop")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.stopPropagation();
        next(e);
    });
    if (modifiers.includes("once")) handler4 = wrapHandler(handler4, (next, e)=>{
        next(e);
        listenerTarget.removeEventListener(event, handler4, options);
    });
    if (modifiers.includes("away") || modifiers.includes("outside")) {
        listenerTarget = document;
        handler4 = wrapHandler(handler4, (next, e)=>{
            if (el.contains(e.target)) return;
            if (e.target.isConnected === false) return;
            if (el.offsetWidth < 1 && el.offsetHeight < 1) return;
            if (el._x_isShown === false) return;
            next(e);
        });
    }
    if (modifiers.includes("self")) handler4 = wrapHandler(handler4, (next, e)=>{
        e.target === el && next(e);
    });
    if ($f347e48613385d9c$var$isKeyEvent(event) || $f347e48613385d9c$var$isClickEvent(event)) handler4 = wrapHandler(handler4, (next, e)=>{
        if ($f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers)) return;
        next(e);
    });
    listenerTarget.addEventListener(event, handler4, options);
    return ()=>{
        listenerTarget.removeEventListener(event, handler4, options);
    };
}
function $f347e48613385d9c$var$dotSyntax(subject) {
    return subject.replace(/-/g, ".");
}
function $f347e48613385d9c$var$camelCase2(subject) {
    return subject.toLowerCase().replace(/-(\w)/g, (match, char)=>char.toUpperCase());
}
function $f347e48613385d9c$var$isNumeric(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$kebabCase2(subject) {
    if ([
        " ",
        "_"
    ].includes(subject)) return subject;
    return subject.replace(/([a-z])([A-Z])/g, "$1-$2").replace(/[_\s]/, "-").toLowerCase();
}
function $f347e48613385d9c$var$isKeyEvent(event) {
    return [
        "keydown",
        "keyup"
    ].includes(event);
}
function $f347e48613385d9c$var$isClickEvent(event) {
    return [
        "contextmenu",
        "click",
        "mouse"
    ].some((i)=>event.includes(i));
}
function $f347e48613385d9c$var$isListeningForASpecificKeyThatHasntBeenPressed(e, modifiers) {
    let keyModifiers = modifiers.filter((i)=>{
        return ![
            "window",
            "document",
            "prevent",
            "stop",
            "once",
            "capture",
            "self",
            "away",
            "outside",
            "passive",
            "preserve-scroll"
        ].includes(i);
    });
    if (keyModifiers.includes("debounce")) {
        let debounceIndex = keyModifiers.indexOf("debounce");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.includes("throttle")) {
        let debounceIndex = keyModifiers.indexOf("throttle");
        keyModifiers.splice(debounceIndex, $f347e48613385d9c$var$isNumeric((keyModifiers[debounceIndex + 1] || "invalid-wait").split("ms")[0]) ? 2 : 1);
    }
    if (keyModifiers.length === 0) return false;
    if (keyModifiers.length === 1 && $f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
    const systemKeyModifiers = [
        "ctrl",
        "shift",
        "alt",
        "meta",
        "cmd",
        "super"
    ];
    const selectedSystemKeyModifiers = systemKeyModifiers.filter((modifier)=>keyModifiers.includes(modifier));
    keyModifiers = keyModifiers.filter((i)=>!selectedSystemKeyModifiers.includes(i));
    if (selectedSystemKeyModifiers.length > 0) {
        const activelyPressedKeyModifiers = selectedSystemKeyModifiers.filter((modifier)=>{
            if (modifier === "cmd" || modifier === "super") modifier = "meta";
            return e[`${modifier}Key`];
        });
        if (activelyPressedKeyModifiers.length === selectedSystemKeyModifiers.length) {
            if ($f347e48613385d9c$var$isClickEvent(e.type)) return false;
            if ($f347e48613385d9c$var$keyToModifiers(e.key).includes(keyModifiers[0])) return false;
        }
    }
    return true;
}
function $f347e48613385d9c$var$keyToModifiers(key) {
    if (!key) return [];
    key = $f347e48613385d9c$var$kebabCase2(key);
    let modifierToKeyMap = {
        "ctrl": "control",
        "slash": "/",
        "space": " ",
        "spacebar": " ",
        "cmd": "meta",
        "esc": "escape",
        "up": "arrow-up",
        "down": "arrow-down",
        "left": "arrow-left",
        "right": "arrow-right",
        "period": ".",
        "comma": ",",
        "equal": "=",
        "minus": "-",
        "underscore": "_"
    };
    modifierToKeyMap[key] = key;
    return Object.keys(modifierToKeyMap).map((modifier)=>{
        if (modifierToKeyMap[modifier] === key) return modifier;
    }).filter((modifier)=>modifier);
}
// packages/alpinejs/src/directives/x-model.js
$f347e48613385d9c$var$directive("model", (el, { modifiers: modifiers, expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let scopeTarget = el;
    if (modifiers.includes("parent")) scopeTarget = el.parentNode;
    let evaluateGet = $f347e48613385d9c$var$evaluateLater(scopeTarget, expression);
    let evaluateSet;
    if (typeof expression === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression} = __placeholder`);
    else if (typeof expression === "function" && typeof expression() === "string") evaluateSet = $f347e48613385d9c$var$evaluateLater(scopeTarget, `${expression()} = __placeholder`);
    else evaluateSet = ()=>{};
    let getValue = ()=>{
        let result;
        evaluateGet((value)=>result = value);
        return $f347e48613385d9c$var$isGetterSetter(result) ? result.get() : result;
    };
    let setValue = (value)=>{
        let result;
        evaluateGet((value2)=>result = value2);
        if ($f347e48613385d9c$var$isGetterSetter(result)) result.set(value);
        else evaluateSet(()=>{}, {
            scope: {
                "__placeholder": value
            }
        });
    };
    if (typeof expression === "string" && el.type === "radio") $f347e48613385d9c$var$mutateDom(()=>{
        if (!el.hasAttribute("name")) el.setAttribute("name", expression);
    });
    let event = el.tagName.toLowerCase() === "select" || [
        "checkbox",
        "radio"
    ].includes(el.type) || modifiers.includes("lazy") ? "change" : "input";
    let removeListener = $f347e48613385d9c$var$isCloning ? ()=>{} : $f347e48613385d9c$var$on(el, event, modifiers, (e)=>{
        setValue($f347e48613385d9c$var$getInputValue(el, modifiers, e, getValue()));
    });
    if (modifiers.includes("fill")) {
        if ([
            void 0,
            null,
            ""
        ].includes(getValue()) || $f347e48613385d9c$var$isCheckbox(el) && Array.isArray(getValue()) || el.tagName.toLowerCase() === "select" && el.multiple) setValue($f347e48613385d9c$var$getInputValue(el, modifiers, {
            target: el
        }, getValue()));
    }
    if (!el._x_removeModelListeners) el._x_removeModelListeners = {};
    el._x_removeModelListeners["default"] = removeListener;
    cleanup2(()=>el._x_removeModelListeners["default"]());
    if (el.form) {
        let removeResetListener = $f347e48613385d9c$var$on(el.form, "reset", [], (e)=>{
            $f347e48613385d9c$var$nextTick(()=>el._x_model && el._x_model.set($f347e48613385d9c$var$getInputValue(el, modifiers, {
                    target: el
                }, getValue())));
        });
        cleanup2(()=>removeResetListener());
    }
    el._x_model = {
        get () {
            return getValue();
        },
        set (value) {
            setValue(value);
        }
    };
    el._x_forceModelUpdate = (value)=>{
        if (value === void 0 && typeof expression === "string" && expression.match(/\./)) value = "";
        window.fromModel = true;
        $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, "value", value));
        delete window.fromModel;
    };
    effect3(()=>{
        let value = getValue();
        if (modifiers.includes("unintrusive") && document.activeElement.isSameNode(el)) return;
        el._x_forceModelUpdate(value);
    });
});
function $f347e48613385d9c$var$getInputValue(el, modifiers, event, currentValue) {
    return $f347e48613385d9c$var$mutateDom(()=>{
        if (event instanceof CustomEvent && event.detail !== void 0) return event.detail !== null && event.detail !== void 0 ? event.detail : event.target.value;
        else if ($f347e48613385d9c$var$isCheckbox(el)) {
            if (Array.isArray(currentValue)) {
                let newValue = null;
                if (modifiers.includes("number")) newValue = $f347e48613385d9c$var$safeParseNumber(event.target.value);
                else if (modifiers.includes("boolean")) newValue = $f347e48613385d9c$var$safeParseBoolean(event.target.value);
                else newValue = event.target.value;
                return event.target.checked ? currentValue.includes(newValue) ? currentValue : currentValue.concat([
                    newValue
                ]) : currentValue.filter((el2)=>!$f347e48613385d9c$var$checkedAttrLooseCompare2(el2, newValue));
            } else return event.target.checked;
        } else if (el.tagName.toLowerCase() === "select" && el.multiple) {
            if (modifiers.includes("number")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f347e48613385d9c$var$safeParseNumber(rawValue);
            });
            else if (modifiers.includes("boolean")) return Array.from(event.target.selectedOptions).map((option)=>{
                let rawValue = option.value || option.text;
                return $f347e48613385d9c$var$safeParseBoolean(rawValue);
            });
            return Array.from(event.target.selectedOptions).map((option)=>{
                return option.value || option.text;
            });
        } else {
            let newValue;
            if ($f347e48613385d9c$var$isRadio(el)) {
                if (event.target.checked) newValue = event.target.value;
                else newValue = currentValue;
            } else newValue = event.target.value;
            if (modifiers.includes("number")) return $f347e48613385d9c$var$safeParseNumber(newValue);
            else if (modifiers.includes("boolean")) return $f347e48613385d9c$var$safeParseBoolean(newValue);
            else if (modifiers.includes("trim")) return newValue.trim();
            else return newValue;
        }
    });
}
function $f347e48613385d9c$var$safeParseNumber(rawValue) {
    let number = rawValue ? parseFloat(rawValue) : null;
    return $f347e48613385d9c$var$isNumeric2(number) ? number : rawValue;
}
function $f347e48613385d9c$var$checkedAttrLooseCompare2(valueA, valueB) {
    return valueA == valueB;
}
function $f347e48613385d9c$var$isNumeric2(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
function $f347e48613385d9c$var$isGetterSetter(value) {
    return value !== null && typeof value === "object" && typeof value.get === "function" && typeof value.set === "function";
}
// packages/alpinejs/src/directives/x-cloak.js
$f347e48613385d9c$var$directive("cloak", (el)=>queueMicrotask(()=>$f347e48613385d9c$var$mutateDom(()=>el.removeAttribute($f347e48613385d9c$var$prefix("cloak")))));
// packages/alpinejs/src/directives/x-init.js
$f347e48613385d9c$var$addInitSelector(()=>`[${$f347e48613385d9c$var$prefix("init")}]`);
$f347e48613385d9c$var$directive("init", $f347e48613385d9c$var$skipDuringClone((el, { expression: expression }, { evaluate: evaluate2 })=>{
    if (typeof expression === "string") return !!expression.trim() && evaluate2(expression, {}, false);
    return evaluate2(expression, {}, false);
}));
// packages/alpinejs/src/directives/x-text.js
$f347e48613385d9c$var$directive("text", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.textContent = value;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-html.js
$f347e48613385d9c$var$directive("html", (el, { expression: expression }, { effect: effect3, evaluateLater: evaluateLater2 })=>{
    let evaluate2 = evaluateLater2(expression);
    effect3(()=>{
        evaluate2((value)=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                el.innerHTML = value;
                el._x_ignoreSelf = true;
                $f347e48613385d9c$var$initTree(el);
                delete el._x_ignoreSelf;
            });
        });
    });
});
// packages/alpinejs/src/directives/x-bind.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith(":", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("bind:"))));
var $f347e48613385d9c$var$handler2 = (el, { value: value, modifiers: modifiers, expression: expression, original: original }, { effect: effect3, cleanup: cleanup2 })=>{
    if (!value) {
        let bindingProviders = {};
        $f347e48613385d9c$var$injectBindingProviders(bindingProviders);
        let getBindings = $f347e48613385d9c$var$evaluateLater(el, expression);
        getBindings((bindings)=>{
            $f347e48613385d9c$var$applyBindingsObject(el, bindings, original);
        }, {
            scope: bindingProviders
        });
        return;
    }
    if (value === "key") return $f347e48613385d9c$var$storeKeyForXFor(el, expression);
    if (el._x_inlineBindings && el._x_inlineBindings[value] && el._x_inlineBindings[value].extract) return;
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    effect3(()=>evaluate2((result)=>{
            if (result === void 0 && typeof expression === "string" && expression.match(/\./)) result = "";
            $f347e48613385d9c$var$mutateDom(()=>$f347e48613385d9c$var$bind(el, value, result, modifiers));
        }));
    cleanup2(()=>{
        el._x_undoAddedClasses && el._x_undoAddedClasses();
        el._x_undoAddedStyles && el._x_undoAddedStyles();
    });
};
$f347e48613385d9c$var$handler2.inline = (el, { value: value, modifiers: modifiers, expression: expression })=>{
    if (!value) return;
    if (!el._x_inlineBindings) el._x_inlineBindings = {};
    el._x_inlineBindings[value] = {
        expression: expression,
        extract: false
    };
};
$f347e48613385d9c$var$directive("bind", $f347e48613385d9c$var$handler2);
function $f347e48613385d9c$var$storeKeyForXFor(el, expression) {
    el._x_keyExpression = expression;
}
// packages/alpinejs/src/directives/x-data.js
$f347e48613385d9c$var$addRootSelector(()=>`[${$f347e48613385d9c$var$prefix("data")}]`);
$f347e48613385d9c$var$directive("data", (el, { expression: expression }, { cleanup: cleanup2 })=>{
    if ($f347e48613385d9c$var$shouldSkipRegisteringDataDuringClone(el)) return;
    expression = expression === "" ? "{}" : expression;
    let magicContext = {};
    $f347e48613385d9c$var$injectMagics(magicContext, el);
    let dataProviderContext = {};
    $f347e48613385d9c$var$injectDataProviders(dataProviderContext, magicContext);
    let data2 = $f347e48613385d9c$var$evaluate(el, expression, {
        scope: dataProviderContext
    });
    if (data2 === void 0 || data2 === true) data2 = {};
    $f347e48613385d9c$var$injectMagics(data2, el);
    let reactiveData = $f347e48613385d9c$var$reactive(data2);
    $f347e48613385d9c$var$initInterceptors(reactiveData);
    let undo = $f347e48613385d9c$var$addScopeToNode(el, reactiveData);
    reactiveData["init"] && $f347e48613385d9c$var$evaluate(el, reactiveData["init"]);
    cleanup2(()=>{
        reactiveData["destroy"] && $f347e48613385d9c$var$evaluate(el, reactiveData["destroy"]);
        undo();
    });
});
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_dataStack) {
        to._x_dataStack = from._x_dataStack;
        to.setAttribute("data-has-alpine-state", true);
    }
});
function $f347e48613385d9c$var$shouldSkipRegisteringDataDuringClone(el) {
    if (!$f347e48613385d9c$var$isCloning) return false;
    if ($f347e48613385d9c$var$isCloningLegacy) return true;
    return el.hasAttribute("data-has-alpine-state");
}
// packages/alpinejs/src/directives/x-show.js
$f347e48613385d9c$var$directive("show", (el, { modifiers: modifiers, expression: expression }, { effect: effect3 })=>{
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    if (!el._x_doHide) el._x_doHide = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            el.style.setProperty("display", "none", modifiers.includes("important") ? "important" : void 0);
        });
    };
    if (!el._x_doShow) el._x_doShow = ()=>{
        $f347e48613385d9c$var$mutateDom(()=>{
            if (el.style.length === 1 && el.style.display === "none") el.removeAttribute("style");
            else el.style.removeProperty("display");
        });
    };
    let hide = ()=>{
        el._x_doHide();
        el._x_isShown = false;
    };
    let show = ()=>{
        el._x_doShow();
        el._x_isShown = true;
    };
    let clickAwayCompatibleShow = ()=>setTimeout(show);
    let toggle = $f347e48613385d9c$var$once((value)=>value ? show() : hide(), (value)=>{
        if (typeof el._x_toggleAndCascadeWithTransitions === "function") el._x_toggleAndCascadeWithTransitions(el, value, show, hide);
        else value ? clickAwayCompatibleShow() : hide();
    });
    let oldValue;
    let firstTime = true;
    effect3(()=>evaluate2((value)=>{
            if (!firstTime && value === oldValue) return;
            if (modifiers.includes("immediate")) value ? clickAwayCompatibleShow() : hide();
            toggle(value);
            oldValue = value;
            firstTime = false;
        }));
});
// packages/alpinejs/src/directives/x-for.js
$f347e48613385d9c$var$directive("for", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    let iteratorNames = $f347e48613385d9c$var$parseForExpression(expression);
    let evaluateItems = $f347e48613385d9c$var$evaluateLater(el, iteratorNames.items);
    let evaluateKey = $f347e48613385d9c$var$evaluateLater(el, // the x-bind:key expression is stored for our use instead of evaluated.
    el._x_keyExpression || "index");
    el._x_prevKeys = [];
    el._x_lookup = {};
    effect3(()=>$f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey));
    cleanup2(()=>{
        Object.values(el._x_lookup).forEach((el2)=>$f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(el2);
                el2.remove();
            }));
        delete el._x_prevKeys;
        delete el._x_lookup;
    });
});
function $f347e48613385d9c$var$loop(el, iteratorNames, evaluateItems, evaluateKey) {
    let isObject2 = (i)=>typeof i === "object" && !Array.isArray(i);
    let templateEl = el;
    evaluateItems((items)=>{
        if ($f347e48613385d9c$var$isNumeric3(items) && items >= 0) items = Array.from(Array(items).keys(), (i)=>i + 1);
        if (items === void 0) items = [];
        let lookup = el._x_lookup;
        let prevKeys = el._x_prevKeys;
        let scopes = [];
        let keys = [];
        if (isObject2(items)) items = Object.entries(items).map(([key, value])=>{
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, value, key, items);
            evaluateKey((value2)=>{
                if (keys.includes(value2)) $f347e48613385d9c$var$warn("Duplicate key on x-for", el);
                keys.push(value2);
            }, {
                scope: {
                    index: key,
                    ...scope2
                }
            });
            scopes.push(scope2);
        });
        else for(let i = 0; i < items.length; i++){
            let scope2 = $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, items[i], i, items);
            evaluateKey((value)=>{
                if (keys.includes(value)) $f347e48613385d9c$var$warn("Duplicate key on x-for", el);
                keys.push(value);
            }, {
                scope: {
                    index: i,
                    ...scope2
                }
            });
            scopes.push(scope2);
        }
        let adds = [];
        let moves = [];
        let removes = [];
        let sames = [];
        for(let i = 0; i < prevKeys.length; i++){
            let key = prevKeys[i];
            if (keys.indexOf(key) === -1) removes.push(key);
        }
        prevKeys = prevKeys.filter((key)=>!removes.includes(key));
        let lastKey = "template";
        for(let i = 0; i < keys.length; i++){
            let key = keys[i];
            let prevIndex = prevKeys.indexOf(key);
            if (prevIndex === -1) {
                prevKeys.splice(i, 0, key);
                adds.push([
                    lastKey,
                    i
                ]);
            } else if (prevIndex !== i) {
                let keyInSpot = prevKeys.splice(i, 1)[0];
                let keyForSpot = prevKeys.splice(prevIndex - 1, 1)[0];
                prevKeys.splice(i, 0, keyForSpot);
                prevKeys.splice(prevIndex, 0, keyInSpot);
                moves.push([
                    keyInSpot,
                    keyForSpot
                ]);
            } else sames.push(key);
            lastKey = key;
        }
        for(let i = 0; i < removes.length; i++){
            let key = removes[i];
            if (!(key in lookup)) continue;
            $f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(lookup[key]);
                lookup[key].remove();
            });
            delete lookup[key];
        }
        for(let i = 0; i < moves.length; i++){
            let [keyInSpot, keyForSpot] = moves[i];
            let elInSpot = lookup[keyInSpot];
            let elForSpot = lookup[keyForSpot];
            let marker = document.createElement("div");
            $f347e48613385d9c$var$mutateDom(()=>{
                if (!elForSpot) $f347e48613385d9c$var$warn(`x-for ":key" is undefined or invalid`, templateEl, keyForSpot, lookup);
                elForSpot.after(marker);
                elInSpot.after(elForSpot);
                elForSpot._x_currentIfEl && elForSpot.after(elForSpot._x_currentIfEl);
                marker.before(elInSpot);
                elInSpot._x_currentIfEl && elInSpot.after(elInSpot._x_currentIfEl);
                marker.remove();
            });
            elForSpot._x_refreshXForScope(scopes[keys.indexOf(keyForSpot)]);
        }
        for(let i = 0; i < adds.length; i++){
            let [lastKey2, index] = adds[i];
            let lastEl = lastKey2 === "template" ? templateEl : lookup[lastKey2];
            if (lastEl._x_currentIfEl) lastEl = lastEl._x_currentIfEl;
            let scope2 = scopes[index];
            let key = keys[index];
            let clone2 = document.importNode(templateEl.content, true).firstElementChild;
            let reactiveScope = $f347e48613385d9c$var$reactive(scope2);
            $f347e48613385d9c$var$addScopeToNode(clone2, reactiveScope, templateEl);
            clone2._x_refreshXForScope = (newScope)=>{
                Object.entries(newScope).forEach(([key2, value])=>{
                    reactiveScope[key2] = value;
                });
            };
            $f347e48613385d9c$var$mutateDom(()=>{
                lastEl.after(clone2);
                $f347e48613385d9c$var$skipDuringClone(()=>$f347e48613385d9c$var$initTree(clone2))();
            });
            if (typeof key === "object") $f347e48613385d9c$var$warn("x-for key cannot be an object, it must be a string or an integer", templateEl);
            lookup[key] = clone2;
        }
        for(let i = 0; i < sames.length; i++)lookup[sames[i]]._x_refreshXForScope(scopes[keys.indexOf(sames[i])]);
        templateEl._x_prevKeys = keys;
    });
}
function $f347e48613385d9c$var$parseForExpression(expression) {
    let forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
    let stripParensRE = /^\s*\(|\)\s*$/g;
    let forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
    let inMatch = expression.match(forAliasRE);
    if (!inMatch) return;
    let res = {};
    res.items = inMatch[2].trim();
    let item = inMatch[1].replace(stripParensRE, "").trim();
    let iteratorMatch = item.match(forIteratorRE);
    if (iteratorMatch) {
        res.item = item.replace(forIteratorRE, "").trim();
        res.index = iteratorMatch[1].trim();
        if (iteratorMatch[2]) res.collection = iteratorMatch[2].trim();
    } else res.item = item;
    return res;
}
function $f347e48613385d9c$var$getIterationScopeVariables(iteratorNames, item, index, items) {
    let scopeVariables = {};
    if (/^\[.*\]$/.test(iteratorNames.item) && Array.isArray(item)) {
        let names = iteratorNames.item.replace("[", "").replace("]", "").split(",").map((i)=>i.trim());
        names.forEach((name, i)=>{
            scopeVariables[name] = item[i];
        });
    } else if (/^\{.*\}$/.test(iteratorNames.item) && !Array.isArray(item) && typeof item === "object") {
        let names = iteratorNames.item.replace("{", "").replace("}", "").split(",").map((i)=>i.trim());
        names.forEach((name)=>{
            scopeVariables[name] = item[name];
        });
    } else scopeVariables[iteratorNames.item] = item;
    if (iteratorNames.index) scopeVariables[iteratorNames.index] = index;
    if (iteratorNames.collection) scopeVariables[iteratorNames.collection] = items;
    return scopeVariables;
}
function $f347e48613385d9c$var$isNumeric3(subject) {
    return !Array.isArray(subject) && !isNaN(subject);
}
// packages/alpinejs/src/directives/x-ref.js
function $f347e48613385d9c$var$handler3() {}
$f347e48613385d9c$var$handler3.inline = (el, { expression: expression }, { cleanup: cleanup2 })=>{
    let root = $f347e48613385d9c$var$closestRoot(el);
    if (!root._x_refs) root._x_refs = {};
    root._x_refs[expression] = el;
    cleanup2(()=>delete root._x_refs[expression]);
};
$f347e48613385d9c$var$directive("ref", $f347e48613385d9c$var$handler3);
// packages/alpinejs/src/directives/x-if.js
$f347e48613385d9c$var$directive("if", (el, { expression: expression }, { effect: effect3, cleanup: cleanup2 })=>{
    if (el.tagName.toLowerCase() !== "template") $f347e48613385d9c$var$warn("x-if can only be used on a <template> tag", el);
    let evaluate2 = $f347e48613385d9c$var$evaluateLater(el, expression);
    let show = ()=>{
        if (el._x_currentIfEl) return el._x_currentIfEl;
        let clone2 = el.content.cloneNode(true).firstElementChild;
        $f347e48613385d9c$var$addScopeToNode(clone2, {}, el);
        $f347e48613385d9c$var$mutateDom(()=>{
            el.after(clone2);
            $f347e48613385d9c$var$skipDuringClone(()=>$f347e48613385d9c$var$initTree(clone2))();
        });
        el._x_currentIfEl = clone2;
        el._x_undoIf = ()=>{
            $f347e48613385d9c$var$mutateDom(()=>{
                $f347e48613385d9c$var$destroyTree(clone2);
                clone2.remove();
            });
            delete el._x_currentIfEl;
        };
        return clone2;
    };
    let hide = ()=>{
        if (!el._x_undoIf) return;
        el._x_undoIf();
        delete el._x_undoIf;
    };
    effect3(()=>evaluate2((value)=>{
            value ? show() : hide();
        }));
    cleanup2(()=>el._x_undoIf && el._x_undoIf());
});
// packages/alpinejs/src/directives/x-id.js
$f347e48613385d9c$var$directive("id", (el, { expression: expression }, { evaluate: evaluate2 })=>{
    let names = evaluate2(expression);
    names.forEach((name)=>$f347e48613385d9c$var$setIdRoot(el, name));
});
$f347e48613385d9c$var$interceptClone((from, to)=>{
    if (from._x_ids) to._x_ids = from._x_ids;
});
// packages/alpinejs/src/directives/x-on.js
$f347e48613385d9c$var$mapAttributes($f347e48613385d9c$var$startingWith("@", $f347e48613385d9c$var$into($f347e48613385d9c$var$prefix("on:"))));
$f347e48613385d9c$var$directive("on", $f347e48613385d9c$var$skipDuringClone((el, { value: value, modifiers: modifiers, expression: expression }, { cleanup: cleanup2 })=>{
    let evaluate2 = expression ? $f347e48613385d9c$var$evaluateLater(el, expression) : ()=>{};
    if (el.tagName.toLowerCase() === "template") {
        if (!el._x_forwardEvents) el._x_forwardEvents = [];
        if (!el._x_forwardEvents.includes(value)) el._x_forwardEvents.push(value);
    }
    let removeListener = $f347e48613385d9c$var$on(el, value, modifiers, (e)=>{
        evaluate2(()=>{}, {
            scope: {
                "$event": e
            },
            params: [
                e
            ]
        });
    });
    cleanup2(()=>removeListener());
}));
// packages/alpinejs/src/directives/index.js
$f347e48613385d9c$var$warnMissingPluginDirective("Collapse", "collapse", "collapse");
$f347e48613385d9c$var$warnMissingPluginDirective("Intersect", "intersect", "intersect");
$f347e48613385d9c$var$warnMissingPluginDirective("Focus", "trap", "focus");
$f347e48613385d9c$var$warnMissingPluginDirective("Mask", "mask", "mask");
function $f347e48613385d9c$var$warnMissingPluginDirective(name, directiveName, slug) {
    $f347e48613385d9c$var$directive(directiveName, (el)=>$f347e48613385d9c$var$warn(`You can't use [x-${directiveName}] without first installing the "${name}" plugin here: https://alpinejs.dev/plugins/${slug}`, el));
}
// packages/alpinejs/src/index.js
$f347e48613385d9c$var$alpine_default.setEvaluator($f347e48613385d9c$var$normalEvaluator);
$f347e48613385d9c$var$alpine_default.setReactivityEngine({
    reactive: $f347e48613385d9c$var$reactive2,
    effect: $f347e48613385d9c$var$effect2,
    release: $f347e48613385d9c$var$stop,
    raw: $f347e48613385d9c$var$toRaw
});
var $f347e48613385d9c$export$b7ee041e4ad2afec = $f347e48613385d9c$var$alpine_default;
// packages/alpinejs/builds/module.js
var $f347e48613385d9c$export$2e2bcd8739ae039 = $f347e48613385d9c$export$b7ee041e4ad2afec;



var $ojnWK = parcelRequire("ojnWK");
var $9e1724f0f41c40ad$exports = {};
/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */ (function(window1, document1, exportName, undefined) {
    'use strict';
    var VENDOR_PREFIXES = [
        '',
        'webkit',
        'Moz',
        'MS',
        'ms',
        'o'
    ];
    var TEST_ELEMENT = document1.createElement('div');
    var TYPE_FUNCTION = 'function';
    var round = Math.round;
    var abs = Math.abs;
    var now = Date.now;
    /**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */ function setTimeoutContext(fn, timeout, context) {
        return setTimeout(bindFn(fn, context), timeout);
    }
    /**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */ function invokeArrayArg(arg, fn, context) {
        if (Array.isArray(arg)) {
            each(arg, context[fn], context);
            return true;
        }
        return false;
    }
    /**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */ function each(obj, iterator, context) {
        var i;
        if (!obj) return;
        if (obj.forEach) obj.forEach(iterator, context);
        else if (obj.length !== undefined) {
            i = 0;
            while(i < obj.length){
                iterator.call(context, obj[i], i, obj);
                i++;
            }
        } else for(i in obj)obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
    }
    /**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */ function deprecate(method, name, message) {
        var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
        return function() {
            var e = new Error('get-stack-trace');
            var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '').replace(/^\s+at\s+/gm, '').replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';
            var log = window1.console && (window1.console.warn || window1.console.log);
            if (log) log.call(window1.console, deprecationMessage, stack);
            return method.apply(this, arguments);
        };
    }
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */ var assign;
    if (typeof Object.assign !== 'function') assign = function assign(target) {
        if (target === undefined || target === null) throw new TypeError('Cannot convert undefined or null to object');
        var output = Object(target);
        for(var index = 1; index < arguments.length; index++){
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for(var nextKey in source)if (source.hasOwnProperty(nextKey)) output[nextKey] = source[nextKey];
            }
        }
        return output;
    };
    else assign = Object.assign;
    /**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */ var extend = deprecate(function extend(dest, src, merge) {
        var keys = Object.keys(src);
        var i = 0;
        while(i < keys.length){
            if (!merge || merge && dest[keys[i]] === undefined) dest[keys[i]] = src[keys[i]];
            i++;
        }
        return dest;
    }, 'extend', 'Use `assign`.');
    /**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */ var merge = deprecate(function merge(dest, src) {
        return extend(dest, src, true);
    }, 'merge', 'Use `assign`.');
    /**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */ function inherit(child, base, properties) {
        var baseP = base.prototype, childP;
        childP = child.prototype = Object.create(baseP);
        childP.constructor = child;
        childP._super = baseP;
        if (properties) assign(childP, properties);
    }
    /**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */ function bindFn(fn, context) {
        return function boundFn() {
            return fn.apply(context, arguments);
        };
    }
    /**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */ function boolOrFn(val, args) {
        if (typeof val == TYPE_FUNCTION) return val.apply(args ? args[0] || undefined : undefined, args);
        return val;
    }
    /**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */ function ifUndefined(val1, val2) {
        return val1 === undefined ? val2 : val1;
    }
    /**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function addEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.addEventListener(type, handler, false);
        });
    }
    /**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */ function removeEventListeners(target, types, handler) {
        each(splitStr(types), function(type) {
            target.removeEventListener(type, handler, false);
        });
    }
    /**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */ function hasParent(node, parent) {
        while(node){
            if (node == parent) return true;
            node = node.parentNode;
        }
        return false;
    }
    /**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */ function inStr(str, find) {
        return str.indexOf(find) > -1;
    }
    /**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */ function splitStr(str) {
        return str.trim().split(/\s+/g);
    }
    /**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */ function inArray(src, find, findByKey) {
        if (src.indexOf && !findByKey) return src.indexOf(find);
        else {
            var i = 0;
            while(i < src.length){
                if (findByKey && src[i][findByKey] == find || !findByKey && src[i] === find) return i;
                i++;
            }
            return -1;
        }
    }
    /**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */ function toArray(obj) {
        return Array.prototype.slice.call(obj, 0);
    }
    /**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */ function uniqueArray(src, key, sort) {
        var results = [];
        var values = [];
        var i = 0;
        while(i < src.length){
            var val = key ? src[i][key] : src[i];
            if (inArray(values, val) < 0) results.push(src[i]);
            values[i] = val;
            i++;
        }
        if (sort) {
            if (!key) results = results.sort();
            else results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
        return results;
    }
    /**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */ function prefixed(obj, property) {
        var prefix, prop;
        var camelProp = property[0].toUpperCase() + property.slice(1);
        var i = 0;
        while(i < VENDOR_PREFIXES.length){
            prefix = VENDOR_PREFIXES[i];
            prop = prefix ? prefix + camelProp : property;
            if (prop in obj) return prop;
            i++;
        }
        return undefined;
    }
    /**
 * get a unique id
 * @returns {number} uniqueId
 */ var _uniqueId = 1;
    function uniqueId() {
        return _uniqueId++;
    }
    /**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */ function getWindowForElement(element) {
        var doc = element.ownerDocument || element;
        return doc.defaultView || doc.parentWindow || window1;
    }
    var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;
    var SUPPORT_TOUCH = 'ontouchstart' in window1;
    var SUPPORT_POINTER_EVENTS = prefixed(window1, 'PointerEvent') !== undefined;
    var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);
    var INPUT_TYPE_TOUCH = 'touch';
    var INPUT_TYPE_PEN = 'pen';
    var INPUT_TYPE_MOUSE = 'mouse';
    var INPUT_TYPE_KINECT = 'kinect';
    var COMPUTE_INTERVAL = 25;
    var INPUT_START = 1;
    var INPUT_MOVE = 2;
    var INPUT_END = 4;
    var INPUT_CANCEL = 8;
    var DIRECTION_NONE = 1;
    var DIRECTION_LEFT = 2;
    var DIRECTION_RIGHT = 4;
    var DIRECTION_UP = 8;
    var DIRECTION_DOWN = 16;
    var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
    var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
    var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;
    var PROPS_XY = [
        'x',
        'y'
    ];
    var PROPS_CLIENT_XY = [
        'clientX',
        'clientY'
    ];
    /**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */ function Input(manager, callback) {
        var self1 = this;
        this.manager = manager;
        this.callback = callback;
        this.element = manager.element;
        this.target = manager.options.inputTarget;
        // smaller wrapper around the handler, for the scope and the enabled state of the manager,
        // so when disabled the input events are completely bypassed.
        this.domHandler = function(ev) {
            if (boolOrFn(manager.options.enable, [
                manager
            ])) self1.handler(ev);
        };
        this.init();
    }
    Input.prototype = {
        /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */ handler: function() {},
        /**
     * bind the events
     */ init: function() {
            this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        },
        /**
     * unbind the events
     */ destroy: function() {
            this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
            this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
            this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
        }
    };
    /**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */ function createInputInstance(manager) {
        var Type;
        var inputClass = manager.options.inputClass;
        if (inputClass) Type = inputClass;
        else if (SUPPORT_POINTER_EVENTS) Type = PointerEventInput;
        else if (SUPPORT_ONLY_TOUCH) Type = TouchInput;
        else if (!SUPPORT_TOUCH) Type = MouseInput;
        else Type = TouchMouseInput;
        return new Type(manager, inputHandler);
    }
    /**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */ function inputHandler(manager, eventType, input) {
        var pointersLen = input.pointers.length;
        var changedPointersLen = input.changedPointers.length;
        var isFirst = eventType & INPUT_START && pointersLen - changedPointersLen === 0;
        var isFinal = eventType & (INPUT_END | INPUT_CANCEL) && pointersLen - changedPointersLen === 0;
        input.isFirst = !!isFirst;
        input.isFinal = !!isFinal;
        if (isFirst) manager.session = {};
        // source event is the normalized value of the domEvents
        // like 'touchstart, mouseup, pointerdown'
        input.eventType = eventType;
        // compute scale, rotation etc
        computeInputData(manager, input);
        // emit secret event
        manager.emit('hammer.input', input);
        manager.recognize(input);
        manager.session.prevInput = input;
    }
    /**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */ function computeInputData(manager, input) {
        var session = manager.session;
        var pointers = input.pointers;
        var pointersLength = pointers.length;
        // store the first input to calculate the distance and direction
        if (!session.firstInput) session.firstInput = simpleCloneInputData(input);
        // to compute scale and rotation we need to store the multiple touches
        if (pointersLength > 1 && !session.firstMultiple) session.firstMultiple = simpleCloneInputData(input);
        else if (pointersLength === 1) session.firstMultiple = false;
        var firstInput = session.firstInput;
        var firstMultiple = session.firstMultiple;
        var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;
        var center = input.center = getCenter(pointers);
        input.timeStamp = now();
        input.deltaTime = input.timeStamp - firstInput.timeStamp;
        input.angle = getAngle(offsetCenter, center);
        input.distance = getDistance(offsetCenter, center);
        computeDeltaXY(session, input);
        input.offsetDirection = getDirection(input.deltaX, input.deltaY);
        var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
        input.overallVelocityX = overallVelocity.x;
        input.overallVelocityY = overallVelocity.y;
        input.overallVelocity = abs(overallVelocity.x) > abs(overallVelocity.y) ? overallVelocity.x : overallVelocity.y;
        input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
        input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;
        input.maxPointers = !session.prevInput ? input.pointers.length : input.pointers.length > session.prevInput.maxPointers ? input.pointers.length : session.prevInput.maxPointers;
        computeIntervalInputData(session, input);
        // find the correct target
        var target = manager.element;
        if (hasParent(input.srcEvent.target, target)) target = input.srcEvent.target;
        input.target = target;
    }
    function computeDeltaXY(session, input) {
        var center = input.center;
        var offset = session.offsetDelta || {};
        var prevDelta = session.prevDelta || {};
        var prevInput = session.prevInput || {};
        if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
            prevDelta = session.prevDelta = {
                x: prevInput.deltaX || 0,
                y: prevInput.deltaY || 0
            };
            offset = session.offsetDelta = {
                x: center.x,
                y: center.y
            };
        }
        input.deltaX = prevDelta.x + (center.x - offset.x);
        input.deltaY = prevDelta.y + (center.y - offset.y);
    }
    /**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */ function computeIntervalInputData(session, input) {
        var last = session.lastInterval || input, deltaTime = input.timeStamp - last.timeStamp, velocity, velocityX, velocityY, direction;
        if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
            var deltaX = input.deltaX - last.deltaX;
            var deltaY = input.deltaY - last.deltaY;
            var v = getVelocity(deltaTime, deltaX, deltaY);
            velocityX = v.x;
            velocityY = v.y;
            velocity = abs(v.x) > abs(v.y) ? v.x : v.y;
            direction = getDirection(deltaX, deltaY);
            session.lastInterval = input;
        } else {
            // use latest velocity info if it doesn't overtake a minimum period
            velocity = last.velocity;
            velocityX = last.velocityX;
            velocityY = last.velocityY;
            direction = last.direction;
        }
        input.velocity = velocity;
        input.velocityX = velocityX;
        input.velocityY = velocityY;
        input.direction = direction;
    }
    /**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */ function simpleCloneInputData(input) {
        // make a simple copy of the pointers because we will get a reference if we don't
        // we only need clientXY for the calculations
        var pointers = [];
        var i = 0;
        while(i < input.pointers.length){
            pointers[i] = {
                clientX: round(input.pointers[i].clientX),
                clientY: round(input.pointers[i].clientY)
            };
            i++;
        }
        return {
            timeStamp: now(),
            pointers: pointers,
            center: getCenter(pointers),
            deltaX: input.deltaX,
            deltaY: input.deltaY
        };
    }
    /**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */ function getCenter(pointers) {
        var pointersLength = pointers.length;
        // no need to loop when only one touch
        if (pointersLength === 1) return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
        var x = 0, y = 0, i = 0;
        while(i < pointersLength){
            x += pointers[i].clientX;
            y += pointers[i].clientY;
            i++;
        }
        return {
            x: round(x / pointersLength),
            y: round(y / pointersLength)
        };
    }
    /**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */ function getVelocity(deltaTime, x, y) {
        return {
            x: x / deltaTime || 0,
            y: y / deltaTime || 0
        };
    }
    /**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */ function getDirection(x, y) {
        if (x === y) return DIRECTION_NONE;
        if (abs(x) >= abs(y)) return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
        return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
    }
    /**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */ function getDistance(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.sqrt(x * x + y * y);
    }
    /**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */ function getAngle(p1, p2, props) {
        if (!props) props = PROPS_XY;
        var x = p2[props[0]] - p1[props[0]], y = p2[props[1]] - p1[props[1]];
        return Math.atan2(y, x) * 180 / Math.PI;
    }
    /**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */ function getRotation(start, end) {
        return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
    }
    /**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */ function getScale(start, end) {
        return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
    }
    var MOUSE_INPUT_MAP = {
        mousedown: INPUT_START,
        mousemove: INPUT_MOVE,
        mouseup: INPUT_END
    };
    var MOUSE_ELEMENT_EVENTS = 'mousedown';
    var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';
    /**
 * Mouse events input
 * @constructor
 * @extends Input
 */ function MouseInput() {
        this.evEl = MOUSE_ELEMENT_EVENTS;
        this.evWin = MOUSE_WINDOW_EVENTS;
        this.pressed = false; // mousedown state
        Input.apply(this, arguments);
    }
    inherit(MouseInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function MEhandler(ev) {
            var eventType = MOUSE_INPUT_MAP[ev.type];
            // on start we want to have the left mouse button down
            if (eventType & INPUT_START && ev.button === 0) this.pressed = true;
            if (eventType & INPUT_MOVE && ev.which !== 1) eventType = INPUT_END;
            // mouse must be down
            if (!this.pressed) return;
            if (eventType & INPUT_END) this.pressed = false;
            this.callback(this.manager, eventType, {
                pointers: [
                    ev
                ],
                changedPointers: [
                    ev
                ],
                pointerType: INPUT_TYPE_MOUSE,
                srcEvent: ev
            });
        }
    });
    var POINTER_INPUT_MAP = {
        pointerdown: INPUT_START,
        pointermove: INPUT_MOVE,
        pointerup: INPUT_END,
        pointercancel: INPUT_CANCEL,
        pointerout: INPUT_CANCEL
    };
    // in IE10 the pointer types is defined as an enum
    var IE10_POINTER_TYPE_ENUM = {
        2: INPUT_TYPE_TOUCH,
        3: INPUT_TYPE_PEN,
        4: INPUT_TYPE_MOUSE,
        5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
    };
    var POINTER_ELEMENT_EVENTS = 'pointerdown';
    var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';
    // IE10 has prefixed support, and case-sensitive
    if (window1.MSPointerEvent && !window1.PointerEvent) {
        POINTER_ELEMENT_EVENTS = 'MSPointerDown';
        POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
    }
    /**
 * Pointer events input
 * @constructor
 * @extends Input
 */ function PointerEventInput() {
        this.evEl = POINTER_ELEMENT_EVENTS;
        this.evWin = POINTER_WINDOW_EVENTS;
        Input.apply(this, arguments);
        this.store = this.manager.session.pointerEvents = [];
    }
    inherit(PointerEventInput, Input, {
        /**
     * handle mouse events
     * @param {Object} ev
     */ handler: function PEhandler(ev) {
            var store = this.store;
            var removePointer = false;
            var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
            var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
            var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;
            var isTouch = pointerType == INPUT_TYPE_TOUCH;
            // get index of the event in the store
            var storeIndex = inArray(store, ev.pointerId, 'pointerId');
            // start and mouse must be down
            if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
                if (storeIndex < 0) {
                    store.push(ev);
                    storeIndex = store.length - 1;
                }
            } else if (eventType & (INPUT_END | INPUT_CANCEL)) removePointer = true;
            // it not found, so the pointer hasn't been down (so it's probably a hover)
            if (storeIndex < 0) return;
            // update the event in the store
            store[storeIndex] = ev;
            this.callback(this.manager, eventType, {
                pointers: store,
                changedPointers: [
                    ev
                ],
                pointerType: pointerType,
                srcEvent: ev
            });
            if (removePointer) // remove from the store
            store.splice(storeIndex, 1);
        }
    });
    var SINGLE_TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
    var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
 * Touch events input
 * @constructor
 * @extends Input
 */ function SingleTouchInput() {
        this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
        this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
        this.started = false;
        Input.apply(this, arguments);
    }
    inherit(SingleTouchInput, Input, {
        handler: function TEhandler(ev) {
            var type = SINGLE_TOUCH_INPUT_MAP[ev.type];
            // should we handle the touch events?
            if (type === INPUT_START) this.started = true;
            if (!this.started) return;
            var touches = normalizeSingleTouches.call(this, ev, type);
            // when done, reset the started state
            if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) this.started = false;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function normalizeSingleTouches(ev, type) {
        var all = toArray(ev.touches);
        var changed = toArray(ev.changedTouches);
        if (type & (INPUT_END | INPUT_CANCEL)) all = uniqueArray(all.concat(changed), 'identifier', true);
        return [
            all,
            changed
        ];
    }
    var TOUCH_INPUT_MAP = {
        touchstart: INPUT_START,
        touchmove: INPUT_MOVE,
        touchend: INPUT_END,
        touchcancel: INPUT_CANCEL
    };
    var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';
    /**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */ function TouchInput() {
        this.evTarget = TOUCH_TARGET_EVENTS;
        this.targetIds = {};
        Input.apply(this, arguments);
    }
    inherit(TouchInput, Input, {
        handler: function MTEhandler(ev) {
            var type = TOUCH_INPUT_MAP[ev.type];
            var touches = getTouches.call(this, ev, type);
            if (!touches) return;
            this.callback(this.manager, type, {
                pointers: touches[0],
                changedPointers: touches[1],
                pointerType: INPUT_TYPE_TOUCH,
                srcEvent: ev
            });
        }
    });
    /**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */ function getTouches(ev, type) {
        var allTouches = toArray(ev.touches);
        var targetIds = this.targetIds;
        // when there is only one touch, the process can be simplified
        if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
            targetIds[allTouches[0].identifier] = true;
            return [
                allTouches,
                allTouches
            ];
        }
        var i, targetTouches, changedTouches = toArray(ev.changedTouches), changedTargetTouches = [], target = this.target;
        // get target touches from touches
        targetTouches = allTouches.filter(function(touch) {
            return hasParent(touch.target, target);
        });
        // collect touches
        if (type === INPUT_START) {
            i = 0;
            while(i < targetTouches.length){
                targetIds[targetTouches[i].identifier] = true;
                i++;
            }
        }
        // filter changed touches to only contain touches that exist in the collected target ids
        i = 0;
        while(i < changedTouches.length){
            if (targetIds[changedTouches[i].identifier]) changedTargetTouches.push(changedTouches[i]);
            // cleanup removed touches
            if (type & (INPUT_END | INPUT_CANCEL)) delete targetIds[changedTouches[i].identifier];
            i++;
        }
        if (!changedTargetTouches.length) return;
        return [
            // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
            uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
            changedTargetTouches
        ];
    }
    /**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */ var DEDUP_TIMEOUT = 2500;
    var DEDUP_DISTANCE = 25;
    function TouchMouseInput() {
        Input.apply(this, arguments);
        var handler = bindFn(this.handler, this);
        this.touch = new TouchInput(this.manager, handler);
        this.mouse = new MouseInput(this.manager, handler);
        this.primaryTouch = null;
        this.lastTouches = [];
    }
    inherit(TouchMouseInput, Input, {
        /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */ handler: function TMEhandler(manager, inputEvent, inputData) {
            var isTouch = inputData.pointerType == INPUT_TYPE_TOUCH, isMouse = inputData.pointerType == INPUT_TYPE_MOUSE;
            if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) return;
            // when we're in a touch event, record touches to  de-dupe synthetic mouse event
            if (isTouch) recordTouches.call(this, inputEvent, inputData);
            else if (isMouse && isSyntheticEvent.call(this, inputData)) return;
            this.callback(manager, inputEvent, inputData);
        },
        /**
     * remove the event listeners
     */ destroy: function destroy() {
            this.touch.destroy();
            this.mouse.destroy();
        }
    });
    function recordTouches(eventType, eventData) {
        if (eventType & INPUT_START) {
            this.primaryTouch = eventData.changedPointers[0].identifier;
            setLastTouch.call(this, eventData);
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) setLastTouch.call(this, eventData);
    }
    function setLastTouch(eventData) {
        var touch = eventData.changedPointers[0];
        if (touch.identifier === this.primaryTouch) {
            var lastTouch = {
                x: touch.clientX,
                y: touch.clientY
            };
            this.lastTouches.push(lastTouch);
            var lts = this.lastTouches;
            var removeLastTouch = function() {
                var i = lts.indexOf(lastTouch);
                if (i > -1) lts.splice(i, 1);
            };
            setTimeout(removeLastTouch, DEDUP_TIMEOUT);
        }
    }
    function isSyntheticEvent(eventData) {
        var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
        for(var i = 0; i < this.lastTouches.length; i++){
            var t = this.lastTouches[i];
            var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
            if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) return true;
        }
        return false;
    }
    var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
    var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;
    // magical touchAction value
    var TOUCH_ACTION_COMPUTE = 'compute';
    var TOUCH_ACTION_AUTO = 'auto';
    var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
    var TOUCH_ACTION_NONE = 'none';
    var TOUCH_ACTION_PAN_X = 'pan-x';
    var TOUCH_ACTION_PAN_Y = 'pan-y';
    var TOUCH_ACTION_MAP = getTouchActionProps();
    /**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */ function TouchAction(manager, value) {
        this.manager = manager;
        this.set(value);
    }
    TouchAction.prototype = {
        /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */ set: function(value) {
            // find out the touch-action by the event handlers
            if (value == TOUCH_ACTION_COMPUTE) value = this.compute();
            if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
            this.actions = value.toLowerCase().trim();
        },
        /**
     * just re-set the touchAction value
     */ update: function() {
            this.set(this.manager.options.touchAction);
        },
        /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */ compute: function() {
            var actions = [];
            each(this.manager.recognizers, function(recognizer) {
                if (boolOrFn(recognizer.options.enable, [
                    recognizer
                ])) actions = actions.concat(recognizer.getTouchAction());
            });
            return cleanTouchActions(actions.join(' '));
        },
        /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */ preventDefaults: function(input) {
            var srcEvent = input.srcEvent;
            var direction = input.offsetDirection;
            // if the touch action did prevented once this session
            if (this.manager.session.prevented) {
                srcEvent.preventDefault();
                return;
            }
            var actions = this.actions;
            var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
            var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
            var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];
            if (hasNone) {
                //do not prevent defaults if this is a tap gesture
                var isTapPointer = input.pointers.length === 1;
                var isTapMovement = input.distance < 2;
                var isTapTouchTime = input.deltaTime < 250;
                if (isTapPointer && isTapMovement && isTapTouchTime) return;
            }
            if (hasPanX && hasPanY) // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
            if (hasNone || hasPanY && direction & DIRECTION_HORIZONTAL || hasPanX && direction & DIRECTION_VERTICAL) return this.preventSrc(srcEvent);
        },
        /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */ preventSrc: function(srcEvent) {
            this.manager.session.prevented = true;
            srcEvent.preventDefault();
        }
    };
    /**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */ function cleanTouchActions(actions) {
        // none
        if (inStr(actions, TOUCH_ACTION_NONE)) return TOUCH_ACTION_NONE;
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);
        // if both pan-x and pan-y are set (different recognizers
        // for different directions, e.g. horizontal pan but vertical swipe?)
        // we need none (as otherwise with pan-x pan-y combined none of these
        // recognizers will work, since the browser would handle all panning
        if (hasPanX && hasPanY) return TOUCH_ACTION_NONE;
        // pan-x OR pan-y
        if (hasPanX || hasPanY) return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
        // manipulation
        if (inStr(actions, TOUCH_ACTION_MANIPULATION)) return TOUCH_ACTION_MANIPULATION;
        return TOUCH_ACTION_AUTO;
    }
    function getTouchActionProps() {
        if (!NATIVE_TOUCH_ACTION) return false;
        var touchMap = {};
        var cssSupports = window1.CSS && window1.CSS.supports;
        [
            'auto',
            'manipulation',
            'pan-y',
            'pan-x',
            'pan-x pan-y',
            'none'
        ].forEach(function(val) {
            // If css.supports is not supported but there is native touch-action assume it supports
            // all values. This is the case for IE 10 and 11.
            touchMap[val] = cssSupports ? window1.CSS.supports('touch-action', val) : true;
        });
        return touchMap;
    }
    /**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */ var STATE_POSSIBLE = 1;
    var STATE_BEGAN = 2;
    var STATE_CHANGED = 4;
    var STATE_ENDED = 8;
    var STATE_RECOGNIZED = STATE_ENDED;
    var STATE_CANCELLED = 16;
    var STATE_FAILED = 32;
    /**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */ function Recognizer(options) {
        this.options = assign({}, this.defaults, options || {});
        this.id = uniqueId();
        this.manager = null;
        // default is enable true
        this.options.enable = ifUndefined(this.options.enable, true);
        this.state = STATE_POSSIBLE;
        this.simultaneous = {};
        this.requireFail = [];
    }
    Recognizer.prototype = {
        /**
     * @virtual
     * @type {Object}
     */ defaults: {},
        /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */ set: function(options) {
            assign(this.options, options);
            // also update the touchAction, in case something changed about the directions/enabled state
            this.manager && this.manager.touchAction.update();
            return this;
        },
        /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ recognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) return this;
            var simultaneous = this.simultaneous;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (!simultaneous[otherRecognizer.id]) {
                simultaneous[otherRecognizer.id] = otherRecognizer;
                otherRecognizer.recognizeWith(this);
            }
            return this;
        },
        /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRecognizeWith: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            delete this.simultaneous[otherRecognizer.id];
            return this;
        },
        /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ requireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) return this;
            var requireFail = this.requireFail;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            if (inArray(requireFail, otherRecognizer) === -1) {
                requireFail.push(otherRecognizer);
                otherRecognizer.requireFailure(this);
            }
            return this;
        },
        /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */ dropRequireFailure: function(otherRecognizer) {
            if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) return this;
            otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
            var index = inArray(this.requireFail, otherRecognizer);
            if (index > -1) this.requireFail.splice(index, 1);
            return this;
        },
        /**
     * has require failures boolean
     * @returns {boolean}
     */ hasRequireFailures: function() {
            return this.requireFail.length > 0;
        },
        /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */ canRecognizeWith: function(otherRecognizer) {
            return !!this.simultaneous[otherRecognizer.id];
        },
        /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */ emit: function(input) {
            var self1 = this;
            var state = this.state;
            function emit(event) {
                self1.manager.emit(event, input);
            }
            // 'panstart' and 'panmove'
            if (state < STATE_ENDED) emit(self1.options.event + stateStr(state));
            emit(self1.options.event); // simple 'eventName' events
            if (input.additionalEvent) emit(input.additionalEvent);
            // panend and pancancel
            if (state >= STATE_ENDED) emit(self1.options.event + stateStr(state));
        },
        /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */ tryEmit: function(input) {
            if (this.canEmit()) return this.emit(input);
            // it's failing anyway
            this.state = STATE_FAILED;
        },
        /**
     * can we emit?
     * @returns {boolean}
     */ canEmit: function() {
            var i = 0;
            while(i < this.requireFail.length){
                if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) return false;
                i++;
            }
            return true;
        },
        /**
     * update the recognizer
     * @param {Object} inputData
     */ recognize: function(inputData) {
            // make a new copy of the inputData
            // so we can change the inputData without messing up the other recognizers
            var inputDataClone = assign({}, inputData);
            // is is enabled and allow recognizing?
            if (!boolOrFn(this.options.enable, [
                this,
                inputDataClone
            ])) {
                this.reset();
                this.state = STATE_FAILED;
                return;
            }
            // reset when we've reached the end
            if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) this.state = STATE_POSSIBLE;
            this.state = this.process(inputDataClone);
            // the recognizer has recognized a gesture
            // so trigger an event
            if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) this.tryEmit(inputDataClone);
        },
        /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */ process: function(inputData) {},
        /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */ getTouchAction: function() {},
        /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */ reset: function() {}
    };
    /**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */ function stateStr(state) {
        if (state & STATE_CANCELLED) return 'cancel';
        else if (state & STATE_ENDED) return 'end';
        else if (state & STATE_CHANGED) return 'move';
        else if (state & STATE_BEGAN) return 'start';
        return '';
    }
    /**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */ function directionStr(direction) {
        if (direction == DIRECTION_DOWN) return 'down';
        else if (direction == DIRECTION_UP) return 'up';
        else if (direction == DIRECTION_LEFT) return 'left';
        else if (direction == DIRECTION_RIGHT) return 'right';
        return '';
    }
    /**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */ function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
        var manager = recognizer.manager;
        if (manager) return manager.get(otherRecognizer);
        return otherRecognizer;
    }
    /**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */ function AttrRecognizer() {
        Recognizer.apply(this, arguments);
    }
    inherit(AttrRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof AttrRecognizer
     */ defaults: {
            /**
         * @type {Number}
         * @default 1
         */ pointers: 1
        },
        /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */ attrTest: function(input) {
            var optionPointers = this.options.pointers;
            return optionPointers === 0 || input.pointers.length === optionPointers;
        },
        /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */ process: function(input) {
            var state = this.state;
            var eventType = input.eventType;
            var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
            var isValid = this.attrTest(input);
            // on cancel input and we've recognized before, return STATE_CANCELLED
            if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) return state | STATE_CANCELLED;
            else if (isRecognized || isValid) {
                if (eventType & INPUT_END) return state | STATE_ENDED;
                else if (!(state & STATE_BEGAN)) return STATE_BEGAN;
                return state | STATE_CHANGED;
            }
            return STATE_FAILED;
        }
    });
    /**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function PanRecognizer() {
        AttrRecognizer.apply(this, arguments);
        this.pX = null;
        this.pY = null;
    }
    inherit(PanRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PanRecognizer
     */ defaults: {
            event: 'pan',
            threshold: 10,
            pointers: 1,
            direction: DIRECTION_ALL
        },
        getTouchAction: function() {
            var direction = this.options.direction;
            var actions = [];
            if (direction & DIRECTION_HORIZONTAL) actions.push(TOUCH_ACTION_PAN_Y);
            if (direction & DIRECTION_VERTICAL) actions.push(TOUCH_ACTION_PAN_X);
            return actions;
        },
        directionTest: function(input) {
            var options = this.options;
            var hasMoved = true;
            var distance = input.distance;
            var direction = input.direction;
            var x = input.deltaX;
            var y = input.deltaY;
            // lock to axis?
            if (!(direction & options.direction)) {
                if (options.direction & DIRECTION_HORIZONTAL) {
                    direction = x === 0 ? DIRECTION_NONE : x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
                    hasMoved = x != this.pX;
                    distance = Math.abs(input.deltaX);
                } else {
                    direction = y === 0 ? DIRECTION_NONE : y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
                    hasMoved = y != this.pY;
                    distance = Math.abs(input.deltaY);
                }
            }
            input.direction = direction;
            return hasMoved && distance > options.threshold && direction & options.direction;
        },
        attrTest: function(input) {
            return AttrRecognizer.prototype.attrTest.call(this, input) && (this.state & STATE_BEGAN || !(this.state & STATE_BEGAN) && this.directionTest(input));
        },
        emit: function(input) {
            this.pX = input.deltaX;
            this.pY = input.deltaY;
            var direction = directionStr(input.direction);
            if (direction) input.additionalEvent = this.options.event + direction;
            this._super.emit.call(this, input);
        }
    });
    /**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */ function PinchRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(PinchRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: 'pinch',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
        },
        emit: function(input) {
            if (input.scale !== 1) {
                var inOut = input.scale < 1 ? 'in' : 'out';
                input.additionalEvent = this.options.event + inOut;
            }
            this._super.emit.call(this, input);
        }
    });
    /**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */ function PressRecognizer() {
        Recognizer.apply(this, arguments);
        this._timer = null;
        this._input = null;
    }
    inherit(PressRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PressRecognizer
     */ defaults: {
            event: 'press',
            pointers: 1,
            time: 251,
            threshold: 9 // a minimal movement is ok, but keep it low
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_AUTO
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTime = input.deltaTime > options.time;
            this._input = input;
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (!validMovement || !validPointers || input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime) this.reset();
            else if (input.eventType & INPUT_START) {
                this.reset();
                this._timer = setTimeoutContext(function() {
                    this.state = STATE_RECOGNIZED;
                    this.tryEmit();
                }, options.time, this);
            } else if (input.eventType & INPUT_END) return STATE_RECOGNIZED;
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function(input) {
            if (this.state !== STATE_RECOGNIZED) return;
            if (input && input.eventType & INPUT_END) this.manager.emit(this.options.event + 'up', input);
            else {
                this._input.timeStamp = now();
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */ function RotateRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(RotateRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof RotateRecognizer
     */ defaults: {
            event: 'rotate',
            threshold: 0,
            pointers: 2
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_NONE
            ];
        },
        attrTest: function(input) {
            return this._super.attrTest.call(this, input) && (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
        }
    });
    /**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */ function SwipeRecognizer() {
        AttrRecognizer.apply(this, arguments);
    }
    inherit(SwipeRecognizer, AttrRecognizer, {
        /**
     * @namespace
     * @memberof SwipeRecognizer
     */ defaults: {
            event: 'swipe',
            threshold: 10,
            velocity: 0.3,
            direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
            pointers: 1
        },
        getTouchAction: function() {
            return PanRecognizer.prototype.getTouchAction.call(this);
        },
        attrTest: function(input) {
            var direction = this.options.direction;
            var velocity;
            if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) velocity = input.overallVelocity;
            else if (direction & DIRECTION_HORIZONTAL) velocity = input.overallVelocityX;
            else if (direction & DIRECTION_VERTICAL) velocity = input.overallVelocityY;
            return this._super.attrTest.call(this, input) && direction & input.offsetDirection && input.distance > this.options.threshold && input.maxPointers == this.options.pointers && abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
        },
        emit: function(input) {
            var direction = directionStr(input.offsetDirection);
            if (direction) this.manager.emit(this.options.event + direction, input);
            this.manager.emit(this.options.event, input);
        }
    });
    /**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */ function TapRecognizer() {
        Recognizer.apply(this, arguments);
        // previous time and center,
        // used for tap counting
        this.pTime = false;
        this.pCenter = false;
        this._timer = null;
        this._input = null;
        this.count = 0;
    }
    inherit(TapRecognizer, Recognizer, {
        /**
     * @namespace
     * @memberof PinchRecognizer
     */ defaults: {
            event: 'tap',
            pointers: 1,
            taps: 1,
            interval: 300,
            time: 250,
            threshold: 9,
            posThreshold: 10 // a multi-tap can be a bit off the initial position
        },
        getTouchAction: function() {
            return [
                TOUCH_ACTION_MANIPULATION
            ];
        },
        process: function(input) {
            var options = this.options;
            var validPointers = input.pointers.length === options.pointers;
            var validMovement = input.distance < options.threshold;
            var validTouchTime = input.deltaTime < options.time;
            this.reset();
            if (input.eventType & INPUT_START && this.count === 0) return this.failTimeout();
            // we only allow little movement
            // and we've reached an end event, so a tap is possible
            if (validMovement && validTouchTime && validPointers) {
                if (input.eventType != INPUT_END) return this.failTimeout();
                var validInterval = this.pTime ? input.timeStamp - this.pTime < options.interval : true;
                var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;
                this.pTime = input.timeStamp;
                this.pCenter = input.center;
                if (!validMultiTap || !validInterval) this.count = 1;
                else this.count += 1;
                this._input = input;
                // if tap count matches we have recognized it,
                // else it has began recognizing...
                var tapCount = this.count % options.taps;
                if (tapCount === 0) {
                    // no failing requirements, immediately trigger the tap event
                    // or wait as long as the multitap interval to trigger
                    if (!this.hasRequireFailures()) return STATE_RECOGNIZED;
                    else {
                        this._timer = setTimeoutContext(function() {
                            this.state = STATE_RECOGNIZED;
                            this.tryEmit();
                        }, options.interval, this);
                        return STATE_BEGAN;
                    }
                }
            }
            return STATE_FAILED;
        },
        failTimeout: function() {
            this._timer = setTimeoutContext(function() {
                this.state = STATE_FAILED;
            }, this.options.interval, this);
            return STATE_FAILED;
        },
        reset: function() {
            clearTimeout(this._timer);
        },
        emit: function() {
            if (this.state == STATE_RECOGNIZED) {
                this._input.tapCount = this.count;
                this.manager.emit(this.options.event, this._input);
            }
        }
    });
    /**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Hammer(element, options) {
        options = options || {};
        options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
        return new Manager(element, options);
    }
    /**
 * @const {string}
 */ Hammer.VERSION = '2.0.7';
    /**
 * default settings
 * @namespace
 */ Hammer.defaults = {
        /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */ domEvents: false,
        /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */ touchAction: TOUCH_ACTION_COMPUTE,
        /**
     * @type {Boolean}
     * @default true
     */ enable: true,
        /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */ inputTarget: null,
        /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */ inputClass: null,
        /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */ preset: [
            // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
            [
                RotateRecognizer,
                {
                    enable: false
                }
            ],
            [
                PinchRecognizer,
                {
                    enable: false
                },
                [
                    'rotate'
                ]
            ],
            [
                SwipeRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                }
            ],
            [
                PanRecognizer,
                {
                    direction: DIRECTION_HORIZONTAL
                },
                [
                    'swipe'
                ]
            ],
            [
                TapRecognizer
            ],
            [
                TapRecognizer,
                {
                    event: 'doubletap',
                    taps: 2
                },
                [
                    'tap'
                ]
            ],
            [
                PressRecognizer
            ]
        ],
        /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */ cssProps: {
            /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userSelect: 'none',
            /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */ touchSelect: 'none',
            /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */ touchCallout: 'none',
            /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */ contentZooming: 'none',
            /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */ userDrag: 'none',
            /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */ tapHighlightColor: 'rgba(0,0,0,0)'
        }
    };
    var STOP = 1;
    var FORCED_STOP = 2;
    /**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */ function Manager(element, options) {
        this.options = assign({}, Hammer.defaults, options || {});
        this.options.inputTarget = this.options.inputTarget || element;
        this.handlers = {};
        this.session = {};
        this.recognizers = [];
        this.oldCssProps = {};
        this.element = element;
        this.input = createInputInstance(this);
        this.touchAction = new TouchAction(this, this.options.touchAction);
        toggleCssProps(this, true);
        each(this.options.recognizers, function(item) {
            var recognizer = this.add(new item[0](item[1]));
            item[2] && recognizer.recognizeWith(item[2]);
            item[3] && recognizer.requireFailure(item[3]);
        }, this);
    }
    Manager.prototype = {
        /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */ set: function(options) {
            assign(this.options, options);
            // Options that need a little more setup
            if (options.touchAction) this.touchAction.update();
            if (options.inputTarget) {
                // Clean up existing event listeners and reinitialize
                this.input.destroy();
                this.input.target = options.inputTarget;
                this.input.init();
            }
            return this;
        },
        /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */ stop: function(force) {
            this.session.stopped = force ? FORCED_STOP : STOP;
        },
        /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */ recognize: function(inputData) {
            var session = this.session;
            if (session.stopped) return;
            // run the touch-action polyfill
            this.touchAction.preventDefaults(inputData);
            var recognizer;
            var recognizers = this.recognizers;
            // this holds the recognizer that is being recognized.
            // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
            // if no recognizer is detecting a thing, it is set to `null`
            var curRecognizer = session.curRecognizer;
            // reset when the last recognizer is recognized
            // or when we're in a new session
            if (!curRecognizer || curRecognizer && curRecognizer.state & STATE_RECOGNIZED) curRecognizer = session.curRecognizer = null;
            var i = 0;
            while(i < recognizers.length){
                recognizer = recognizers[i];
                // find out if we are allowed try to recognize the input for this one.
                // 1.   allow if the session is NOT forced stopped (see the .stop() method)
                // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
                //      that is being recognized.
                // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
                //      this can be setup with the `recognizeWith()` method on the recognizer.
                if (session.stopped !== FORCED_STOP && (!curRecognizer || recognizer == curRecognizer || // 2
                recognizer.canRecognizeWith(curRecognizer))) recognizer.recognize(inputData);
                else recognizer.reset();
                // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
                // current active recognizer. but only if we don't already have an active recognizer
                if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) curRecognizer = session.curRecognizer = recognizer;
                i++;
            }
        },
        /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */ get: function(recognizer) {
            if (recognizer instanceof Recognizer) return recognizer;
            var recognizers = this.recognizers;
            for(var i = 0; i < recognizers.length; i++){
                if (recognizers[i].options.event == recognizer) return recognizers[i];
            }
            return null;
        },
        /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */ add: function(recognizer) {
            if (invokeArrayArg(recognizer, 'add', this)) return this;
            // remove existing
            var existing = this.get(recognizer.options.event);
            if (existing) this.remove(existing);
            this.recognizers.push(recognizer);
            recognizer.manager = this;
            this.touchAction.update();
            return recognizer;
        },
        /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */ remove: function(recognizer) {
            if (invokeArrayArg(recognizer, 'remove', this)) return this;
            recognizer = this.get(recognizer);
            // let's make sure this recognizer exists
            if (recognizer) {
                var recognizers = this.recognizers;
                var index = inArray(recognizers, recognizer);
                if (index !== -1) {
                    recognizers.splice(index, 1);
                    this.touchAction.update();
                }
            }
            return this;
        },
        /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */ on: function(events, handler) {
            if (events === undefined) return;
            if (handler === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                handlers[event] = handlers[event] || [];
                handlers[event].push(handler);
            });
            return this;
        },
        /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */ off: function(events, handler) {
            if (events === undefined) return;
            var handlers = this.handlers;
            each(splitStr(events), function(event) {
                if (!handler) delete handlers[event];
                else handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            });
            return this;
        },
        /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */ emit: function(event, data) {
            // we also want to trigger dom events
            if (this.options.domEvents) triggerDomEvent(event, data);
            // no handlers, so skip it all
            var handlers = this.handlers[event] && this.handlers[event].slice();
            if (!handlers || !handlers.length) return;
            data.type = event;
            data.preventDefault = function() {
                data.srcEvent.preventDefault();
            };
            var i = 0;
            while(i < handlers.length){
                handlers[i](data);
                i++;
            }
        },
        /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */ destroy: function() {
            this.element && toggleCssProps(this, false);
            this.handlers = {};
            this.session = {};
            this.input.destroy();
            this.element = null;
        }
    };
    /**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */ function toggleCssProps(manager, add) {
        var element = manager.element;
        if (!element.style) return;
        var prop;
        each(manager.options.cssProps, function(value, name) {
            prop = prefixed(element.style, name);
            if (add) {
                manager.oldCssProps[prop] = element.style[prop];
                element.style[prop] = value;
            } else element.style[prop] = manager.oldCssProps[prop] || '';
        });
        if (!add) manager.oldCssProps = {};
    }
    /**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */ function triggerDomEvent(event, data) {
        var gestureEvent = document1.createEvent('Event');
        gestureEvent.initEvent(event, true, true);
        gestureEvent.gesture = data;
        data.target.dispatchEvent(gestureEvent);
    }
    assign(Hammer, {
        INPUT_START: INPUT_START,
        INPUT_MOVE: INPUT_MOVE,
        INPUT_END: INPUT_END,
        INPUT_CANCEL: INPUT_CANCEL,
        STATE_POSSIBLE: STATE_POSSIBLE,
        STATE_BEGAN: STATE_BEGAN,
        STATE_CHANGED: STATE_CHANGED,
        STATE_ENDED: STATE_ENDED,
        STATE_RECOGNIZED: STATE_RECOGNIZED,
        STATE_CANCELLED: STATE_CANCELLED,
        STATE_FAILED: STATE_FAILED,
        DIRECTION_NONE: DIRECTION_NONE,
        DIRECTION_LEFT: DIRECTION_LEFT,
        DIRECTION_RIGHT: DIRECTION_RIGHT,
        DIRECTION_UP: DIRECTION_UP,
        DIRECTION_DOWN: DIRECTION_DOWN,
        DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
        DIRECTION_VERTICAL: DIRECTION_VERTICAL,
        DIRECTION_ALL: DIRECTION_ALL,
        Manager: Manager,
        Input: Input,
        TouchAction: TouchAction,
        TouchInput: TouchInput,
        MouseInput: MouseInput,
        PointerEventInput: PointerEventInput,
        TouchMouseInput: TouchMouseInput,
        SingleTouchInput: SingleTouchInput,
        Recognizer: Recognizer,
        AttrRecognizer: AttrRecognizer,
        Tap: TapRecognizer,
        Pan: PanRecognizer,
        Swipe: SwipeRecognizer,
        Pinch: PinchRecognizer,
        Rotate: RotateRecognizer,
        Press: PressRecognizer,
        on: addEventListeners,
        off: removeEventListeners,
        each: each,
        merge: merge,
        extend: extend,
        assign: assign,
        inherit: inherit,
        bindFn: bindFn,
        prefixed: prefixed
    });
    // this prevents errors when Hammer is loaded in the presence of an AMD
    //  style loader but by script tag, not by the loader.
    var freeGlobal = typeof window1 !== 'undefined' ? window1 : typeof self !== 'undefined' ? self : {}; // jshint ignore:line
    freeGlobal.Hammer = Hammer;
    if (typeof define === 'function' && define.amd) define(function() {
        return Hammer;
    });
    else if ($9e1724f0f41c40ad$exports) $9e1724f0f41c40ad$exports = Hammer;
    else window1[exportName] = Hammer;
})(window, document, 'Hammer');


/*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ const $dc093197fa71c887$export$53b83ca8eaab0383 = (t)=>"object" == typeof t && null !== t && t.constructor === Object && "[object Object]" === Object.prototype.toString.call(t);


/*! License details at fancyapps.com/license */ const $585a18adb7d59904$export$844ec244b1367d54 = (t)=>"string" == typeof t;


/*! License details at fancyapps.com/license */ const $72eb7366a788e3d9$export$8ee0fc9ee280b4ee = (n)=>n && null !== n && n instanceof Element && "nodeType" in n;


/*! License details at fancyapps.com/license */ const $81976219b3588213$export$b368690db5627d91 = function(e) {
    var t = (new DOMParser).parseFromString(e, "text/html").body;
    if (t.childElementCount > 1) {
        for(var n = document.createElement("div"); t.firstChild;)n.appendChild(t.firstChild);
        return n;
    }
    let r = t.firstChild;
    return !r || r instanceof HTMLElement ? r : ((n = document.createElement("div")).appendChild(r), n);
};


/*! License details at fancyapps.com/license */ const $16dbdcd3a6f0d21d$export$2bb74740c4e19def = function(e) {
    if (!(e && e instanceof Element && e.offsetParent)) return !1;
    const n = e.scrollHeight > e.clientHeight, t = window.getComputedStyle(e).overflowY, o = -1 !== t.indexOf("hidden"), i = -1 !== t.indexOf("visible");
    return n && !o && !i;
}, $16dbdcd3a6f0d21d$export$e41e80160bed5714 = function(t, o) {
    return !t || t === document.body || o && t === o ? null : $16dbdcd3a6f0d21d$export$2bb74740c4e19def(t) ? t : $16dbdcd3a6f0d21d$export$e41e80160bed5714(t.parentElement, o);
};


/*! License details at fancyapps.com/license */ const $b02d5d471dc29732$export$b539ed14f4f9e78 = (t = !0, e = "--f-scrollbar-compensate", s = "--f-body-margin", o = "hide-scrollbar")=>{
    const n = document, r = n.body, l = n.documentElement;
    if (t) {
        if (r.classList.contains(o)) return;
        let t = window.innerWidth - l.getBoundingClientRect().width;
        t < 0 && (t = 0), l.style.setProperty(e, `${t}px`);
        const n = parseFloat(window.getComputedStyle(r).marginRight);
        n && r.style.setProperty(s, `${n}px`), r.classList.add(o);
    } else r.classList.remove(o), r.style.setProperty(s, ""), n.documentElement.style.setProperty(e, "");
};


/*! License details at fancyapps.com/license */ 
const $56a4b1af55519d9a$export$8b58be045bf06082 = (t, ...e)=>{
    const n = e.length;
    for(let c = 0; c < n; c++){
        const n = e[c] || {};
        Object.entries(n).forEach(([e, n])=>{
            const c = Array.isArray(n) ? [] : {};
            t[e] || Object.assign(t, {
                [e]: c
            }), (0, $dc093197fa71c887$export$53b83ca8eaab0383)(n) ? Object.assign(t[e], $56a4b1af55519d9a$export$8b58be045bf06082(t[e], n)) : Array.isArray(n) ? Object.assign(t, {
                [e]: [
                    ...n
                ]
            }) : Object.assign(t, {
                [e]: n
            });
        });
    }
    return t;
};


/*! License details at fancyapps.com/license */ function $f96a9ede5ac3bcc5$export$71594e8a50f746f4() {
    return !("undefined" == typeof window || !window.document || !window.document.createElement);
}


/*! License details at fancyapps.com/license */ /*! License details at fancyapps.com/license */ const $73781947f6aacd25$export$7d15b64cf5a3a4c4 = function(t = 0, n = 0, a = 0) {
    return Math.max(Math.min(n, a), t);
};


const $cc0f4c55c8b6e1bf$export$871de8747c9eaa88 = function(t = 0, n = 0, r = 0, c = 0, m = 0, p = !1) {
    const s = (t - n) / (r - n) * (m - c) + c;
    return p ? c < m ? (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(c, s, m) : (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(m, s, c) : s;
};


/*! License details at fancyapps.com/license */ const $8d1d8b176a38106a$export$d2cf6cd1dc7067d3 = (s, t = "")=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.add(t);
    });
};


/*! License details at fancyapps.com/license */ 




/*! License details at fancyapps.com/license */ 
/*! License details at fancyapps.com/license */ 
function $923f092a45fc777c$var$e(e) {
    return (0, $dc093197fa71c887$export$53b83ca8eaab0383)(e) || Array.isArray(e);
}
function $923f092a45fc777c$export$248d38f6296296c5(t, r) {
    const o = Object.keys(t), c = Object.keys(r);
    return o.length === c.length && o.every((o)=>{
        const c = t[o], i = r[o];
        return "function" == typeof c ? `${c}` == `${i}` : $923f092a45fc777c$var$e(c) && $923f092a45fc777c$var$e(i) ? $923f092a45fc777c$export$248d38f6296296c5(c, i) : c === i;
    });
}


const $6f48c3b0d4f5e032$var$e = function(n) {
    for (const t of $6f48c3b0d4f5e032$var$s)t.getState() === $6f48c3b0d4f5e032$export$7f967bab4408cae2.Running && t.tick($6f48c3b0d4f5e032$var$a ? n - $6f48c3b0d4f5e032$var$a : 0);
    $6f48c3b0d4f5e032$var$a = n, $6f48c3b0d4f5e032$var$u = window.requestAnimationFrame($6f48c3b0d4f5e032$var$e);
};
var $6f48c3b0d4f5e032$export$7f967bab4408cae2, $6f48c3b0d4f5e032$var$o, $6f48c3b0d4f5e032$export$b4fa0e08d7ac6a23;
!function(n) {
    n[n.Initializing = 0] = "Initializing", n[n.Running = 1] = "Running", n[n.Paused = 2] = "Paused", n[n.Completed = 3] = "Completed", n[n.Destroyed = 4] = "Destroyed";
}($6f48c3b0d4f5e032$export$7f967bab4408cae2 || ($6f48c3b0d4f5e032$export$7f967bab4408cae2 = {})), function(n) {
    n[n.Spring = 0] = "Spring", n[n.Ease = 1] = "Ease";
}($6f48c3b0d4f5e032$var$o || ($6f48c3b0d4f5e032$var$o = {})), function(n) {
    n[n.Loop = 0] = "Loop", n[n.Reverse = 1] = "Reverse";
}($6f48c3b0d4f5e032$export$b4fa0e08d7ac6a23 || ($6f48c3b0d4f5e032$export$b4fa0e08d7ac6a23 = {}));
const $6f48c3b0d4f5e032$var$s = new Set;
let $6f48c3b0d4f5e032$var$u = null, $6f48c3b0d4f5e032$var$a = 0;
function $6f48c3b0d4f5e032$export$208a41d6b4e37b97() {
    let a = $6f48c3b0d4f5e032$export$7f967bab4408cae2.Initializing, f = $6f48c3b0d4f5e032$var$o.Ease, l = 0, g = 0, p = $6f48c3b0d4f5e032$export$208a41d6b4e37b97.Easings.Linear, m = 500, d = 0, b = 0, S = 0, h = 0, y = 1 / 0, E = .01, R = .01, M = !1, j = {}, w = null, v = {}, O = {}, C = {}, L = 0, I = 0, D = $6f48c3b0d4f5e032$export$b4fa0e08d7ac6a23.Loop, z = $6f48c3b0d4f5e032$export$208a41d6b4e37b97.Easings.Linear;
    const N = new Map;
    function V(n, ...t) {
        for (const e of N.get(n) || [])e(...t);
    }
    function q(n) {
        return g = 0, n ? w = setTimeout(()=>{
            x();
        }, n) : x(), F;
    }
    function x() {
        a = $6f48c3b0d4f5e032$export$7f967bab4408cae2.Running, V("start", v, O);
    }
    function A() {
        if (a = $6f48c3b0d4f5e032$export$7f967bab4408cae2.Completed, C = {}, V("end", v), a === $6f48c3b0d4f5e032$export$7f967bab4408cae2.Completed) {
            if (l < L) {
                if (l++, D === $6f48c3b0d4f5e032$export$b4fa0e08d7ac6a23.Reverse) {
                    const n = Object.assign({}, j);
                    j = Object.assign({}, O), O = n;
                }
                q(I);
            } else l = 0;
        }
        return F;
    }
    const F = {
        getState: function() {
            return a;
        },
        easing: function(n) {
            return p = n, f = $6f48c3b0d4f5e032$var$o.Ease, C = {}, F;
        },
        duration: function(n) {
            return m = n, F;
        },
        spring: function(n = {}) {
            f = $6f48c3b0d4f5e032$var$o.Spring;
            const t = {
                velocity: 0,
                mass: 1,
                tension: 170,
                friction: 26,
                restDelta: .1,
                restSpeed: .1,
                maxSpeed: 1 / 0,
                clamp: !0
            }, { velocity: e, mass: i, tension: r, friction: s, restDelta: u, restSpeed: a, maxSpeed: c, clamp: l } = Object.assign(Object.assign({}, t), n);
            return d = e, b = i, S = r, h = s, R = u, E = a, y = c, M = l, C = {}, F;
        },
        isRunning: function() {
            return a === $6f48c3b0d4f5e032$export$7f967bab4408cae2.Running;
        },
        isSpring: function() {
            return f === $6f48c3b0d4f5e032$var$o.Spring;
        },
        from: function(n) {
            return v = Object.assign({}, n), F;
        },
        to: function(n) {
            return O = n, F;
        },
        repeat: function(n, t = 0, e = $6f48c3b0d4f5e032$export$b4fa0e08d7ac6a23.Loop, i) {
            return L = n, I = t, D = e, z = i || p, F;
        },
        on: function(n, t) {
            var e, i;
            return e = n, i = t, N.set(e, [
                ...N.get(e) || [],
                i
            ]), F;
        },
        off: function(n, t) {
            var e, i;
            return e = n, i = t, N.has(e) && N.set(e, N.get(e).filter((n)=>n !== i)), F;
        },
        start: function(n) {
            return a = $6f48c3b0d4f5e032$export$7f967bab4408cae2.Initializing, j = Object.assign({}, v), (0, $923f092a45fc777c$export$248d38f6296296c5)(j, O) || ($6f48c3b0d4f5e032$var$s.add(this), $6f48c3b0d4f5e032$var$u || ($6f48c3b0d4f5e032$var$u = window.requestAnimationFrame($6f48c3b0d4f5e032$var$e)), q(n)), F;
        },
        pause: function() {
            return w && (clearTimeout(w), w = null), a === $6f48c3b0d4f5e032$export$7f967bab4408cae2.Running && (a = $6f48c3b0d4f5e032$export$7f967bab4408cae2.Paused, V("pause", v)), F;
        },
        end: A,
        tick: function(e) {
            e > 50 && (e = 50), g += e;
            let s = 0, u = !1;
            if (a !== $6f48c3b0d4f5e032$export$7f967bab4408cae2.Running) return F;
            if (f === $6f48c3b0d4f5e032$var$o.Ease) {
                s = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(0, g / m, 1), u = 1 === s;
                const t = D === $6f48c3b0d4f5e032$export$b4fa0e08d7ac6a23.Reverse ? z : p;
                for(const n in v)v[n] = j[n] + (O[n] - j[n]) * t(s);
            }
            if (f === $6f48c3b0d4f5e032$var$o.Spring) {
                const t = .001 * e;
                let i = 0;
                for(const e in v){
                    const o = O[e];
                    let r = v[e];
                    if ("number" != typeof o || isNaN(o) || "number" != typeof r || isNaN(r)) continue;
                    if (Math.abs(o - r) <= R) {
                        v[e] = o, C[e] = 0;
                        continue;
                    }
                    C[e] || ("object" == typeof d && "number" == typeof d[e] ? C[e] = d[e] : C[e] = "number" == typeof d ? d : 0);
                    let s = C[e];
                    s = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(-1 * Math.abs(y), s, Math.abs(y));
                    const u = s * b * h;
                    s += ((r > o ? -1 : 1) * (Math.abs(o - r) * S) - u) / b * t, r += s * t;
                    const a = v[e] > o ? r < o : r > o;
                    let c = Math.abs(s) < E && Math.abs(o - r) <= R;
                    M && a && (c = !0), c ? (r = o, s = 0) : i++, v[e] = r, C[e] = s;
                }
                u = !i;
            }
            const c = Object.assign({}, O);
            return V("step", v, j, O, s), u && a === $6f48c3b0d4f5e032$export$7f967bab4408cae2.Running && (0, $923f092a45fc777c$export$248d38f6296296c5)(O, c) && (a = $6f48c3b0d4f5e032$export$7f967bab4408cae2.Completed, A()), F;
        },
        getStartValues: function() {
            return j;
        },
        getCurrentValues: function() {
            return v;
        },
        getCurrentVelocities: function() {
            return C;
        },
        getEndValues: function() {
            return O;
        },
        destroy: function() {
            a = $6f48c3b0d4f5e032$export$7f967bab4408cae2.Destroyed, w && (clearTimeout(w), w = null), j = v = O = {}, $6f48c3b0d4f5e032$var$s.delete(this);
        }
    };
    return F;
}
$6f48c3b0d4f5e032$export$208a41d6b4e37b97.destroy = ()=>{
    for (const n of $6f48c3b0d4f5e032$var$s)n.destroy();
    $6f48c3b0d4f5e032$var$u && (cancelAnimationFrame($6f48c3b0d4f5e032$var$u), $6f48c3b0d4f5e032$var$u = null);
}, $6f48c3b0d4f5e032$export$208a41d6b4e37b97.Easings = {
    Linear: function(n) {
        return n;
    },
    EaseIn: function(n) {
        return 0 === n ? 0 : Math.pow(2, 10 * n - 10);
    },
    EaseOut: function(n) {
        return 1 === n ? 1 : 1 - Math.pow(2, -10 * n);
    },
    EaseInOut: function(n) {
        return 0 === n ? 0 : 1 === n ? 1 : n < .5 ? Math.pow(2, 20 * n - 10) / 2 : (2 - Math.pow(2, -20 * n + 10)) / 2;
    }
};


/*! License details at fancyapps.com/license */ function $fff24a5500e60204$export$6385f9b89f59465f(e) {
    const t = [], n = "undefined" != typeof TouchEvent && e instanceof TouchEvent ? e.touches : e instanceof MouseEvent && "mouseup" !== e.type ? [
        e
    ] : [];
    for (const e of n)t.push({
        x: e.clientX,
        y: e.clientY,
        ts: Date.now()
    });
    return t;
}
function $fff24a5500e60204$export$1ae15396032099be(e) {
    const t = [], n = "undefined" != typeof TouchEvent && e instanceof TouchEvent ? e.changedTouches : e instanceof MouseEvent ? [
        e
    ] : [];
    for (const e of n)t.push({
        x: e.clientX,
        y: e.clientY,
        ts: Date.now()
    });
    return t;
}
function $fff24a5500e60204$export$b820caf342892892(e) {
    const t = e[0], n = e[1] || t;
    return {
        x: (t.x + n.x) / 2,
        y: (t.y + n.y) / 2,
        ts: n.ts
    };
}
function $fff24a5500e60204$export$79376507b09a66f(e) {
    const t = e[0], n = e[1] || e[0];
    return t && n ? -1 * Math.sqrt((n.x - t.x) * (n.x - t.x) + (n.y - t.y) * (n.y - t.y)) : 0;
}
const $fff24a5500e60204$var$s = (e)=>{
    e.cancelable && e.preventDefault();
}, $fff24a5500e60204$var$i = {
    passive: !1
}, $fff24a5500e60204$var$c = {
    panThreshold: 5,
    swipeThreshold: 3,
    ignore: [
        "textarea",
        "input",
        "select",
        "[contenteditable]",
        "[data-selectable]",
        "[data-draggable]"
    ]
};
let $fff24a5500e60204$var$a = !1, $fff24a5500e60204$var$r = !0;
const $fff24a5500e60204$export$1f911e2d31b2843e = (u, l)=>{
    let d, f, h, v = Object.assign(Object.assign({}, $fff24a5500e60204$var$c), l), p = [], m = [], E = [], g = !1, w = !1, y = !1, T = 0, b = 0, M = 0, x = 0, L = 0, P = 0, D = 0, X = 0, Y = 0, j = [], k = 0, R = 0;
    const z = new Map;
    function A(e) {
        const t = $fff24a5500e60204$export$79376507b09a66f(m), n = $fff24a5500e60204$export$79376507b09a66f(E), s = t && n ? t / n : 0, i = Math.abs(D) > Math.abs(X) ? D : X, c = {
            srcEvent: d,
            isPanRecognized: g,
            isSwipeRecognized: w,
            firstTouch: p,
            previousTouch: E,
            currentTouch: m,
            deltaX: M,
            deltaY: x,
            offsetX: L,
            offsetY: P,
            velocityX: D,
            velocityY: X,
            velocity: i,
            angle: Y,
            axis: h,
            scale: s,
            center: f
        };
        for (const t of z.get(e) || [])t(c);
    }
    function O(e) {
        const t = Date.now();
        j = j.filter((e)=>!e.ts || e.ts > t - 100), e && j.push(e);
    }
    function S() {
        if (D = 0, X = 0, j.length > 3) {
            const e = j[0], t = j[j.length - 1];
            if (e && t) {
                const n = t.x - e.x, o = t.y - e.y, s = e.ts && t.ts ? t.ts - e.ts : 0;
                s > 0 && (D = Math.abs(n) > 3 ? n / (s / 30) : 0, X = Math.abs(o) > 3 ? o / (s / 30) : 0);
            }
        }
    }
    function q(t) {
        if (t instanceof MouseEvent) {
            if ($fff24a5500e60204$var$a) return;
        } else $fff24a5500e60204$var$a = !0;
        const o = t.composedPath()[0], i = v.ignore.join(",");
        if (o.matches(i) || o.closest(i)) return;
        if ("undefined" != typeof MouseEvent && t instanceof MouseEvent && (!t.buttons || 0 !== t.button)) return;
        t instanceof MouseEvent && $fff24a5500e60204$var$s(t);
        const c = Date.now(), r = c - (T || c);
        y = r > 0 && r <= 250, T = c, clearTimeout(k), d = t, t instanceof MouseEvent && (window.addEventListener("mousemove", C), window.addEventListener("mouseup", I)), window.addEventListener("blur", B), m = $fff24a5500e60204$export$6385f9b89f59465f(t), p = [
            ...m
        ], E = [], b = m.length, f = $fff24a5500e60204$export$b820caf342892892(m), 1 === b && (g = !1, w = !1), b && O($fff24a5500e60204$export$b820caf342892892(m)), A("start");
    }
    function C(t) {
        var s;
        if (!p.length) return;
        if (t.defaultPrevented) return;
        d = t, E = [
            ...m
        ], m = $fff24a5500e60204$export$6385f9b89f59465f(t), b = m.length, f = $fff24a5500e60204$export$b820caf342892892(m);
        const i = f, c = $fff24a5500e60204$export$b820caf342892892(E);
        if (M = i.x - c.x, x = i.y - c.y, O(i), S(), A("move"), m.length > 1) {
            const e = $fff24a5500e60204$export$79376507b09a66f(m), t = $fff24a5500e60204$export$79376507b09a66f(E);
            Math.abs(e - t) >= .1 && A("pinch");
        }
        if (!g && p.length) {
            const e = $fff24a5500e60204$export$b820caf342892892(p);
            L = i.x - e.x, P = i.y - e.y, g = Math.abs(L) > v.panThreshold || Math.abs(P) > v.panThreshold, g && ($fff24a5500e60204$var$r = !1, clearTimeout(R), R = 0, Y = Math.abs(180 * Math.atan2(P, L) / Math.PI), h = Y > 45 && Y < 135 ? "y" : "x", p = [
                ...m
            ], E = [
                ...m
            ], null === (s = window.getSelection()) || void 0 === s || s.removeAllRanges(), A("panstart"));
        }
        g && (M || x) && A("pan");
    }
    function I(o) {
        if (d = o, !p.length) return;
        const s = $fff24a5500e60204$export$6385f9b89f59465f(o), i = $fff24a5500e60204$export$1ae15396032099be(o);
        if (b = s.length, f = $fff24a5500e60204$export$b820caf342892892(i), i.length && O($fff24a5500e60204$export$b820caf342892892(i)), S(), E = [
            ...m
        ], m = [
            ...s
        ], p = [
            ...s
        ], s.length > 0) A("end"), g = !1, w = !1, j = [];
        else {
            const e = v.swipeThreshold;
            (Math.abs(D) > e || Math.abs(X) > e) && (w = !0), g && A("panend"), w && A("swipe"), g || w || (A("tap"), y ? A("doubleTap") : k = setTimeout(function() {
                A("singleTap");
            }, 250)), A("end"), F();
        }
    }
    function B() {
        clearTimeout(k), F(), g && A("panend"), A("end");
    }
    function F() {
        g = !1, w = !1, y = !1, b = 0, j = [], m = [], E = [], p = [], M = 0, x = 0, L = 0, P = 0, D = 0, X = 0, Y = 0, h = void 0, window.removeEventListener("mousemove", C), window.removeEventListener("mouseup", I), window.removeEventListener("blur", B), $fff24a5500e60204$var$r || R || (R = setTimeout(()=>{
            $fff24a5500e60204$var$r = !0, R = 0;
        }, 100));
    }
    function G(e) {
        const t = e.target;
        $fff24a5500e60204$var$a = !1, t && !e.defaultPrevented && ($fff24a5500e60204$var$r || ($fff24a5500e60204$var$s(e), e.stopPropagation()));
    }
    const H = {
        init: function() {
            if (u) return u.addEventListener("click", G, $fff24a5500e60204$var$i), u.addEventListener("mousedown", q, $fff24a5500e60204$var$i), u.addEventListener("touchstart", q, $fff24a5500e60204$var$i), u.addEventListener("touchmove", C, $fff24a5500e60204$var$i), u.addEventListener("touchend", I), u.addEventListener("touchcancel", I), H;
        },
        on: function(e, t) {
            return function(e, t) {
                z.set(e, [
                    ...z.get(e) || [],
                    t
                ]);
            }(e, t), H;
        },
        off: function(e, t) {
            return z.has(e) && z.set(e, z.get(e).filter((e)=>e !== t)), H;
        },
        isPointerDown: ()=>b > 0,
        destroy: function() {
            clearTimeout(k), clearTimeout(R), R = 0, u && (u.removeEventListener("click", G, $fff24a5500e60204$var$i), u.removeEventListener("mousedown", q, $fff24a5500e60204$var$i), u.removeEventListener("touchstart", q, $fff24a5500e60204$var$i), u.removeEventListener("touchmove", C, $fff24a5500e60204$var$i), u.removeEventListener("touchend", I), u.removeEventListener("touchcancel", I)), u = null, F();
        }
    };
    return H;
};
$fff24a5500e60204$export$1f911e2d31b2843e.isClickAllowed = ()=>$fff24a5500e60204$var$r;


/*! License details at fancyapps.com/license */ const $65b2220f881fadfb$export$30568d076ec2f42 = {
    IMAGE_ERROR: "This image couldn't be loaded. <br /> Please try again later.",
    MOVE_UP: "Move up",
    MOVE_DOWN: "Move down",
    MOVE_LEFT: "Move left",
    MOVE_RIGHT: "Move right",
    ZOOM_IN: "Zoom in",
    ZOOM_OUT: "Zoom out",
    TOGGLE_FULL: "Toggle zoom level",
    TOGGLE_1TO1: "Toggle zoom level",
    ITERATE_ZOOM: "Toggle zoom level",
    ROTATE_CCW: "Rotate counterclockwise",
    ROTATE_CW: "Rotate clockwise",
    FLIP_X: "Flip horizontally",
    FLIP_Y: "Flip vertically",
    RESET: "Reset"
};



/*! License details at fancyapps.com/license */ const $e49a661321e90b65$export$c2255604a80b4506 = (s, t = "")=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.remove(t);
    });
};


/*! License details at fancyapps.com/license */ const $0ff753c965c9dc10$export$4a80062ca50b57c7 = (s, t = "", c)=>{
    s && s.classList && t.split(" ").forEach((t)=>{
        t && s.classList.toggle(t, c || !1);
    });
};


const $868588f20a38800c$var$g = (e)=>{
    e.cancelable && e.preventDefault();
}, $868588f20a38800c$var$h = (e, t = 1e4)=>(e = parseFloat(e + "") || 0, Math.round((e + Number.EPSILON) * t) / t), $868588f20a38800c$var$m = (e)=>e instanceof HTMLImageElement;
var $868588f20a38800c$export$9520bccbaf78266, $868588f20a38800c$export$97fb49bddd4ef65d;
!function(e) {
    e.Reset = "reset", e.Zoom = "zoom", e.ZoomIn = "zoomIn", e.ZoomOut = "zoomOut", e.ZoomTo = "zoomTo", e.ToggleCover = "toggleCover", e.ToggleFull = "toggleFull", e.ToggleMax = "toggleMax", e.IterateZoom = "iterateZoom", e.Pan = "pan", e.Swipe = "swipe", e.Move = "move", e.MoveLeft = "moveLeft", e.MoveRight = "moveRight", e.MoveUp = "moveUp", e.MoveDown = "moveDown", e.RotateCCW = "rotateCCW", e.RotateCW = "rotateCW", e.FlipX = "flipX", e.FlipY = "flipY";
}($868588f20a38800c$export$9520bccbaf78266 || ($868588f20a38800c$export$9520bccbaf78266 = {})), function(e) {
    e.Cover = "cover", e.Full = "full", e.Max = "max";
}($868588f20a38800c$export$97fb49bddd4ef65d || ($868588f20a38800c$export$97fb49bddd4ef65d = {}));
const $868588f20a38800c$export$15463f5204f2871f = {
    x: 0,
    y: 0,
    scale: 1,
    angle: 0,
    flipX: 1,
    flipY: 1
}, $868588f20a38800c$var$y = {
    bounds: !0,
    classes: {
        container: "f-panzoom",
        wrapper: "f-panzoom__wrapper",
        content: "f-panzoom__content",
        viewport: "f-panzoom__viewport"
    },
    clickAction: $868588f20a38800c$export$9520bccbaf78266.ToggleFull,
    dblClickAction: !1,
    gestures: {},
    height: "auto",
    l10n: (0, $65b2220f881fadfb$export$30568d076ec2f42),
    maxScale: 4,
    minScale: 1,
    mouseMoveFactor: 1,
    panMode: "drag",
    protected: !1,
    singleClickAction: !1,
    spinnerTpl: '<div class="f-spinner"></div>',
    wheelAction: $868588f20a38800c$export$9520bccbaf78266.Zoom,
    width: "auto"
};
let $868588f20a38800c$var$x, $868588f20a38800c$var$w = 0, $868588f20a38800c$var$M = 0, $868588f20a38800c$var$j = 0;
const $868588f20a38800c$export$b704d075ddd20210 = (c, v = {}, k = {})=>{
    let E, C, O, A, S, T, F, Z, L = 0, X = Object.assign(Object.assign({}, $868588f20a38800c$var$y), v), Y = {}, R = Object.assign({}, $868588f20a38800c$export$15463f5204f2871f), P = Object.assign({}, $868588f20a38800c$export$15463f5204f2871f);
    const z = [];
    function D(e) {
        let t = X[e];
        return t && "function" == typeof t ? t(xe) : t;
    }
    function I() {
        return c && c.parentElement && E && 3 === L;
    }
    const W = new Map;
    function H(e, ...t) {
        const n = [
            ...W.get(e) || []
        ];
        X.on && n.push(X.on[e]);
        for (const e of n)e && e instanceof Function && e(xe, ...t);
        "*" !== e && H("*", e, ...t);
    }
    function q(e) {
        if (!I()) return;
        const t = e.target;
        if ((0, $16dbdcd3a6f0d21d$export$e41e80160bed5714)(t)) return;
        const i = Date.now(), a = [
            -e.deltaX || 0,
            -e.deltaY || 0,
            -e.detail || 0
        ].reduce(function(e, t) {
            return Math.abs(t) > Math.abs(e) ? t : e;
        }), s = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(-1, a, 1);
        H("wheel", e, s);
        const r = D("wheelAction");
        if (!r) return;
        if (e.defaultPrevented) return;
        const l = P.scale;
        let c = l * (s > 0 ? 1.5 : .5);
        if (r === $868588f20a38800c$export$9520bccbaf78266.Zoom) {
            const t = Math.abs(e.deltaY) < 100 && Math.abs(e.deltaX) < 100;
            if (i - $868588f20a38800c$var$M < (t ? 200 : 45)) return void $868588f20a38800c$var$g(e);
            $868588f20a38800c$var$M = i;
            const n = te(), a = ae();
            if ($868588f20a38800c$var$h(c) < $868588f20a38800c$var$h(n) && $868588f20a38800c$var$h(l) <= $868588f20a38800c$var$h(n) ? ($868588f20a38800c$var$j += Math.abs(s), c = n) : $868588f20a38800c$var$h(c) > $868588f20a38800c$var$h(a) && $868588f20a38800c$var$h(l) >= $868588f20a38800c$var$h(a) ? ($868588f20a38800c$var$j += Math.abs(s), c = a) : ($868588f20a38800c$var$j = 0, c = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(n, c, a)), $868588f20a38800c$var$j > 7) return;
        }
        switch($868588f20a38800c$var$g(e), r){
            case $868588f20a38800c$export$9520bccbaf78266.Pan:
                ce(r, {
                    srcEvent: e,
                    deltaX: 2 * -e.deltaX,
                    deltaY: 2 * -e.deltaY
                });
                break;
            case $868588f20a38800c$export$9520bccbaf78266.Zoom:
                ce($868588f20a38800c$export$9520bccbaf78266.ZoomTo, {
                    srcEvent: e,
                    scale: c,
                    center: {
                        x: e.clientX,
                        y: e.clientY
                    }
                });
                break;
            default:
                ce(r, {
                    srcEvent: e
                });
        }
    }
    function $(e) {
        var n, i;
        const o = e.composedPath()[0];
        if (!(0, $fff24a5500e60204$export$1f911e2d31b2843e).isClickAllowed()) return;
        if (!(0, $72eb7366a788e3d9$export$8ee0fc9ee280b4ee)(o) || e.defaultPrevented) return;
        if (!(null == c ? void 0 : c.contains(o))) return;
        if (o.hasAttribute("disabled") || o.hasAttribute("aria-disabled")) return;
        const a = o.closest("[data-panzoom-action]"), s = null === (n = null == a ? void 0 : a.dataset) || void 0 === n ? void 0 : n.panzoomAction, r = (null === (i = null == a ? void 0 : a.dataset) || void 0 === i ? void 0 : i.panzoomValue) || "";
        if (s) {
            switch(s){
                case $868588f20a38800c$export$9520bccbaf78266.ZoomTo:
                case $868588f20a38800c$export$9520bccbaf78266.ZoomIn:
                case $868588f20a38800c$export$9520bccbaf78266.ZoomOut:
                    ce(s, {
                        scale: parseFloat(r || "") || void 0
                    });
                    break;
                case $868588f20a38800c$export$9520bccbaf78266.MoveLeft:
                case $868588f20a38800c$export$9520bccbaf78266.MoveRight:
                    ce(s, {
                        deltaX: parseFloat(r || "") || void 0
                    });
                    break;
                case $868588f20a38800c$export$9520bccbaf78266.MoveUp:
                case $868588f20a38800c$export$9520bccbaf78266.MoveDown:
                    ce(s, {
                        deltaY: parseFloat(r || "") || void 0
                    });
                    break;
                default:
                    ce(s);
            }
            return;
        }
        if (!(null == E ? void 0 : E.contains(o))) return;
        const u = {
            srcEvent: e
        };
        if (ce(D("clickAction"), u), D("dblClickAction")) {
            const e = Date.now(), t = e - ($868588f20a38800c$var$w || e);
            $868588f20a38800c$var$w = e, t > 0 && t <= 250 ? ($868588f20a38800c$var$x && (clearTimeout($868588f20a38800c$var$x), $868588f20a38800c$var$x = void 0), ce(D("dblClickAction"), u)) : $868588f20a38800c$var$x = setTimeout(()=>{
                ce(D("singleClickAction"), u);
            }, 250);
        }
    }
    function _(e) {
        if (Z = e, !I() || !K()) return;
        if (R.scale <= 1 || P.scale <= 1) return;
        if (((null == E ? void 0 : E.dataset.animationName) || "").indexOf("zoom") > -1) return;
        const t = Q(P.scale);
        if (!t) return;
        const { x: n, y: i } = t;
        ce($868588f20a38800c$export$9520bccbaf78266.Pan, {
            deltaX: n - P.x,
            deltaY: i - P.y
        });
    }
    function B() {
        var e;
        c && ((0, $e49a661321e90b65$export$c2255604a80b4506)(c, "is-loading"), null === (e = c.querySelector(".f-spinner")) || void 0 === e || e.remove());
    }
    function N() {
        if (!c || !C) return;
        if (B(), $868588f20a38800c$var$m(C) && (!C.complete || !C.naturalWidth)) return L = 2, null == E || E.classList.add("has-error"), void H("error");
        H("loaded");
        const { width: e, height: t } = G();
        $868588f20a38800c$var$m(C) && (C.setAttribute("width", e + ""), C.setAttribute("height", t + "")), E && ((0, $e49a661321e90b65$export$c2255604a80b4506)(E, "has-error"), $868588f20a38800c$var$m(C) && (E.setAttribute("width", e + ""), E.setAttribute("height", t + ""), E.style.aspectRatio = `${e / t || ""}`)), T = (0, $6f48c3b0d4f5e032$export$208a41d6b4e37b97)().on("start", (e, t)=>{
            P = Object.assign(Object.assign({}, $868588f20a38800c$export$15463f5204f2871f), t), void 0 !== t.angle && (t.angle = 90 * Math.round(t.angle / 90)), void 0 !== t.flipX && (t.flipX = t.flipX > 0 ? 1 : -1), void 0 !== t.flipY && (t.flipY = t.flipY > 0 ? 1 : -1), le(), H("animationStart");
        }).on("pause", (e)=>{
            P = Object.assign(Object.assign({}, $868588f20a38800c$export$15463f5204f2871f), e);
        }).on("step", (e)=>{
            if (!I()) return void (null == T || T.end());
            if (R = Object.assign(Object.assign({}, $868588f20a38800c$export$15463f5204f2871f), e), K() || !D("bounds") || ve() || P.scale > R.scale || P.scale < ne()) return void ue();
            const t = se(P.scale);
            let n = !1, i = !1, a = !1, s = !1;
            R.x < t.x[0] && (n = !0), R.x > t.x[1] && (i = !0), R.y < t.y[0] && (s = !0), R.y > t.y[1] && (a = !0);
            let r = !1, l = !1, c = !1, u = !1;
            P.x < t.x[0] && (r = !0), P.x > t.x[1] && (l = !0), P.y < t.y[0] && (u = !0), P.y > t.y[1] && (c = !0);
            let d = !1;
            (i && l || n && r) && (P.x = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(t.x[0], P.x, t.x[1]), d = !0), (a && c || s && u) && (P.y = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(t.y[0], P.y, t.y[1]), d = !0), d && T && T.spring({
                tension: 94,
                friction: 17,
                maxSpeed: 555 * P.scale,
                restDelta: .1,
                restSpeed: .1,
                velocity: T.getCurrentVelocities()
            }).from(R).to(P).start(), ue();
        }).on("end", ()=>{
            re(), (null == T ? void 0 : T.isRunning()) || (le(), H("animationEnd"));
        }), function() {
            const e = D("gestures");
            e && A && C && (S = (0, $fff24a5500e60204$export$1f911e2d31b2843e)(A, e).on("start", (e)=>{
                if (!T) return;
                const t = e.srcEvent;
                K() || ((R.scale > 1 || e.currentTouch.length > 1) && (null == t || t.stopPropagation(), T.pause()), 1 === e.currentTouch.length && H("touchStart"));
            }).on("move", (e)=>{
                K() || (1 !== P.scale || e.currentTouch.length > 1) && (e.srcEvent.preventDefault(), e.srcEvent.stopPropagation());
            }).on("pan", (e)=>{
                if (!I() || K()) return;
                const t = e.srcEvent;
                (1 !== P.scale || e.currentTouch.length > 1) && ($868588f20a38800c$var$g(t), ce($868588f20a38800c$export$9520bccbaf78266.Pan, e));
            }).on("swipe", (e)=>{
                I() && !K() && P.scale > 1 && ce($868588f20a38800c$export$9520bccbaf78266.Swipe, e);
            }).on("tap", (e)=>{
                H("click", e);
            }).on("singleTap", (e)=>{
                H("singleClick", e);
            }).on("doubleTap", (e)=>{
                H("dblClick", e);
            }).on("pinch", (e)=>{
                K() || (e.scale > ne() ? ce($868588f20a38800c$export$9520bccbaf78266.ZoomIn, e) : e.scale < ne() ? ce($868588f20a38800c$export$9520bccbaf78266.ZoomOut, e) : ce($868588f20a38800c$export$9520bccbaf78266.Pan, e));
            }).on("end", (e)=>{
                K() || (e.currentTouch.length ? (e.srcEvent.stopPropagation(), $868588f20a38800c$var$g(e.srcEvent), null == T || T.end()) : (le(), re(), H("touchEnd")));
            }).init());
        }(), A && (A.addEventListener("wheel", q, {
            passive: !1
        }), z.push(()=>{
            null == A || A.removeEventListener("wheel", q, {
                passive: !1
            });
        })), null == c || c.addEventListener("click", $), null === document || void 0 === document || document.addEventListener("mousemove", _), z.push(()=>{
            null == c || c.removeEventListener("click", $), null === document || void 0 === document || document.removeEventListener("mousemove", _);
        });
        const n = V();
        R = Object.assign({}, n), P = Object.assign({}, n), L = 3, ue(), le(), H("ready"), requestAnimationFrame(()=>{
            B(), A && (A.style.visibility = "");
        });
    }
    function V() {
        const e = Object.assign({}, D("startPos") || {});
        let t = e.scale, n = 1;
        n = "string" == typeof t ? ee(t) : "number" == typeof t ? t : ne();
        const i = Object.assign(Object.assign(Object.assign({}, $868588f20a38800c$export$15463f5204f2871f), e), {
            scale: n
        }), o = K() ? Q(n) : void 0;
        if (o) {
            const { x: e, y: t } = o;
            i.x = e, i.y = t;
        }
        return i;
    }
    function U() {
        const e = {
            top: 0,
            left: 0,
            width: 0,
            height: 0
        };
        if (E) {
            const t = E.getBoundingClientRect();
            P.angle % 180 == 90 ? (e.top = t.top + .5 * t.height - .5 * t.width, e.left = t.left + .5 * t.width - .5 * t.height, e.width = t.height, e.height = t.width) : (e.top = t.top, e.left = t.left, e.width = t.width, e.height = t.height);
        }
        return e;
    }
    function G() {
        let t = D("width"), n = D("height");
        if (C && "auto" === t) {
            const e = C.getAttribute("width");
            t = e ? parseFloat(e + "") : void 0 !== C.dataset.width ? parseFloat(C.dataset.width + "") : $868588f20a38800c$var$m(A) ? A.naturalWidth : $868588f20a38800c$var$m(C) ? C.naturalWidth : C.getBoundingClientRect().width;
        } else t = (0, $585a18adb7d59904$export$844ec244b1367d54)(t) ? parseFloat(t) : t;
        if (C && "auto" === n) {
            const e = C.getAttribute("height");
            n = e ? parseFloat(e + "") : void 0 !== C.dataset.height ? parseFloat(C.dataset.height + "") : $868588f20a38800c$var$m(A) ? A.naturalHeight : $868588f20a38800c$var$m(C) ? C.naturalHeight : C.getBoundingClientRect().height;
        } else n = (0, $585a18adb7d59904$export$844ec244b1367d54)(n) ? parseFloat(n) : n;
        return {
            width: t,
            height: n
        };
    }
    function J() {
        const e = U();
        return {
            width: e.width,
            height: e.height
        };
    }
    function K() {
        return "mousemove" === D("panMode") && matchMedia("(hover: hover)").matches;
    }
    function Q(e) {
        const t = Z || D("event"), n = null == E ? void 0 : E.getBoundingClientRect();
        if (!t || !n || e <= 1) return {
            x: 0,
            y: 0
        };
        const i = (t.clientX || 0) - n.left, a = (t.clientY || 0) - n.top, { width: s, height: r } = J(), l = se(e);
        if (e > 1) {
            const t = D("mouseMoveFactor");
            t > 1 && (e *= t);
        }
        let c = s * e, u = r * e, d = .5 * (c - s) - i / s * 100 / 100 * (c - s), f = .5 * (u - r) - a / r * 100 / 100 * (u - r);
        return d = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(l.x[0], d, l.x[1]), f = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(l.y[0], f, l.y[1]), {
            x: d,
            y: f
        };
    }
    function ee(e = "base") {
        if (!c) return 1;
        const t = c.getBoundingClientRect(), n = U(), { width: i, height: a } = G(), s = (e)=>{
            if ("number" == typeof e) return e;
            switch(e){
                case "min":
                case "base":
                    return 1;
                case "cover":
                    return Math.max(t.height / n.height, t.width / n.width) || 1;
                case "full":
                case "max":
                    {
                        const e = P.angle % 180 == 90 ? a : i;
                        return e && n.width ? e / n.width : 1;
                    }
            }
        }, r = D("minScale"), l = D("maxScale"), u = Math.min(s("full"), s(r)), d = "number" == typeof l ? s("full") * l : Math.min(s("full"), s(l));
        switch(e){
            case "min":
                return u;
            case "base":
                return (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(u, 1, d);
            case "cover":
                return s("cover");
            case "full":
                return Math.min(d, s("full"));
            case "max":
                return d;
        }
    }
    function te() {
        return ee("min");
    }
    function ne() {
        return ee("base");
    }
    function ie() {
        return ee("cover");
    }
    function oe() {
        return ee("full");
    }
    function ae() {
        return ee("max");
    }
    function se(e) {
        const t = {
            x: [
                0,
                0
            ],
            y: [
                0,
                0
            ]
        }, n = null == c ? void 0 : c.getBoundingClientRect();
        if (!n) return t;
        const i = U(), o = n.width, a = n.height;
        let s = i.width, r = i.height, l = e = void 0 === e ? P.scale : e, u = e;
        if (K() && e > 1) {
            const t = D("mouseMoveFactor");
            t > 1 && (s * e > o + .01 && (l *= t), r * e > a + .01 && (u *= t));
        }
        return s *= l, r *= u, e > 1 && (s > o && (t.x[0] = .5 * (o - s), t.x[1] = .5 * (s - o)), t.x[0] -= .5 * (i.left - n.left), t.x[1] -= .5 * (i.left - n.left), t.x[0] -= .5 * (i.left + i.width - n.right), t.x[1] -= .5 * (i.left + i.width - n.right), r > a && (t.y[0] = .5 * (a - r), t.y[1] = .5 * (r - a)), t.y[0] -= .5 * (i.top - n.top), t.y[1] -= .5 * (i.top - n.top), t.y[0] -= .5 * (i.top + i.height - n.bottom), t.y[1] -= .5 * (i.top + i.height - n.bottom)), t;
    }
    function re() {
        if (!I()) return;
        if (!D("bounds")) return;
        if (!T) return;
        const e = te(), t = ae(), n = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(e, P.scale, t);
        if (P.scale < e - .01 || P.scale > t + .01) return void ce($868588f20a38800c$export$9520bccbaf78266.ZoomTo, {
            scale: n
        });
        if (T.isRunning()) return;
        if (ve()) return;
        const i = se(n);
        P.x < i.x[0] || P.x > i.x[1] || P.y < i.y[0] || P.y > i.y[1] ? (P.x = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(i.x[0], P.x, i.x[1]), P.y = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(i.y[0], P.y, i.y[1]), T.spring({
            tension: 170,
            friction: 17,
            restDelta: .001,
            restSpeed: .001,
            maxSpeed: 1 / 0,
            velocity: T.getCurrentVelocities()
        }), T.from(R).to(P).start()) : ue();
    }
    function le() {
        if (!I()) return;
        const e = pe(), t = ve(), n = be(), i = ye(), o = fe(), a = ge();
        (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(E, "is-fullsize", i), (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(E, "is-expanded", n), (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(E, "is-dragging", t), (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(E, "can-drag", e), (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(E, "will-zoom-in", o), (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(E, "will-zoom-out", a);
        const s = he(), r = me(), l = !I();
        for (const e of (null == c ? void 0 : c.querySelectorAll("[data-panzoom-action]")) || []){
            const t = e.dataset.panzoomAction;
            let n = !1;
            if (l) n = !0;
            else switch(t){
                case $868588f20a38800c$export$9520bccbaf78266.ZoomIn:
                    s || (n = !0);
                    break;
                case $868588f20a38800c$export$9520bccbaf78266.ZoomOut:
                    r || (n = !0);
                    break;
                case $868588f20a38800c$export$9520bccbaf78266.ToggleFull:
                    s || r || (n = !0);
                    const t1 = e.querySelector("g");
                    t1 && (t1.style.display = i ? "none" : "");
                    break;
                case $868588f20a38800c$export$9520bccbaf78266.ToggleCover:
                case $868588f20a38800c$export$9520bccbaf78266.ToggleMax:
                    s || r || (n = !0);
            }
            n ? (e.setAttribute("aria-disabled", ""), e.setAttribute("tabindex", "-1")) : (e.removeAttribute("aria-disabled"), e.removeAttribute("tabindex"));
        }
    }
    function ce(e, t) {
        var n;
        if (!c || !C || !T) return;
        if (e === $868588f20a38800c$export$9520bccbaf78266.Swipe && Math.abs(T.getCurrentVelocities().scale) > .01) return;
        let i = Object.assign({}, P), a = se(K() ? P.scale : R.scale);
        const l = T.getCurrentVelocities(), u = U(), d = ((null === (n = (t = t || {}).currentTouch) || void 0 === n ? void 0 : n.length) || 0) > 1, f = t.velocityX || 0, g = t.velocityY || 0;
        let h = t.center;
        !h && t.srcEvent && (h = (0, $fff24a5500e60204$export$b820caf342892892)((0, $fff24a5500e60204$export$1ae15396032099be)(t.srcEvent)));
        let m = t.deltaX || 0, v = t.deltaY || 0;
        switch(e){
            case $868588f20a38800c$export$9520bccbaf78266.MoveRight:
                m = t.deltaX || 100;
                break;
            case $868588f20a38800c$export$9520bccbaf78266.MoveLeft:
                m = t.deltaX || -100;
                break;
            case $868588f20a38800c$export$9520bccbaf78266.MoveUp:
                v = t.deltaY || -100;
                break;
            case $868588f20a38800c$export$9520bccbaf78266.MoveDown:
                v = t.deltaY || 100;
        }
        let y = [];
        switch(e){
            case $868588f20a38800c$export$9520bccbaf78266.Reset:
                P = Object.assign({}, $868588f20a38800c$export$15463f5204f2871f), P.scale = ne();
                break;
            case $868588f20a38800c$export$9520bccbaf78266.Pan:
            case $868588f20a38800c$export$9520bccbaf78266.Move:
            case $868588f20a38800c$export$9520bccbaf78266.MoveLeft:
            case $868588f20a38800c$export$9520bccbaf78266.MoveRight:
            case $868588f20a38800c$export$9520bccbaf78266.MoveUp:
            case $868588f20a38800c$export$9520bccbaf78266.MoveDown:
                if (ve()) {
                    let e = 1, t = 1;
                    P.x <= a.x[0] && f <= 0 && (e = Math.max(.01, 1 - Math.abs(1 / u.width * Math.abs(P.x - a.x[0]))), e *= .2), P.x >= a.x[1] && f >= 0 && (e = Math.max(.01, 1 - Math.abs(1 / u.width * Math.abs(P.x - a.x[1]))), e *= .2), P.y <= a.y[0] && g <= 0 && (t = Math.max(.01, 1 - Math.abs(1 / u.height * Math.abs(P.y - a.y[0]))), t *= .2), P.y >= a.y[1] && g >= 0 && (t = Math.max(.01, 1 - Math.abs(1 / u.height * Math.abs(P.y - a.y[1]))), t *= .2), P.x += m * e, P.y += v * t;
                } else P.x = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(a.x[0], P.x + m, a.x[1]), P.y = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(a.y[0], P.y + v, a.y[1]);
                break;
            case $868588f20a38800c$export$9520bccbaf78266.Swipe:
                const e1 = (e = 0)=>Math.sign(e) * Math.pow(Math.abs(e), 1.5);
                P.x += (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(-1000, e1(f), 1e3), P.y += (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(-1000, e1(g), 1e3), g && !f && (P.x = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(a.x[0], P.x, a.x[1])), !g && f && (P.y = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(a.y[0], P.y, a.y[1])), l.x = f, l.y = g;
                break;
            case $868588f20a38800c$export$9520bccbaf78266.ZoomTo:
                P.scale = t.scale || 1;
                break;
            case $868588f20a38800c$export$9520bccbaf78266.ZoomIn:
                P.scale = P.scale * (t.scale || 2), d || (P.scale = Math.min(P.scale, ae()));
                break;
            case $868588f20a38800c$export$9520bccbaf78266.ZoomOut:
                P.scale = P.scale * (t.scale || .5), d || (P.scale = Math.max(P.scale, te()));
                break;
            case $868588f20a38800c$export$9520bccbaf78266.ToggleCover:
                y = [
                    ne(),
                    ie()
                ];
                break;
            case $868588f20a38800c$export$9520bccbaf78266.ToggleFull:
                y = [
                    ne(),
                    oe()
                ];
                break;
            case $868588f20a38800c$export$9520bccbaf78266.ToggleMax:
                y = [
                    ne(),
                    ae()
                ];
                break;
            case $868588f20a38800c$export$9520bccbaf78266.IterateZoom:
                y = [
                    ne(),
                    oe(),
                    ae()
                ];
                break;
            case $868588f20a38800c$export$9520bccbaf78266.Zoom:
                const n1 = oe();
                P.scale >= n1 - .05 ? P.scale = ne() : P.scale = Math.min(n1, P.scale * (t.scale || 2));
                break;
            case $868588f20a38800c$export$9520bccbaf78266.RotateCW:
                P.angle += 90;
                break;
            case $868588f20a38800c$export$9520bccbaf78266.RotateCCW:
                P.angle -= 90;
                break;
            case $868588f20a38800c$export$9520bccbaf78266.FlipX:
                P.flipX *= -1;
                break;
            case $868588f20a38800c$export$9520bccbaf78266.FlipY:
                P.flipY *= -1;
        }
        if (void 0 !== R.angle && Math.abs(R.angle) >= 360 && (P.angle -= 360 * Math.floor(R.angle / 360), R.angle -= 360 * Math.floor(R.angle / 360)), y.length) {
            const e = y.findIndex((e)=>e > P.scale + 1e-4);
            P.scale = y[e] || y[0];
        }
        if (d && (P.scale = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(te() * (d ? .8 : 1), P.scale, ae() * (d ? 1.6 : 1))), K()) {
            const e = Q(P.scale);
            if (e) {
                const { x: t, y: n } = e;
                P.x = t, P.y = n;
            }
        } else if (P.scale !== i.scale) {
            let e = 0, t = 0;
            if (h) e = h.x, t = h.y;
            else {
                const n = c.getBoundingClientRect();
                e = n.x + .5 * n.width, t = n.y + .5 * n.height;
            }
            let n = e - u.left, s = t - u.top;
            n -= .5 * u.width, s -= .5 * u.height;
            const r = (n - i.x) / i.scale, l = (s - i.y) / i.scale;
            P.x = n - r * P.scale, P.y = s - l * P.scale, !d && D("bounds") && (a = se(), P.x = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(a.x[0], P.x, a.x[1]), P.y = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(a.y[0], P.y, a.y[1]));
        }
        if (e === $868588f20a38800c$export$9520bccbaf78266.Swipe) {
            let e = 94, t = 17, n = 500 * P.scale, i = l;
            T.spring({
                tension: e,
                friction: t,
                maxSpeed: n,
                restDelta: .1,
                restSpeed: .1,
                velocity: i
            });
        } else e === $868588f20a38800c$export$9520bccbaf78266.Pan || d ? T.spring({
            tension: 900,
            friction: 17,
            restDelta: .01,
            restSpeed: .01,
            maxSpeed: 1
        }) : T.spring({
            tension: 170,
            friction: 17,
            restDelta: .001,
            restSpeed: .001,
            maxSpeed: 1 / 0,
            velocity: l
        });
        e === $868588f20a38800c$export$9520bccbaf78266.Reset || 0 === t.velocity ? R = Object.assign({}, P) : T.from(R).to(P).start(), H("action", e);
    }
    function ue() {
        if (!C) return;
        if (E) {
            const { width: e, height: t } = G();
            E.style.maxWidth = `min(${e}px, 100%)`, E.style.maxHeight = `min(${t}px, 100%)`;
        }
        let { x: e, y: t, scale: n, angle: i, flipX: o, flipY: a } = R;
        const s = function() {
            const { width: e, height: t } = G(), { width: n, height: i } = J();
            if (!c) return {
                x: 0,
                y: 0,
                width: 0,
                height: 0,
                scale: 0,
                flipX: 0,
                flipY: 0,
                angle: 0,
                fitWidth: n,
                fitHeight: i,
                fullWidth: e,
                fullHeight: t
            };
            let { x: o, y: a, scale: s, angle: r, flipX: l, flipY: u } = R, d = 1 / oe(), f = e, g = t, h = R.scale * d, m = P.scale * d;
            const p = Math.max(n, i), v = Math.min(n, i);
            e > t ? (f = p, g = v) : (f = v, g = p);
            h = e > t ? p * s / e || 1 : p * s / t || 1;
            let b = f ? e * m : 0, y = g ? t * m : 0;
            return o = o + .5 * f - .5 * b, a = a + .5 * g - .5 * y, {
                x: o,
                y: a,
                width: b,
                height: y,
                scale: f && g ? e * h / b : 0,
                flipX: l,
                flipY: u,
                angle: r,
                fitWidth: n,
                fitHeight: i,
                fullWidth: e,
                fullHeight: t
            };
        }();
        if (s) {
            const { x: e, y: t, width: n, height: o, scale: a, flipX: r, flipY: l } = s;
            let c = `translate(${$868588f20a38800c$var$h(e)}px, ${$868588f20a38800c$var$h(t)}px)`;
            c += 1 !== r || 1 !== l ? ` scaleX(${$868588f20a38800c$var$h(a * r)}) scaleY(${$868588f20a38800c$var$h(a * l)})` : ` scale(${$868588f20a38800c$var$h(a)})`, 0 !== i && (c += ` rotate(${i}deg)`), A && (A.style.width = `${$868588f20a38800c$var$h(n)}px`, A.style.height = `${$868588f20a38800c$var$h(o)}px`, A.style.transform = `${c}`);
        }
        H("render");
    }
    function de() {
        let e = P.scale;
        const t = D("clickAction");
        let n = ne();
        if (t) {
            let i = [];
            switch(t){
                case $868588f20a38800c$export$9520bccbaf78266.ZoomIn:
                    n = 2 * e;
                    break;
                case $868588f20a38800c$export$9520bccbaf78266.ZoomOut:
                    n = .5 * e;
                    break;
                case $868588f20a38800c$export$9520bccbaf78266.ToggleCover:
                    i = [
                        ne(),
                        ie()
                    ];
                    break;
                case $868588f20a38800c$export$9520bccbaf78266.ToggleFull:
                    i = [
                        ne(),
                        oe()
                    ];
                    break;
                case $868588f20a38800c$export$9520bccbaf78266.ToggleMax:
                    i = [
                        ne(),
                        ae()
                    ];
                    break;
                case $868588f20a38800c$export$9520bccbaf78266.IterateZoom:
                    i = [
                        ne(),
                        oe(),
                        ae()
                    ];
                    break;
                case $868588f20a38800c$export$9520bccbaf78266.Zoom:
                    const t1 = oe();
                    n = e >= t1 - .05 ? ne() : Math.min(t1, 2 * e);
            }
            if (i.length) {
                const t = i.findIndex((t)=>t > e + 1e-4);
                n = i[t] || ne();
            }
        }
        return n = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(te(), n, ae()), n;
    }
    function fe() {
        return !!(I() && de() > P.scale);
    }
    function ge() {
        return !!(I() && de() < P.scale);
    }
    function he() {
        return !!(I() && P.scale < ae());
    }
    function me() {
        return !!(I() && P.scale > te());
    }
    function pe() {
        return !(!(I() && be() && S) || K());
    }
    function ve() {
        return !(!I() || !(null == S ? void 0 : S.isPointerDown()) || K());
    }
    function be() {
        return !!(I() && P.scale > ne());
    }
    function ye() {
        return !!(I() && P.scale >= oe());
    }
    const xe = {
        canDrag: pe,
        canZoomIn: he,
        canZoomOut: me,
        destroy: function() {
            H("destroy");
            for (const e of Object.values(Y))null == e || e.destroy(xe);
            for (const e of z)e();
            return E && (E.style.aspectRatio = "", E.style.maxWidth = "", E.style.maxHeight = ""), A && (A.style.width = "", A.style.height = "", A.style.transform = ""), E = void 0, C = void 0, A = void 0, R = Object.assign({}, $868588f20a38800c$export$15463f5204f2871f), P = Object.assign({}, $868588f20a38800c$export$15463f5204f2871f), null == T || T.destroy(), T = void 0, null == S || S.destroy(), S = void 0, L = 4, xe;
        },
        emit: H,
        execute: ce,
        getBoundaries: se,
        getContainer: function() {
            return c;
        },
        getContent: function() {
            return C;
        },
        getFullDim: G,
        getGestures: function() {
            return S;
        },
        getMousemovePos: Q,
        getOptions: function() {
            return X;
        },
        getScale: ee,
        getStartPosition: V,
        getState: function() {
            return L;
        },
        getTransform: function(e) {
            return !0 === e ? P : R;
        },
        getTween: function() {
            return T;
        },
        getViewport: function() {
            return A;
        },
        getWrapper: function() {
            return E;
        },
        init: function() {
            return L = 0, H("init"), function() {
                for (const [e, t] of Object.entries(Object.assign(Object.assign({}, k), X.plugins || {})))if (e && !Y[e] && t instanceof Function) {
                    const n = t();
                    n.init(xe), Y[e] = n;
                }
                H("initPlugins");
            }(), function() {
                const e = Object.assign(Object.assign({}, $868588f20a38800c$var$y.classes), D("classes"));
                if (!c) return;
                if ((0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(c, e.container), C = c.querySelector("." + e.content), !C) return;
                C.setAttribute("draggable", "false"), E = c.querySelector("." + e.wrapper), E || (E = document.createElement("div"), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(E, e.wrapper), C.insertAdjacentElement("beforebegin", E), E.insertAdjacentElement("afterbegin", C));
                A = c.querySelector("." + e.viewport), A || (A = document.createElement("div"), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(A, e.viewport), A.insertAdjacentElement("afterbegin", C), E.insertAdjacentElement("beforeend", A));
                O = C.cloneNode(!0), O.removeAttribute("id"), E.insertAdjacentElement("afterbegin", O), C instanceof HTMLPictureElement && (C = C.querySelector("img"));
                O instanceof HTMLPictureElement && (O = O.querySelector("img"));
                A instanceof HTMLPictureElement && (A = A.querySelector("img"));
                if (A && (A.style.visibility = "hidden", D("protected"))) {
                    A.addEventListener("contextmenu", (e)=>{
                        e.preventDefault();
                    });
                    const e = document.createElement("div");
                    (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(e, "f-panzoom__protected"), A.appendChild(e);
                }
                H("initLayout");
            }(), function() {
                if (c && E && !F) {
                    let e = null;
                    F = new ResizeObserver(()=>{
                        I() && (e = e || requestAnimationFrame(()=>{
                            I() && (le(), re(), H("refresh")), e = null;
                        }));
                    }), F.observe(E), z.push(()=>{
                        null == F || F.disconnect(), F = void 0, e && (cancelAnimationFrame(e), e = null);
                    });
                }
            }(), function() {
                if (!c || !C) return;
                if (!$868588f20a38800c$var$m(C) || !$868588f20a38800c$var$m(O)) return void N();
                const e = ()=>{
                    C && $868588f20a38800c$var$m(C) && C.decode().then(()=>{
                        N();
                    }).catch(()=>{
                        N();
                    });
                };
                if (L = 1, c.classList.add("is-loading"), H("loading"), O.src && O.complete) return void e();
                (function() {
                    if (!c) return;
                    if (null == c ? void 0 : c.querySelector(".f-spinner")) return;
                    const e = D("spinnerTpl"), t = (0, $81976219b3588213$export$b368690db5627d91)(e);
                    t && (t.classList.add("f-spinner"), c.classList.add("is-loading"), null == E || E.insertAdjacentElement("afterbegin", t));
                })(), O.addEventListener("load", e, !1), O.addEventListener("error", e, !1), z.push(()=>{
                    null == O || O.removeEventListener("load", e, !1), null == O || O.removeEventListener("error", e, !1);
                });
            }(), xe;
        },
        isDragging: ve,
        isExpanded: be,
        isFullsize: ye,
        localize: function(e, t = []) {
            const n = D("l10n") || {};
            e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t)=>n[t] || e);
            for(let n = 0; n < t.length; n++)e = e.split(t[n][0]).join(t[n][1]);
            return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
        },
        off: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])W.has(n) && W.set(n, W.get(n).filter((e)=>e !== t));
            return xe;
        },
        on: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])W.set(n, [
                ...W.get(n) || [],
                t
            ]);
            return xe;
        },
        version: "6.0.29",
        willZoomIn: fe,
        willZoomOut: ge
    };
    return xe;
};
$868588f20a38800c$export$b704d075ddd20210.l10n = {
    en_EN: (0, $65b2220f881fadfb$export$30568d076ec2f42)
}, $868588f20a38800c$export$b704d075ddd20210.getDefaults = ()=>$868588f20a38800c$var$y;


/*! License details at fancyapps.com/license */ 



/*! License details at fancyapps.com/license */ const $f52266445ed38812$export$2b0209f2592da03b = (e, o)=>{
    let t = [];
    return e.childNodes.forEach((e)=>{
        e.nodeType !== Node.ELEMENT_NODE || o && !e.matches(o) || t.push(e);
    }), t;
};











/*! License details at fancyapps.com/license */ 
const $9ceb4493d65212ad$export$30568d076ec2f42 = Object.assign(Object.assign({}, (0, $65b2220f881fadfb$export$30568d076ec2f42)), {
    ERROR: "Something went wrong. <br /> Please try again later.",
    NEXT: "Next page",
    PREV: "Previous page",
    GOTO: "Go to page #%d",
    DOWNLOAD: "Download",
    TOGGLE_FULLSCREEN: "Toggle full-screen mode",
    TOGGLE_EXPAND: "Toggle full-size mode",
    TOGGLE_THUMBS: "Toggle thumbnails",
    TOGGLE_AUTOPLAY: "Toggle slideshow"
});


const $da1ac87b7e404694$var$g = (e)=>{
    e.cancelable && e.preventDefault();
}, $da1ac87b7e404694$var$m = {
    adaptiveHeight: !1,
    center: !0,
    classes: {
        container: "f-carousel",
        isEnabled: "is-enabled",
        isLTR: "is-ltr",
        isRTL: "is-rtl",
        isHorizontal: "is-horizontal",
        isVertical: "is-vertical",
        hasAdaptiveHeight: "has-adaptive-height",
        viewport: "f-carousel__viewport",
        slide: "f-carousel__slide",
        isSelected: "is-selected"
    },
    dragFree: !1,
    enabled: !0,
    errorTpl: '<div class="f-html">{{ERROR}}</div>',
    fill: !1,
    infinite: !0,
    initialPage: 0,
    l10n: (0, $9ceb4493d65212ad$export$30568d076ec2f42),
    rtl: !1,
    slides: [],
    slidesPerPage: "auto",
    spinnerTpl: '<div class="f-spinner"></div>',
    transition: "fade",
    tween: {
        clamp: !0,
        mass: 1,
        tension: 160,
        friction: 25,
        restDelta: 1,
        restSpeed: 1,
        velocity: 0
    },
    vertical: !1
};
let $da1ac87b7e404694$var$h, $da1ac87b7e404694$var$b = 0;
const $da1ac87b7e404694$export$144901db2ea8e967 = (p, x = {}, y = {})=>{
    $da1ac87b7e404694$var$b++;
    let w, M, S, j, P, L = 0, A = Object.assign({}, $da1ac87b7e404694$var$m), O = Object.assign({}, $da1ac87b7e404694$var$m), T = {}, R = null, V = null, C = !1, H = !1, D = !1, $ = !1, z = "height", q = 0, F = !0, I = 0, k = 0, B = 0, N = 0, _ = "*", G = [], X = [];
    const Y = new Set;
    let W = [], J = [], K = 0, Q = 0, U = 0;
    function Z(e, ...t) {
        let n = O[e];
        return n && n instanceof Function ? n(He, ...t) : n;
    }
    function ee(e, t = []) {
        const n = Z("l10n") || {};
        e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t)=>n[t] || e);
        for(let n = 0; n < t.length; n++)e = e.split(t[n][0]).join(t[n][1]);
        return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
    }
    const te = new Map;
    function ne(e, ...t) {
        const n = [
            ...te.get(e) || []
        ];
        O.on && n.push(O.on[e]);
        for (const e of n)e && e instanceof Function && e(He, ...t);
        "*" !== e && ne("*", e, ...t);
    }
    function ie() {
        var t, n;
        const i = (0, $56a4b1af55519d9a$export$8b58be045bf06082)({}, $da1ac87b7e404694$var$m, A);
        (0, $56a4b1af55519d9a$export$8b58be045bf06082)(i, $da1ac87b7e404694$var$m, A);
        let r = "";
        const l = A.breakpoints || {};
        if (l) for (const [e, t] of Object.entries(l))window.matchMedia(e).matches && (r += e, (0, $56a4b1af55519d9a$export$8b58be045bf06082)(i, t));
        if (void 0 === P || r !== P) {
            if (P = r, 0 !== L) {
                let e = null === (n = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0]) || void 0 === n ? void 0 : n.index;
                void 0 === e && (e = O.initialSlide), i.initialSlide = e, i.slides = [];
                for (const e of G)e.isVirtual && i.slides.push(e);
            }
            Re(), O = i, !1 !== O.enabled && (L = 0, ne("init"), function() {
                for (const [e, t] of Object.entries(Object.assign(Object.assign({}, y), O.plugins || {})))if (e && !T[e] && t instanceof Function) {
                    const n = t();
                    n.init(He, $da1ac87b7e404694$export$144901db2ea8e967), T[e] = n;
                }
                ne("initPlugins");
            }(), function() {
                if (!R) return;
                const t = Z("classes") || {};
                (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(R, t.container);
                const n = Z("style");
                if (n && (0, $dc093197fa71c887$export$53b83ca8eaab0383)(n)) for (const [e, t] of Object.entries(n))R.style.setProperty(e, t);
                V = R.querySelector(`.${t.viewport}`), V || (V = document.createElement("div"), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(V, t.viewport), V.append(...(0, $f52266445ed38812$export$2b0209f2592da03b)(R, `.${t.slide}`)), R.insertAdjacentElement("afterbegin", V)), R.carousel = He, ne("initLayout");
            }(), function() {
                if (!V) return;
                const e = Z("classes") || {};
                G = [], [
                    ...(0, $f52266445ed38812$export$2b0209f2592da03b)(V, `.${e.slide}`)
                ].forEach((e)=>{
                    e.parentElement && G.push(me(Object.assign({
                        el: e,
                        isVirtual: !1
                    }, e.dataset || {})));
                }), ge(Z("slides"));
                for (const e of G)ne("addSlide", e);
                for (const e of G){
                    const t = e.el;
                    (null == t ? void 0 : t.parentElement) && ((0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(t, O.classes.slide), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(t, e.class), Ae(e), ne("attachSlideEl", e));
                }
                ne("initSlides");
            }(), ye(), function() {
                if (R && (R.addEventListener("click", je, {
                    passive: !1
                }), document.addEventListener("mousemove", oe), !S)) {
                    let e = null;
                    S = new ResizeObserver((t)=>{
                        e || (e = requestAnimationFrame(()=>{
                            !function(e) {
                                var t;
                                if (!R) return;
                                if (0 === L) {
                                    const n = null === (t = e[0]) || void 0 === t ? void 0 : t.contentBoxSize[0], i = (null == n ? void 0 : n.blockSize) || 0, o = (null == n ? void 0 : n.inlineSize) || 0;
                                    return K = i, Q = o, L = 1, (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(R, (Z("classes") || {}).isEnabled), Te(), M = (0, $6f48c3b0d4f5e032$export$208a41d6b4e37b97)().on("start", ()=>{
                                        w && w.isPointerDown() || (le(), Te());
                                    }).on("step", (e)=>{
                                        const t = q;
                                        q = e.pos, q !== t && (F = !1, Te());
                                    }).on("end", (e)=>{
                                        (null == w ? void 0 : w.isPointerDown()) || (q = e.pos, M && !H && (q < B || q > N) ? M.spring({
                                            clamp: !0,
                                            mass: 1,
                                            tension: 200,
                                            friction: 25,
                                            velocity: 0,
                                            restDelta: 1,
                                            restSpeed: 1
                                        }).from({
                                            pos: q
                                        }).to({
                                            pos: (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(B, q, N)
                                        }).start() : F || (F = !0, ne("settle")));
                                    }), se(), ae(), void ne("ready");
                                }
                                if (1 !== L) return;
                                const n = J.length;
                                ye(), se();
                                const i = R.getBoundingClientRect(), o = i.height, s = i.width;
                                n > 1 && ($ && Math.abs(o - K) < .5 || !$ && Math.abs(s - Q) < .5) || (K = o, Q = s, $ && !o || !$ && !s || R && V && (n === J.length && (null == w ? void 0 : w.isPointerDown()) || (Z("dragFree") && (H || q > B && q < N) ? (le(), Te()) : Oe(I, {
                                    transition: !1
                                }))));
                            }(t), e = null;
                        }));
                    }), S.observe(R);
                }
            }());
        }
    }
    function oe(e) {
        $da1ac87b7e404694$var$h = e;
    }
    function se() {
        if (!V) return;
        const e = Z("gestures");
        !1 !== e ? w || (w = (0, $fff24a5500e60204$export$1f911e2d31b2843e)(V, e).on("start", (e)=>{
            var t, n;
            if (!M) return;
            const { srcEvent: o } = e;
            $ && (0, $16dbdcd3a6f0d21d$export$e41e80160bed5714)(o.target), M.pause(), M.getCurrentVelocities().pos = 0;
            const s = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0];
            if (s && Y.has(s.index) && s.el && (q = s.offset || 0, q += (function(e) {
                const t = window.getComputedStyle(e), n = new DOMMatrixReadOnly(t.transform);
                return {
                    width: n.m41 || 0,
                    height: n.m42 || 0
                };
            }(s.el)[z] || 0) * (D && !$ ? 1 : -1)), Me(), !H) (q < B || q > N) && M.spring({
                clamp: !0,
                mass: 1,
                tension: 500,
                friction: 25,
                velocity: (null === (n = M.getCurrentVelocities()) || void 0 === n ? void 0 : n.pos) || 0,
                restDelta: 1,
                restSpeed: 1
            }).from({
                pos: q
            }).to({
                pos: (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(B, q, N)
            }).start();
        }).on("move", (e)=>{
            const { srcEvent: t, axis: n } = e, o = e.srcEvent.target;
            o && (0, $16dbdcd3a6f0d21d$export$e41e80160bed5714)(o) || (n || (t.stopPropagation(), t.stopImmediatePropagation()), ("y" === n && $ || "x" === n && !$) && ($da1ac87b7e404694$var$g(t), t.stopPropagation()));
        }).on("panstart", (e)=>{
            (null == e ? void 0 : e.axis) === ($ ? "y" : "x") && (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(V, "is-dragging");
        }).on("panend", ()=>{
            (0, $e49a661321e90b65$export$c2255604a80b4506)(V, "is-dragging");
        }).on("pan", (e)=>{
            var t;
            const { deltaX: n, deltaY: i, currentTouch: o, axis: s } = e;
            if (!M) return;
            if (o.length > 1) return;
            if ("y" === s && !$ || "x" === s && $) return;
            const r = D && !$ ? 1 : -1;
            let l = $ ? i : n, a = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q, c = 1;
            H || (a <= B && l * r < 0 ? (c = Math.max(.01, 1 - Math.abs(1 / fe() * Math.abs(a - B))), c *= .2) : a >= N && l * r > 0 && (c = Math.max(.01, 1 - Math.abs(1 / fe() * Math.abs(a - N))), c *= .2)), a += l * c * r, M.spring({
                clamp: !0,
                mass: 1,
                tension: 700,
                friction: 25,
                velocity: (null === (t = M.getCurrentVelocities()) || void 0 === t ? void 0 : t.pos) || 0,
                restDelta: 1,
                restSpeed: 1
            }).from({
                pos: q
            }).to({
                pos: a
            }).start();
        }).on("end", (e)=>{
            var t, n;
            const { axis: i, velocityX: o, velocityY: s, currentTouch: r } = e, l = J.length, c = Z("dragFree");
            if (r.length > 0 || !M) return;
            if (!l) return;
            const d = Z("vertical") ? s : o;
            let u = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q;
            const f = D && !$ ? 1 : -1;
            if (u += d * (c ? 5 : 1) * f, !H && (d * f <= 0 && u < B || d * f >= 0 && u > N)) {
                let e = 0;
                return Math.abs(d) > 0 && (e = 2 * Math.abs(d), e = Math.min(.3 * fe(), e)), u = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(B + -1 * e, u, N + e), void M.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 380,
                    friction: 25,
                    velocity: -1 * d,
                    restDelta: 1,
                    restSpeed: 1
                }).from({
                    pos: q
                }).to({
                    pos: u
                }).start();
            }
            if (c || (null === (t = T.Autoscroll) || void 0 === t ? void 0 : t.isEnabled())) return void (Math.abs(d) > 10 ? M.spring({
                clamp: !0,
                mass: 1,
                tension: 150,
                friction: 25,
                velocity: -1 * d,
                restDelta: 1,
                restSpeed: 1
            }).from({
                pos: q
            }).to({
                pos: u
            }).start() : M.isRunning() || F || (F = !0, ne("settle")));
            if (!c && !(null === (n = T.Autoscroll) || void 0 === n ? void 0 : n.isEnabled()) && (!e.offsetX && !e.offsetY || "y" === i && !$ || "x" === i && $)) return void Oe(I, {
                transition: "tween"
            });
            let v = de(u);
            Math.abs(d) > 10 && v === I && (v += d > 0 ? D && !$ ? 1 : -1 : D && !$ ? -1 : 1), Oe(v, {
                transition: "tween",
                tween: {
                    velocity: -1 * d
                }
            });
        }).init()) : w && (w.destroy(), w = void 0);
    }
    function re(e = "*") {
        var t;
        const n = [];
        for (const i of G)("*" === e || i.class && i.class.includes(e) || i.el && (null === (t = i.el) || void 0 === t ? void 0 : t.classList.contains(e))) && n.push(i);
        j = void 0, _ = e, X = [
            ...n
        ];
    }
    function le() {
        if (!M) return;
        const e = de((null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q);
        e !== I && (j = I, I = e, Ae(), ae(), ce(), ne("change", I, j));
    }
    function ae() {
        var e;
        if (!R) return;
        (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(V, "is-draggable", !!w && J.length > 0);
        for (const e of R.querySelectorAll("[data-carousel-index]"))e.innerHTML = I + "";
        for (const e of R.querySelectorAll("[data-carousel-page]"))e.innerHTML = I + 1 + "";
        for (const e of R.querySelectorAll("[data-carousel-pages]"))e.innerHTML = J.length + "";
        for (const e of R.querySelectorAll("[data-carousel-go-prev]"))e.toggleAttribute("aria-disabled", !Ve()), Ve() ? e.removeAttribute("tabindex") : e.setAttribute("tabindex", "-1");
        for (const e of R.querySelectorAll("[data-carousel-go-next]"))e.toggleAttribute("aria-disabled", !Ce()), Ce() ? e.removeAttribute("tabindex") : e.setAttribute("tabindex", "-1");
        let t = !1;
        const n = null === (e = J[I]) || void 0 === e ? void 0 : e.slides[0];
        n && (n.downloadSrc || "image" === n.type && n.src) && (t = !0);
        for (const e of R.querySelectorAll("[data-carousel-download]"))e.toggleAttribute("aria-disabled", !t);
    }
    function ce(e) {
        var t;
        e || (e = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0]);
        const n = e.el;
        if (n) for (const t of n.querySelectorAll("[data-slide-index]"))t.innerHTML = e.index + 1 + "";
    }
    function de(e) {
        var t, n, i;
        if (!J.length || !M) return 0;
        const o = ve();
        let s = e;
        H ? s -= Math.floor((e - (null === (t = J[0]) || void 0 === t ? void 0 : t.pos)) / o) * o : s = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(null === (n = J[0]) || void 0 === n ? void 0 : n.pos, e, null === (i = J[J.length - 1]) || void 0 === i ? void 0 : i.pos);
        const r = new Map;
        let l = 0;
        for (const e of J){
            const t = Math.abs(e.pos - s), n = Math.abs(e.pos - s - o), i = Math.abs(e.pos - s + o), a = Math.min(t, n, i);
            r.set(l, a), l++;
        }
        const c = r.size > 0 ? [
            ...r.entries()
        ].reduce((e, t)=>t[1] < e[1] ? t : e) : [
            I,
            0
        ];
        return parseInt(c[0]);
    }
    function ue() {
        return U;
    }
    function fe() {
        return V && V.getBoundingClientRect()[z] || 0;
    }
    function ve(e = !0) {
        return X.reduce((e, t)=>e + t.dim, 0) + (X.length - (H && e ? 0 : 1)) * U;
    }
    function pe(e) {
        const t = ve();
        let n = fe();
        if (!V) return [];
        const i = [];
        if (!t || !n) return [];
        e = void 0 === e ? q : e, H && (e -= Math.floor(e / t) * t);
        let o = 0, s = 0;
        if (C) {
            const e = V.getBoundingClientRect();
            o = Math.abs(e.left), s = Math.abs(window.innerWidth - e.right);
        }
        let r = 0;
        for (let l of X){
            const a = (t = 0)=>{
                i.indexOf(l) > -1 || (l.pos = r - e + t || 0, l.offset + t > e - l.dim - o + .51 && l.offset + t < e + n + s - .51 && i.push(l));
            };
            l.offset = r, H && (a(t), a(-1 * t)), a(), r += l.dim + U;
        }
        return i;
    }
    function ge(e, t) {
        const n = [];
        for (const t of Array.isArray(e) ? e : [
            e
        ]){
            const e = me(Object.assign(Object.assign({}, t), {
                isVirtual: !0
            }));
            n.push(e);
        }
        G.splice(void 0 === t ? G.length : t, 0, ...n), xe();
        for (const e of n)he(e);
        return re(_), n;
    }
    function me(e) {
        return ((0, $585a18adb7d59904$export$844ec244b1367d54)(e) || e instanceof HTMLElement) && (e = {
            html: e
        }), Object.assign({
            index: -1,
            el: void 0,
            class: "",
            isVirtual: !0,
            dim: 0,
            pos: 0,
            offset: 0,
            html: "",
            src: ""
        }, e);
    }
    function he(e) {
        if (!e) return;
        let t = e.el;
        t || (t = document.createElement("div"), e.el = t);
        const n = e.html ? e.html instanceof HTMLElement ? e.html : (0, $81976219b3588213$export$b368690db5627d91)(e.html) : void 0;
        n && ((0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(n, "f-html"), e.htmlEl = n, (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(t, "has-html"), t.append(n), ne("contentReady", e));
    }
    function be(e) {
        if (!V || !e) return;
        let t = e.el;
        if (t) {
            if (t.setAttribute("index", e.index + ""), t.parentElement !== V) {
                let n;
                (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(t, O.classes.slide), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(t, e.class), Ae(e);
                for (const t of G)if (t.index > e.index) {
                    n = t.el;
                    break;
                }
                V.insertBefore(t, n && V.contains(n) ? n : null), ne("attachSlideEl", e);
            }
            return ce(e), t;
        }
    }
    function Ee(e) {
        const t = null == e ? void 0 : e.el;
        t && (t.remove(), we(t), ne("detachSlideEl", e));
    }
    function xe() {
        for(let e = 0; e < G.length; e++){
            const t = G[e], n = t.el;
            n && (t.index !== e && we(n), n.setAttribute("index", `${e}`)), t.index = e;
        }
    }
    function ye() {
        var e, n, i, o, s;
        if (!R || !V) return;
        D = Z("rtl"), $ = Z("vertical"), z = $ ? "height" : "width";
        const r = Z("classes");
        (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(R, r.isLTR, !D), (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(R, r.isRTL, D), (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(R, r.isHorizontal, !$), (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(R, r.isVertical, $), (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(R, r.hasAdaptiveHeight, Z("adaptiveHeight")), C = "visible" === window.getComputedStyle(V).getPropertyValue("overflow-" + ($ ? "y" : "x"));
        const l = V.getBoundingClientRect();
        if (!l.width && !l.height) return;
        U = V && parseFloat(getComputedStyle(V).getPropertyValue("--f-carousel-gap")) || 0;
        const d = function() {
            let e = 0;
            if (V) {
                let t = document.createElement("div");
                (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(t, O.classes.slide), V.appendChild(t), e = t.getBoundingClientRect()[z], t.remove(), t = void 0;
            }
            return e;
        }();
        for (const n of X){
            const i = n.el;
            let o = 0;
            if (!n.isVirtual && i && (0, $72eb7366a788e3d9$export$8ee0fc9ee280b4ee)(i)) {
                let t = !1;
                i.parentElement && i.parentElement === V || (V.appendChild(i), t = !0), o = i.getBoundingClientRect()[z], t && (null === (e = i.parentElement) || void 0 === e || e.removeChild(i));
            } else o = d;
            n.dim = o;
        }
        if (H = !1, Z("infinite")) {
            H = !0;
            const e = ve();
            let t = fe();
            if (C) {
                const e = V.getBoundingClientRect();
                t += e.left, t += e.right - e.width;
            }
            for(let i = 0; i < X.length; i++){
                const o = (null === (n = X[i]) || void 0 === n ? void 0 : n.dim) + U;
                if (e - o < t && e - o - t < o) {
                    H = !1;
                    break;
                }
            }
        }
        if (function() {
            var e;
            if (!R) return;
            xe();
            const t = fe(), n = ve(!1);
            let i = Z("slidesPerPage");
            i = "auto" === i ? 1 / 0 : parseFloat(i + ""), J = [];
            let o = 0, s = 0;
            for (const n of X)(!J.length || o + n.dim - t > .05 || s >= i) && (J.push({
                index: J.length,
                slides: [],
                dim: 0,
                offset: 0,
                pos: 0
            }), o = 0, s = 0), null === (e = J[J.length - 1]) || void 0 === e || e.slides.push(n), o += n.dim + U, s++;
            const r = Z("center"), l = Z("fill");
            let c = 0;
            for (const e of J){
                e.dim = (e.slides.length - 1) * U;
                for (const t of e.slides)e.dim += t.dim;
                e.offset = c, e.pos = c, !1 !== r && (e.pos -= .5 * (t - e.dim)), l && !H && n > t && (e.pos = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(0, e.pos, n - t)), c += e.dim + U;
            }
            const d = [];
            let u;
            for (const e of J){
                const t = Object.assign({}, e);
                u && Math.abs(t.pos - u.pos) < .1 ? (u.dim += t.dim, u.slides = [
                    ...u.slides,
                    ...t.slides
                ]) : (u = t, t.index = d.length, d.push(t));
            }
            J = d, ae();
        }(), B = (null === (i = J[0]) || void 0 === i ? void 0 : i.pos) || 0, N = (null === (o = J[J.length - 1]) || void 0 === o ? void 0 : o.pos) || 0, 0 === L) !function() {
            var e;
            j = void 0, I = Z("initialPage");
            const t = Z("initialSlide") || void 0;
            void 0 !== t && (I = He.getPageIndex(t) || 0), I = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(0, I, J.length - 1), q = (null === (e = J[I]) || void 0 === e ? void 0 : e.pos) || 0, k = q;
        }();
        else {
            const e = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q;
            (e < B || e > N) && (I = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(0, I, J.length - 1), k = (null === (s = J[I || 0]) || void 0 === s ? void 0 : s.pos) || 0);
        }
        ne("refresh");
    }
    function we(e) {
        if (!e || !(0, $72eb7366a788e3d9$export$8ee0fc9ee280b4ee)(e)) return;
        const n = parseInt(e.getAttribute("index") || "-1");
        let i = "";
        for (const t of Array.from(e.classList)){
            const e = t.match(/^f-(\w+)(Out|In)$/);
            e && e[1] && (i = e[1] + "");
        }
        if (!e || !i) return;
        const o = [
            `f-${i}Out`,
            `f-${i}In`,
            "to-prev",
            "to-next",
            "from-prev",
            "from-next"
        ];
        e.removeEventListener("animationend", Se), (0, $e49a661321e90b65$export$c2255604a80b4506)(e, o.join(" ")), Y.delete(n);
    }
    function Me() {
        if (!V) return;
        const e = Y.size;
        for (const e of X)we(e.el);
        Y.clear(), e && Te();
    }
    function Se(e) {
        "f-" === e.animationName.substring(0, 2) && (we(e.target), Y.size || ((0, $e49a661321e90b65$export$c2255604a80b4506)(R, "in-transition"), !F && Math.abs(He.getPosition(!0) - k) < .5 && (F = !0, ne("settle"))), Te());
    }
    function je(e) {
        var t;
        if (e.defaultPrevented) return;
        const n = e.composedPath()[0];
        if (n.closest("[data-carousel-go-prev]")) return $da1ac87b7e404694$var$g(e), void He.prev();
        if (n.closest("[data-carousel-go-next]")) return $da1ac87b7e404694$var$g(e), void He.next();
        const i = n.closest("[data-carousel-go-to]");
        if (i) return $da1ac87b7e404694$var$g(e), void He.goTo(parseFloat(i.dataset.carouselGoTo || "") || 0);
        if (n.closest("[data-carousel-download]")) {
            $da1ac87b7e404694$var$g(e);
            const n = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0];
            if (n && (n.downloadSrc || "image" === n.type && n.src)) {
                const e = n.downloadFilename, t = document.createElement("a"), i = n.downloadSrc || n.src || "";
                t.href = i, t.target = "_blank", t.download = e || i, t.click();
            }
        } else ne("click", e);
    }
    function Pe(e) {
        var t;
        const n = e.el;
        n && (null === (t = n.querySelector(".f-spinner")) || void 0 === t || t.remove());
    }
    function Le(e) {
        var t;
        const n = e.el;
        n && (null === (t = n.querySelector(".f-html.is-error")) || void 0 === t || t.remove(), (0, $e49a661321e90b65$export$c2255604a80b4506)(n, "has-error"));
    }
    function Ae(e) {
        var t;
        e || (e = null === (t = J[I]) || void 0 === t ? void 0 : t.slides[0]);
        const i = null == e ? void 0 : e.el;
        if (!i) return;
        let o = Z("formatCaption", e);
        void 0 === o && (o = e.caption), o = o || "";
        const s = Z("captionEl");
        if (s && s instanceof HTMLElement) {
            if (e.index !== I) return;
            if ((0, $585a18adb7d59904$export$844ec244b1367d54)(o) && (s.innerHTML = ee(o + "")), o instanceof HTMLElement) {
                if (o.parentElement === s) return;
                s.innerHTML = "", o.parentElement && (o = o.cloneNode(!0)), s.append(o);
            }
            return;
        }
        if (!o) return;
        let r = e.captionEl || i.querySelector(".f-caption");
        !r && o instanceof HTMLElement && o.classList.contains("f-caption") && (r = o), r || (r = document.createElement("div"), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(r, "f-caption"), (0, $585a18adb7d59904$export$844ec244b1367d54)(o) ? r.innerHTML = ee(o + "") : o instanceof HTMLElement && (o.parentElement && (o = o.cloneNode(!0)), r.append(o)));
        const l = `f-caption-${$da1ac87b7e404694$var$b}_${e.index}`;
        r.setAttribute("id", l), r.dataset.selectable = "true", (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(i, "has-caption"), i.setAttribute("aria-labelledby", l), e.captionEl = r, i.insertAdjacentElement("beforeend", r);
    }
    function Oe(t, i = {}) {
        var o, r;
        let { transition: l, tween: u } = Object.assign({
            transition: O.transition,
            tween: O.tween
        }, i || {});
        if (!R || !M) return;
        const f = J.length;
        if (!f) return;
        if (function(e, t) {
            var i, o, s, r;
            if (!(R && M && t && (0, $585a18adb7d59904$export$844ec244b1367d54)(t) && "tween" !== t)) return !1;
            if ((null === (i = J[I]) || void 0 === i ? void 0 : i.slides.length) > 1) return !1;
            const l = J.length;
            let u = e > I ? 1 : -1;
            e = H ? (e % l + l) % l : (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(0, e, l - 1), D && (u *= -1);
            const f = null === (o = J[I]) || void 0 === o ? void 0 : o.slides[0], v = null == f ? void 0 : f.index, p = null === (s = J[e]) || void 0 === s ? void 0 : s.slides[0], g = null == p ? void 0 : p.index, m = null === (r = J[e]) || void 0 === r ? void 0 : r.pos;
            if (void 0 === g || void 0 === v || v === g || q === m || Math.abs(fe() - ((null == p ? void 0 : p.dim) || 0)) > 1) return !1;
            F = !1, M.pause(), Me(), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(R, "in-transition"), q = k = m;
            const h = be(f), b = be(p);
            return le(), h && (Y.add(v), h.style.transform = "", h.addEventListener("animationend", Se), (0, $e49a661321e90b65$export$c2255604a80b4506)(h, O.classes.isSelected), h.inert = !1, (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(h, `f-${t}Out to-${u > 0 ? "next" : "prev"}`)), b && (Y.add(g), b.style.transform = "", b.addEventListener("animationend", Se), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(b, O.classes.isSelected), b.inert = !1, (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(b, `f-${t}In from-${u > 0 ? "prev" : "next"}`)), Te(), !0;
        }(t, l)) return;
        t = H ? (t % f + f) % f : (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(0, t, f - 1), k = (null === (o = J[t || 0]) || void 0 === o ? void 0 : o.pos) || 0;
        const v = M.isRunning() ? M.getEndValues().pos : q;
        if (Math.abs(k - v) < 1) return q = k, I !== t && (Ae(), ae(), ce(), j = I, I = t, ne("change", I, j)), Te(), void (F || (F = !0, ne("settle")));
        if (M.pause(), Me(), H) {
            const e = ve(), t = Math.floor((v - (null === (r = J[0]) || void 0 === r ? void 0 : r.pos)) / e), n = k + t * e;
            k = [
                n + e,
                n,
                n - e
            ].reduce(function(e, t) {
                return Math.abs(t - v) < Math.abs(e - v) ? t : e;
            });
        }
        !1 !== l && (0, $dc093197fa71c887$export$53b83ca8eaab0383)(u) ? M.spring((0, $56a4b1af55519d9a$export$8b58be045bf06082)({}, O.tween, u)).from({
            pos: q
        }).to({
            pos: k
        }).start() : (q = k, le(), Te(), F || (F = !0, ne("settle")));
    }
    function Te() {
        var e;
        if (!R || !V) return;
        const t = J[I];
        W = pe();
        const n = new Set;
        let i;
        const s = [];
        for (const o of X){
            if (o.isVirtual && !Y.has(o.index) && W.indexOf(o) < 0) continue;
            let r = be(o);
            if (!r) continue;
            s.push(o);
            const l = (null === (e = null == t ? void 0 : t.slides) || void 0 === e ? void 0 : e.indexOf(o)) > -1;
            if (l && n.add(r), Z("adaptiveHeight") && l) {
                const e = (r.firstElementChild || r).getBoundingClientRect().height;
                i = null == i ? e : Math.max(i, e);
            }
        }
        V && i && (V.style.height = `${i}px`), [
            ...(0, $f52266445ed38812$export$2b0209f2592da03b)(V, `.${O.classes.slide}`)
        ].forEach((e)=>{
            const t = parseInt(e.getAttribute("index") || "-1"), i = G[t];
            i || e.remove();
            const o = n.has(e);
            if ((0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(e, O.classes.isSelected, o), e.inert = W.indexOf(i) < 0, i.isVirtual && !Y.has(i.index) && W.indexOf(i) < 0) return void Ee(i);
            let s = i.pos ? Math.round(1e4 * i.pos) / 1e4 : 0, l = 0, a = 0, c = 0, d = 0, f = O.setTransform || void 0;
            Y.has(i.index) || (l = $ ? 0 : D ? -1 * s : s, a = $ ? s : 0, c = (0, $cc0f4c55c8b6e1bf$export$871de8747c9eaa88)(l, 0, i.dim, 0, 100), d = (0, $cc0f4c55c8b6e1bf$export$871de8747c9eaa88)(a, 0, i.dim, 0, 100)), f instanceof Function && !Y.has(i.index) ? f(He, i, {
                x: l,
                y: a,
                xPercent: c,
                yPercent: d
            }) : e.style.transform = l || a ? `translate3d(${c}%, ${d}%,0)` : "";
        }), ne("render", s);
    }
    function Re() {
        var e;
        null == R || R.removeEventListener("click", je), Me(), document.removeEventListener("mousemove", oe), null == S || S.disconnect(), S = void 0;
        for (const n of G)n.el && (0, $72eb7366a788e3d9$export$8ee0fc9ee280b4ee)(n.el) && (n.state = void 0, Pe(n), Le(n), Ee(n), n.isVirtual ? (null === (e = n.el) || void 0 === e || e.remove(), n.el = void 0) : (n.el.style.transform = "", null == V || V.appendChild(n.el)));
        for (const e of Object.values(T))null == e || e.destroy();
        T = {}, null == w || w.destroy(), w = void 0, null == M || M.destroy(), M = void 0;
        for (const [e, t] of Object.entries(O.classes || {}))"container" !== e && (0, $e49a661321e90b65$export$c2255604a80b4506)(R, t);
        (0, $e49a661321e90b65$export$c2255604a80b4506)(V, "is-draggable");
    }
    function Ve() {
        return H || I > 0;
    }
    function Ce() {
        return H || I < J.length - 1;
    }
    const He = {
        add: function(e, t) {
            var n, i;
            let o = q;
            const s = I, r = ve(), l = (null == M ? void 0 : M.isRunning()) ? M.getEndValues().pos : q, a = Math.floor((l - (null === (n = J[0]) || void 0 === n ? void 0 : n.pos)) / r), c = ge(e, t);
            for (const e of c)ne("addSlide", e);
            return re(_), ye(), M && (s === I && (o -= a * r), k = (null === (i = J[I || 0]) || void 0 === i ? void 0 : i.pos) || 0, o === k ? q = k : M.spring({
                clamp: !0,
                mass: 1,
                tension: 300,
                friction: 25,
                restDelta: 1,
                restSpeed: 1
            }).from({
                pos: o
            }).to({
                pos: k
            }).start()), Te(), He;
        },
        canGoPrev: Ve,
        canGoNext: Ce,
        destroy: function() {
            return ne("destroy"), window.removeEventListener("resize", ie), Re(), te.clear(), R = null, J = [], G = [], O = Object.assign({}, $da1ac87b7e404694$var$m), T = {}, X = [], P = "", _ = "*", L = 2, He;
        },
        emit: ne,
        filter: function(e = "*") {
            return re(e), ye(), Te(), ne("filter", e), He;
        },
        getContainer: function() {
            return R;
        },
        getGapDim: ue,
        getGestures: function() {
            return w;
        },
        getLastMouseMove: function() {
            return $da1ac87b7e404694$var$h;
        },
        getOption: function(e) {
            return Z(e);
        },
        getOptions: function() {
            return O;
        },
        getPage: function() {
            return J[I];
        },
        getPageIndex: function(e) {
            if (void 0 !== e) {
                for (const t of J || [])for (const n of t.slides)if (n.index === e) return t.index;
                return -1;
            }
            return I;
        },
        getPageProgress: function(e, t) {
            var n;
            void 0 === e && (e = I);
            const i = J[e];
            if (!i) return e > I ? -1 : 1;
            const o = ve(), s = ue();
            let r = i.pos, l = He.getPosition();
            if (H && !0 !== t) {
                const e = Math.floor((l - (null === (n = J[0]) || void 0 === n ? void 0 : n.pos)) / o);
                l -= e * o, r = [
                    r + o,
                    r,
                    r - o
                ].reduce(function(e, t) {
                    return Math.abs(t - l) < Math.abs(e - l) ? t : e;
                });
            }
            return (l - r) / (i.dim + s);
        },
        getPageVisibility: function(e) {
            var t;
            void 0 === e && (e = I);
            const n = J[e];
            if (!n) return e > I ? -1 : 1;
            const i = He.getPosition(), o = fe();
            let s = n.pos;
            if (H) {
                const e = He.getPosition(), n = ve(), i = s + Math.floor((e - (null === (t = J[0]) || void 0 === t ? void 0 : t.pos)) / n) * n;
                s = [
                    i + n,
                    i,
                    i - n
                ].reduce(function(t, n) {
                    return Math.abs(n - e) < Math.abs(t - e) ? n : t;
                });
            }
            return s > i && s + n.dim < i + o ? 1 : s < i ? (s + n.dim - i) / n.dim : s + n.dim > i + o ? (i + o - s) / n.dim : 0;
        },
        getPages: function() {
            return J;
        },
        getPlugins: function() {
            return T;
        },
        getPosition: function(e) {
            var t;
            let n = q;
            if (H && !0 !== e) {
                const e = ve();
                n -= Math.floor((q - (null === (t = J[0]) || void 0 === t ? void 0 : t.pos) || 0) / e) * e;
            }
            return n;
        },
        getSlides: function() {
            return G;
        },
        getState: function() {
            return L;
        },
        getTotalSlideDim: ve,
        getTween: function() {
            return M;
        },
        getViewport: function() {
            return V;
        },
        getViewportDim: fe,
        getVisibleSlides: function(e) {
            return void 0 === e ? W : pe(e);
        },
        goTo: Oe,
        hasNavigated: function() {
            return void 0 !== j;
        },
        hideError: Le,
        hideLoading: Pe,
        init: function() {
            if (!p || !(0, $72eb7366a788e3d9$export$8ee0fc9ee280b4ee)(p)) throw new Error("No Element found");
            return 0 !== L && (Re(), L = 0), R = p, A = x, window.removeEventListener("resize", ie), A.breakpoints && window.addEventListener("resize", ie), ie(), He;
        },
        isInfinite: function() {
            return H;
        },
        isInTransition: function() {
            return Y.size > 0;
        },
        isRTL: function() {
            return D;
        },
        isSettled: function() {
            return F;
        },
        isVertical: function() {
            return $;
        },
        localize: function(e, t = []) {
            return ee(e, t);
        },
        next: function(e = {}) {
            return Oe(I + 1, e), He;
        },
        off: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])te.has(n) && te.set(n, te.get(n).filter((e)=>e !== t));
            return He;
        },
        on: function(e, t) {
            for (const n of e instanceof Array ? e : [
                e
            ])te.set(n, [
                ...te.get(n) || [],
                t
            ]);
            return He;
        },
        prev: function(e = {}) {
            return Oe(I - 1, e), He;
        },
        remove: function(e) {
            void 0 === e && (e = G.length - 1);
            const t = G[e];
            return t && (ne("removeSlide", t), t.el && (we(t.el), t.el.remove(), t.el = void 0), G.splice(e, 1), re(_), ye(), Te()), He;
        },
        setPosition: function(e) {
            q = e, le(), Te();
        },
        showError: function(e, t) {
            Pe(e), Le(e);
            const n = e.el;
            if (n) {
                const i = document.createElement("div");
                (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(i, "f-html"), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(i, "is-error"), i.innerHTML = ee(t || "<p>{{ERROR}}</p>"), e.htmlEl = i, (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(n, "has-html"), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(n, "has-error"), n.insertAdjacentElement("afterbegin", i), ne("contentReady", e);
            }
            return He;
        },
        showLoading: function(e) {
            const t = e.el, n = null == t ? void 0 : t.querySelector(".f-spinner");
            if (!t || n) return He;
            const i = Z("spinnerTpl"), o = (0, $81976219b3588213$export$b368690db5627d91)(i);
            return o && ((0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(o, "f-spinner"), t.insertAdjacentElement("beforeend", o)), He;
        },
        version: "6.0.29"
    };
    return He;
};
$da1ac87b7e404694$export$144901db2ea8e967.l10n = {
    en_EN: (0, $9ceb4493d65212ad$export$30568d076ec2f42)
}, $da1ac87b7e404694$export$144901db2ea8e967.getDefaults = ()=>$da1ac87b7e404694$var$m;


/*! License details at fancyapps.com/license */ 

/*! License details at fancyapps.com/license */ const $6ef6108b8aa723b5$export$b8b3234b4edfc4c2 = function(n = "", t = "", o = "") {
    return n.split(t).join(o);
};



const $32041ffb9773f9eb$var$a = {
    tpl: (t)=>`<img class="f-panzoom__content" \n    ${t.srcset ? 'data-lazy-srcset="{{srcset}}"' : ""} \n    ${t.sizes ? 'data-lazy-sizes="{{sizes}}"' : ""} \n    data-lazy-src="{{src}}" alt="{{alt}}" />`
}, $32041ffb9773f9eb$export$b7fc409e12a7dcec = ()=>{
    let s;
    function l(e, o) {
        const n = null == s ? void 0 : s.getOptions().Zoomable;
        let i = ((0, $dc093197fa71c887$export$53b83ca8eaab0383)(n) ? Object.assign(Object.assign({}, $32041ffb9773f9eb$var$a), n) : $32041ffb9773f9eb$var$a)[e];
        return i && "function" == typeof i && o ? i(o) : i;
    }
    function c() {
        s && (s.on("addSlide", u), s.on("removeSlide", f), s.on("attachSlideEl", m), s.on("click", d), s.on("change", r));
    }
    function r() {
        g();
    }
    function d(t, e) {
        const o = e.target;
        o && !e.defaultPrevented && o.dataset.panzoomAction && p(o.dataset.panzoomAction);
    }
    function u(t, i) {
        if (!s) return;
        const a = i.el;
        if (!a) return;
        const c = i.src || i.lazySrc || "", r = i.alt || i.caption || `Image #${i.index}`, d = i.srcset || i.lazySrcset || "", u = i.sizes || i.lazySizes || "";
        if (c && (0, $585a18adb7d59904$export$844ec244b1367d54)(c) && !i.html && (!i.type || "image" === i.type)) {
            i.type = "image", i.thumbSrc = i.thumbSrc || c;
            let t = l("tpl", i);
            t = (0, $6ef6108b8aa723b5$export$b8b3234b4edfc4c2)(t, "{{src}}", c + ""), t = (0, $6ef6108b8aa723b5$export$b8b3234b4edfc4c2)(t, "{{alt}}", r + ""), t = (0, $6ef6108b8aa723b5$export$b8b3234b4edfc4c2)(t, "{{srcset}}", d + ""), t = (0, $6ef6108b8aa723b5$export$b8b3234b4edfc4c2)(t, "{{sizes}}", u + ""), a.insertAdjacentHTML("afterbegin", t);
        }
        if (!a.querySelector(".f-panzoom__content")) return;
        const f = i.width && "auto" !== i.width ? parseFloat(i.width + "") : "auto", m = i.height && "auto" !== i.height ? parseFloat(i.height + "") : "auto", p = (0, $868588f20a38800c$export$b704d075ddd20210)(a, Object.assign({
            width: f,
            height: m,
            classes: {
                container: "f-zoomable"
            },
            event: ()=>null == s ? void 0 : s.getLastMouseMove(),
            spinnerTpl: ()=>(null == s ? void 0 : s.getOption("spinnerTpl")) || ""
        }, l("Panzoom")));
        p.on("*", (t, e, ...o)=>{
            s && ("loading" === e && (i.state = 0), "loaded" === e && (i.state = 1), "error" === e && (i.state = 2, null == s || s.showError(i, "{{IMAGE_ERROR}}")), s.emit(`panzoom:${e}`, i, ...o), "ready" === e && s.emit("contentReady", i), i.index === (null == s ? void 0 : s.getPageIndex()) && g());
        }), i.panzoomRef = p;
    }
    function f(t, e) {
        e.panzoomRef && (e.panzoomRef.destroy(), e.panzoomRef = void 0);
    }
    function m(t, e) {
        const o = e.panzoomRef;
        if (o) switch(o.getState()){
            case 0:
                o.init();
                break;
            case 3:
                o.execute((0, $868588f20a38800c$export$9520bccbaf78266).ZoomTo, Object.assign(Object.assign({}, o.getStartPosition()), {
                    velocity: 0
                }));
        }
    }
    function g() {
        var t;
        const e = null == s ? void 0 : s.getContainer();
        if (!e) return;
        const o = null === (t = null == s ? void 0 : s.getPage()) || void 0 === t ? void 0 : t.slides[0].panzoomRef, n = (null == o ? void 0 : o.canZoomIn()) || !1, a = (null == o ? void 0 : o.canZoomOut()) || !1, l = (null == o ? void 0 : o.isFullsize()) || !1, c = !o || 3 !== (null == o ? void 0 : o.getState());
        for (const t of (null == e ? void 0 : e.querySelectorAll("[data-panzoom-action]")) || []){
            const e = t.dataset.panzoomAction;
            let o = !1;
            if (c) o = !0;
            else switch(e){
                case (0, $868588f20a38800c$export$9520bccbaf78266).ZoomIn:
                    n || (o = !0);
                    break;
                case (0, $868588f20a38800c$export$9520bccbaf78266).ZoomOut:
                    a || (o = !0);
                    break;
                case (0, $868588f20a38800c$export$9520bccbaf78266).ToggleFull:
                    n || a || (o = !0);
                    const e1 = t.querySelector("g");
                    e1 && (e1.style.display = l ? "none" : "");
                    break;
                case (0, $868588f20a38800c$export$9520bccbaf78266).ToggleCover:
                case (0, $868588f20a38800c$export$9520bccbaf78266).ToggleMax:
                    n || a || (o = !0);
            }
            o ? (t.setAttribute("aria-disabled", ""), t.setAttribute("tabindex", "-1")) : (t.removeAttribute("aria-disabled"), t.removeAttribute("tabindex"));
        }
    }
    function p(t, ...e) {
        var o;
        null === (o = null == s ? void 0 : s.getPage().slides[0].panzoomRef) || void 0 === o || o.execute(t, ...e);
    }
    return {
        init: function(t) {
            s = t, !1 !== s.getOptions().Zoomable && s.on("initPlugins", c);
        },
        destroy: function() {
            if (s) {
                s.off("addSlide", u), s.off("removeSlide", f), s.off("attachSlideEl", m), s.off("click", d), s.off("change", r);
                for (const t of s.getSlides())f(0, t);
            }
            s = void 0;
        },
        execute: p
    };
};


/*! License details at fancyapps.com/license */ 
const $93c33b89fb6377fd$var$e = {
    syncOnChange: !1,
    syncOnClick: !0,
    syncOnHover: !1
}, $93c33b89fb6377fd$export$2ae15352e0a80063 = ()=>{
    let i, t;
    function o() {
        const t = null == i ? void 0 : i.getOptions().Sync;
        return (0, $dc093197fa71c887$export$53b83ca8eaab0383)(t) ? Object.assign(Object.assign({}, $93c33b89fb6377fd$var$e), t) : $93c33b89fb6377fd$var$e;
    }
    function s(n) {
        var e, s, l;
        i && n && (t = n, i.getOptions().classes = Object.assign(Object.assign({}, i.getOptions().classes), {
            isSelected: ""
        }), i.getOptions().initialSlide = (null === (s = null === (e = t.getPage()) || void 0 === e ? void 0 : e.slides[0]) || void 0 === s ? void 0 : s.index) || 0, o().syncOnChange && i.on("change", c), o().syncOnClick && i.on("click", g), o().syncOnHover && (null === (l = i.getViewport()) || void 0 === l || l.addEventListener("mouseover", u)), function() {
            if (!i || !t) return;
            i.on("ready", d), i.on("refresh", a), t.on("change", r), t.on("filter", f);
        }());
    }
    function l() {
        const n = o().target;
        i && n && s(n);
    }
    function d() {
        v();
    }
    function c() {
        var n;
        if (i && t) {
            const e = (null === (n = i.getPage()) || void 0 === n ? void 0 : n.slides) || [], o = t.getPageIndex(e[0].index || 0);
            o > -1 && t.goTo(o, i.hasNavigated() ? void 0 : {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function r() {
        var n;
        if (i && t) {
            const e = i.getPageIndex((null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0].index) || 0);
            e > -1 && i.goTo(e, t.hasNavigated() ? void 0 : {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function g(n, e) {
        var o;
        if (!i || !t) return;
        if (null === (o = i.getTween()) || void 0 === o ? void 0 : o.isRunning()) return;
        const s = null == i ? void 0 : i.getOptions().classes.slide;
        if (!s) return;
        const l = s ? e.target.closest(`.${s}`) : null;
        if (l) {
            const n = parseInt(l.getAttribute("index") || "") || 0, e = t.getPageIndex(n);
            t.goTo(e);
        }
    }
    function u(n) {
        i && g(0, n);
    }
    function a() {
        var n;
        if (i && t) {
            const e = i.getPageIndex((null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0].index) || 0);
            e > -1 && i.goTo(e, {
                tween: !1,
                transition: !1
            }), v();
        }
    }
    function f(n, e) {
        i && t && (i.filter(e), r());
    }
    function v() {
        var n, e, o;
        if (!t) return;
        const s = (null === (e = null === (n = t.getPage()) || void 0 === n ? void 0 : n.slides[0]) || void 0 === e ? void 0 : e.index) || 0;
        for (const n of (null == i ? void 0 : i.getSlides()) || [])null === (o = n.el) || void 0 === o || o.classList.toggle("is-selected", n.index === s);
    }
    return {
        init: function(n) {
            i = n, i.on("initSlides", l);
        },
        destroy: function() {
            var n;
            null == i || i.off("ready", d), null == i || i.off("refresh", a), null == i || i.off("change", c), null == i || i.off("click", g), null === (n = null == i ? void 0 : i.getViewport()) || void 0 === n || n.removeEventListener("mouseover", u), null == t || t.off("change", r), null == t || t.off("filter", f), t = void 0, null == i || i.off("initSlides", l), i = void 0;
        },
        getTarget: function() {
            return t;
        }
    };
};


/*! License details at fancyapps.com/license */ 
const $4accc7b78e8dfc04$var$t = {
    showLoading: !0,
    preload: 1
}, $4accc7b78e8dfc04$var$a = "is-lazyloading", $4accc7b78e8dfc04$var$s = "is-lazyloaded", $4accc7b78e8dfc04$export$6f539aaa4f74fdd1 = ()=>{
    let l;
    function n() {
        const a = null == l ? void 0 : l.getOptions().Lazyload;
        return (0, $dc093197fa71c887$export$53b83ca8eaab0383)(a) ? Object.assign(Object.assign({}, $4accc7b78e8dfc04$var$t), a) : $4accc7b78e8dfc04$var$t;
    }
    function o(e) {
        var t;
        const o = e.el;
        if (!o) return;
        const i = "[data-lazy-src],[data-lazy-srcset],[data-lazy-bg]", d = Array.from(o.querySelectorAll(i));
        o.matches(i) && d.push(o);
        for (const o of d){
            const i = o.dataset.lazySrc, d = o.dataset.lazySrcset, r = o.dataset.lazySizes, c = o.dataset.lazyBg, u = (o instanceof HTMLImageElement || o instanceof HTMLSourceElement) && (i || d), f = o instanceof HTMLElement && c;
            if (!u && !f) continue;
            const m = i || d || c;
            if (m) {
                if (u && m) {
                    const c = null === (t = o.parentElement) || void 0 === t ? void 0 : t.classList.contains("f-panzoom__wrapper");
                    n().showLoading && (null == l || l.showLoading(e)), o.addEventListener("load", ()=>{
                        null == l || l.hideLoading(e), o instanceof HTMLImageElement ? o.decode().then(()=>{
                            o.classList.remove($4accc7b78e8dfc04$var$a), o.classList.add($4accc7b78e8dfc04$var$s);
                        }) : (o.classList.remove($4accc7b78e8dfc04$var$a), o.classList.add($4accc7b78e8dfc04$var$s)), c || null == l || l.emit("lazyLoad:loaded", e, o, m);
                    }), o.addEventListener("error", ()=>{
                        null == l || l.hideLoading(e), o.classList.remove($4accc7b78e8dfc04$var$a), o.classList.add("has-lazyerror"), c || null == l || l.emit("lazyLoad:error", e, o, m);
                    }), o.classList.add("f-lazyload"), o.classList.add($4accc7b78e8dfc04$var$a), c || null == l || l.emit("lazyLoad:load", e, o, m), i && (o.src = i), d && (o.srcset = d), r && (o.sizes = r);
                } else if (f) {
                    if (!document.body.contains(o)) document.createElement("img").src = c;
                    o.style.backgroundImage = `url('${c}')`;
                }
                delete o.dataset.lazySrc, delete o.dataset.lazySrcset, delete o.dataset.lazySizes, delete o.dataset.lazyBg;
            }
        }
    }
    function i() {
        if (!l) return;
        const e = [
            ...l.getVisibleSlides()
        ], t = n().preload;
        if (t > 0) {
            const a = l.getPosition(), s = l.getViewportDim();
            e.push(...l.getVisibleSlides(a + s * t), ...l.getVisibleSlides(a - s * t));
        }
        for (const t of e)o(t);
    }
    return {
        init: function(e) {
            l = e, l.on("render", i);
        },
        destroy: function() {
            null == l || l.off("render", i), l = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 



const $601560cf604299af$var$r = {
    prevTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M15 3l-9 9 9 9"></path></svg>',
    nextTpl: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" tabindex="-1"><path d="M9 3l9 9-9 9"></path></svg>'
}, $601560cf604299af$export$b6e350ab9915297a = ()=>{
    let s, i, l;
    function a() {
        const t = null == s ? void 0 : s.getOptions().Arrows;
        return (0, $dc093197fa71c887$export$53b83ca8eaab0383)(t) ? Object.assign(Object.assign({}, $601560cf604299af$var$r), t) : $601560cf604299af$var$r;
    }
    function u(e) {
        if (!s) return;
        const o = `<button data-carousel-go-${e} tabindex="0" class="f-button is-arrow is-${e}" title="{{${e.toUpperCase()}}}">` + a()[`${e}Tpl`] + "</button", r = (0, $81976219b3588213$export$b368690db5627d91)(s.localize(o)) || void 0;
        return r && (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(r, a()[`${e}Class`]), r;
    }
    function g() {
        var t;
        null == i || i.remove(), i = void 0, null == l || l.remove(), l = void 0, null === (t = null == s ? void 0 : s.getContainer()) || void 0 === t || t.classList.remove("has-arrows");
    }
    function c() {
        s && !1 !== s.getOptions().Arrows && s.getPages().length > 1 ? (!function() {
            if (!s) return;
            const t = s.getViewport();
            t && (i || (i = u("prev"), i && t.insertAdjacentElement("beforebegin", i)), l || (l = u("next"), l && t.insertAdjacentElement("afterend", l)), (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(s.getContainer(), "has-arrows", !(!i && !l)));
        }(), s && (null == i || i.toggleAttribute("aria-disabled", !s.canGoPrev()), null == l || l.toggleAttribute("aria-disabled", !s.canGoNext()))) : g();
    }
    return {
        init: function(t) {
            s = t.on([
                "change",
                "refresh"
            ], c);
        },
        destroy: function() {
            g(), null == s || s.off([
                "change",
                "refresh"
            ], c), s = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 


/*! License details at fancyapps.com/license */ const $2c0df3f02be006bc$export$1a5903fe7331d64a = {
    moveLeft: {
        tpl: '<button data-panzoom-action="moveLeft" class="f-button" title="{{MOVE_LEFT}}"><svg><path d="M5 12h14M5 12l6 6M5 12l6-6"/></svg></button>'
    },
    moveRight: {
        tpl: '<button data-panzoom-action="moveRight" class="f-button" title="{{MOVE_RIGHT}}"><svg><path d="M5 12h14M13 18l6-6M13 6l6 6"/></svg></button>'
    },
    moveUp: {
        tpl: '<button data-panzoom-action="moveUp" class="f-button" title="{{MOVE_UP}}"><svg><path d="M12 5v14M18 11l-6-6M6 11l6-6"/></svg></button>'
    },
    moveDown: {
        tpl: '<button data-panzoom-action="moveDown" class="f-button" title="{{MOVE_DOWN}}"><svg><path d="M12 5v14M18 13l-6 6M6 13l6 6"/></svg></button>'
    },
    zoomIn: {
        tpl: '<button data-panzoom-action="zoomIn" class="f-button" title="{{ZOOM_IN}}"><svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M11 8v6M8 11h6"/></svg></button>'
    },
    zoomOut: {
        tpl: '<button data-panzoom-action="zoomOut" class="f-button" title="{{ZOOM_OUT}}"><svg><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg></button>'
    },
    toggle1to1: {
        tpl: '<button data-panzoom-action="toggleFull" class="f-button" title="{{TOGGLE_FULL}}"><svg><path d="M3.51 3.07c5.74.02 11.48-.02 17.22.02 1.37.1 2.34 1.64 2.18 3.13 0 4.08.02 8.16 0 12.23-.1 1.54-1.47 2.64-2.79 2.46-5.61-.01-11.24.02-16.86-.01-1.36-.12-2.33-1.65-2.17-3.14 0-4.07-.02-8.16 0-12.23.1-1.36 1.22-2.48 2.42-2.46Z"/><path d="M5.65 8.54h1.49v6.92m8.94-6.92h1.49v6.92M11.5 9.4v.02m0 5.18v0"/></svg></button>'
    },
    toggleFull: {
        tpl: '<button data-panzoom-action="toggleFull" class="f-button" title="{{TOGGLE_FULL}}"><svg><g><line x1="11" y1="8" x2="11" y2="14"></line></g><circle cx="11" cy="11" r="7.5"/><path d="m21 21-4.35-4.35M8 11h6"/></svg></button>'
    },
    rotateCCW: {
        tpl: '<button data-panzoom-action="rotateCCW" class="f-button" title="{{ROTATE_CCW}}"><svg><path d="M15 4.55a8 8 0 0 0-6 14.9M9 15v5H4M18.37 7.16v.01M13 19.94v.01M16.84 18.37v.01M19.37 15.1v.01M19.94 11v.01"/></svg></button>'
    },
    rotateCW: {
        tpl: '<button data-panzoom-action="rotateCW" class="f-button" title="{{ROTATE_CW}}"><svg><path d="M9 4.55a8 8 0 0 1 6 14.9M15 15v5h5M5.63 7.16v.01M4.06 11v.01M4.63 15.1v.01M7.16 18.37v.01M11 19.94v.01"/></svg></button>'
    },
    flipX: {
        tpl: '<button data-panzoom-action="flipX" class="f-button" title="{{FLIP_X}}"><svg><path d="M12 3v18M16 7v10h5L16 7M8 7v10H3L8 7"/></svg></button>'
    },
    flipY: {
        tpl: '<button data-panzoom-action="flipY" class="f-button" title="{{FLIP_Y}}"><svg><path d="M3 12h18M7 16h10L7 21v-5M7 8h10L7 3v5"/></svg></button>'
    },
    reset: {
        tpl: '<button data-panzoom-action="reset" class="f-button" title="{{RESET}}"><svg><path d="M20 11A8.1 8.1 0 0 0 4.5 9M4 5v4h4M4 13a8.1 8.1 0 0 0 15.5 2m.5 4v-4h-4"/></svg></button>'
    }
};



var $6c872b50f88d7027$export$68ae38b485887054;
!function(t) {
    t.Left = "left", t.middle = "middle", t.right = "right";
}($6c872b50f88d7027$export$68ae38b485887054 || ($6c872b50f88d7027$export$68ae38b485887054 = {}));
const $6c872b50f88d7027$var$s = Object.assign({
    counter: {
        tpl: '<div class="f-counter"><span data-carousel-page></span>/<span data-carousel-pages></span></div>'
    },
    download: {
        tpl: '<button data-carousel-download class="f-button" title="{{DOWNLOAD}}"><svg><path d="M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2M7 11l5 5 5-5M12 4v12"/></svg></button>'
    },
    autoplay: {
        tpl: '<button data-autoplay-action="toggle" class="f-button" title="{{TOGGLE_AUTOPLAY}}"><svg><g><path d="M5 3.5 19 12 5 20.5Z"/></g><g><path d="M8 4v15M17 4v15"/></g></svg></button>'
    },
    thumbs: {
        tpl: '<button data-thumbs-action="toggle" class="f-button" title="{{TOGGLE_THUMBS}}"><svg><rect width="18" height="14" x="3" y="3" rx="2"/><path d="M4 21h1M9 21h1M14 21h1M19 21h1"/></svg></button>'
    }
}, (0, $2c0df3f02be006bc$export$1a5903fe7331d64a)), $6c872b50f88d7027$var$a = {
    absolute: !1,
    display: {
        left: [],
        middle: [
            "zoomIn",
            "zoomOut",
            "toggle1to1",
            "rotateCCW",
            "rotateCW",
            "flipX",
            "flipY",
            "reset"
        ],
        right: []
    },
    enabled: "auto",
    items: {}
}, $6c872b50f88d7027$export$4c260019440d418f = ()=>{
    let l, r;
    function u(e) {
        const o = null == l ? void 0 : l.getOptions().Toolbar;
        let n = ((0, $dc093197fa71c887$export$53b83ca8eaab0383)(o) ? Object.assign(Object.assign({}, $6c872b50f88d7027$var$a), o) : $6c872b50f88d7027$var$a)[e];
        return n && "function" == typeof n && l ? n(l) : n;
    }
    function d() {
        var t, a, d, c;
        if (!(null == l ? void 0 : l.getOptions().Toolbar)) return;
        if (!l || r) return;
        let f = u("enabled");
        if (!f) return;
        const g = u("absolute"), p = l.getSlides().length > 1;
        let b = !1, m = !1;
        for (const t of l.getSlides())t.panzoomRef && (b = !0), (t.downloadSrc || "image" === t.type && t.src) && (m = !0);
        const v = (null === (t = l.getPlugins().Thumbs) || void 0 === t ? void 0 : t.isEnabled()) || !1, h = p && l.getPlugins().Autoplay || !1, y = l.getPlugins().Fullscreen && (document.fullscreenEnabled || document.webkitFullscreenEnabled);
        if ("auto" === f && (f = b), !f) return;
        r = (null === (a = l.getContainer()) || void 0 === a ? void 0 : a.querySelector(".f-carousel__toolbar")) || void 0, r || (r = document.createElement("div"), r.classList.add("f-carousel__toolbar"));
        const E = u("display"), j = (0, $56a4b1af55519d9a$export$8b58be045bf06082)({}, $6c872b50f88d7027$var$s, u("items"));
        for (const t of [
            "left",
            "middle",
            "right"
        ]){
            const i = E[t] || [], s = document.createElement("div");
            s.classList.add("f-carousel__toolbar__column"), s.classList.add(`is-${t}`);
            for (const t of i){
                let i;
                if ((0, $585a18adb7d59904$export$844ec244b1367d54)(t)) {
                    if ("counter" === t && !p) continue;
                    if ("autoplay" === t && !h) continue;
                    if ((0, $2c0df3f02be006bc$export$1a5903fe7331d64a)[t] && !b) continue;
                    if ("fullscreen" === t && !y) continue;
                    if ("thumbs" === t && !v) continue;
                    if ("download" === t && !m) continue;
                    i = j[t];
                }
                if ("object" == typeof t && (i = t), i && i.tpl) {
                    let t = l.localize(i.tpl);
                    t = t.split("<svg>").join('<svg tabindex="-1" width="24" height="24" viewBox="0 0 24 24">');
                    const e = (0, $81976219b3588213$export$b368690db5627d91)(t);
                    e && ("function" == typeof i.click && l && e.addEventListener("click", (t)=>{
                        t.preventDefault(), t.stopPropagation(), "function" == typeof i.click && l && i.click(l, t);
                    }), s.append(e));
                }
            }
            r.append(s);
        }
        if (r.childElementCount && (!0 === g && r.classList.add("is-absolute"), null === (d = l.getContainer()) || void 0 === d || d.classList.add("has-toolbar"), !r.parentElement)) {
            const t = u("parentEl");
            t ? t.insertAdjacentElement("afterbegin", r) : null === (c = l.getViewport()) || void 0 === c || c.insertAdjacentElement("beforebegin", r);
        }
    }
    return {
        init: function(t) {
            l = t, l.on("initSlides", d);
        },
        destroy: function() {
            var t;
            null == l || l.off("initSlides", d), null === (t = null == l ? void 0 : l.getContainer()) || void 0 === t || t.classList.remove("has-toolbar"), null == r || r.remove(), r = void 0;
        },
        add: function(t, e) {
            $6c872b50f88d7027$var$s[t] = e;
        },
        isEnabled: function() {
            return !!r;
        }
    };
};


/*! License details at fancyapps.com/license */ 
const $ff8ddf44ec81951a$var$e = {
    autoStart: !0,
    pauseOnHover: !0,
    showProgressbar: !0,
    timeout: 2e3
}, $ff8ddf44ec81951a$export$6c96167f46662e38 = ()=>{
    let n, o, i = !1, a = !1, l = !1, s = null;
    function r(o) {
        const i = null == n ? void 0 : n.getOptions().Autoplay;
        let a = ((0, $dc093197fa71c887$export$53b83ca8eaab0383)(i) ? Object.assign(Object.assign({}, $ff8ddf44ec81951a$var$e), i) : $ff8ddf44ec81951a$var$e)[o];
        return a && "function" == typeof a && n ? a(n) : a;
    }
    function u() {
        var t;
        const e = (null === (t = null == n ? void 0 : n.getPage()) || void 0 === t ? void 0 : t.slides) || [];
        for (const t of e)if (0 === t.state) return !0;
        return !1;
    }
    function d() {
        clearTimeout(o), o = void 0;
    }
    function g() {
        if (o) return;
        if (l) return;
        if (u()) return;
        if (!(null == n ? void 0 : n.isSettled())) return;
        !function() {
            var t, e, o, i;
            if (!n) return;
            if (v(), !r("showProgressbar")) return;
            let a = r("progressbarParentEl");
            !a && (null === (t = n.getPlugins().Toolbar) || void 0 === t ? void 0 : t.isEnabled()) && (a = n.getContainer());
            if (!a && !0 !== (null === (e = n.getPlugins().Toolbar) || void 0 === e ? void 0 : e.isEnabled())) {
                const t = (null === (o = n.getPages()[0]) || void 0 === o ? void 0 : o.slides) || [], e = (null === (i = n.getPage()) || void 0 === i ? void 0 : i.slides) || [];
                1 === t.length && 1 === e.length && (a = e[0].el);
            }
            a || (a = n.getViewport());
            if (!a) return;
            s = document.createElement("div"), s.classList.add("f-progressbar"), a.prepend(s);
            const l = r("timeout") || 1e3;
            s.style.animationDuration = `${l}ms`;
        }();
        const t = r("timeout");
        o = setTimeout(()=>{
            n && i && !a && (n.isInfinite() || n.getPageIndex() !== n.getPages().length - 1 ? n.next() : n.goTo(0));
        }, t);
    }
    function f() {
        var t, e;
        if (!n || n.getPages().length < 2 || !1 === n.getOptions().Autoplay) return;
        if (i) return;
        i = !0, n.emit("autoplay:start", r("timeout")), null === (t = n.getContainer()) || void 0 === t || t.classList.add("has-autoplay"), null === (e = n.getTween()) || void 0 === e || e.on("start", b);
        const o = null == n ? void 0 : n.getContainer();
        o && r("pauseOnHover") && matchMedia("(hover: hover)").matches && (o.addEventListener("mouseenter", E, !1), o.addEventListener("mouseleave", x, !1)), n.on("change", h), n.on("settle", y), n.on("contentReady", p), n.on("panzoom:animationStart", c), n.isSettled() && g();
    }
    function c() {
        var t, e;
        if (d(), v(), i && n) {
            n.emit("autoplay:end"), null === (t = n.getContainer()) || void 0 === t || t.classList.remove("has-autoplay"), null === (e = n.getTween()) || void 0 === e || e.off("start", b);
            const o = null == n ? void 0 : n.getContainer();
            o && (o.removeEventListener("mouseenter", E, !1), o.removeEventListener("mouseleave", x, !1));
        }
        n && (n.off("change", h), n.off("settle", y), n.off("contentReady", p), n.off("panzoom:animationStart", c)), i = !1, a = !1;
    }
    function v() {
        s && (s.remove(), s = null);
    }
    function m() {
        n && n.getPages().length > 1 && r("autoStart") && f();
    }
    function p(t) {
        n && n.getPageIndex(t.index) === n.getPageIndex() && (!i || l || u() || g());
    }
    function P(t, e) {
        const n = e.target;
        n && !e.defaultPrevented && "toggle" === n.dataset.autoplayAction && L.toggle();
    }
    function h() {
        !n || !(null == n ? void 0 : n.isInfinite()) && n.getPageIndex() === n.getPages().length - 1 ? c() : (v(), d());
    }
    function y() {
        !i || l || a || g();
    }
    function b() {
        d(), v();
    }
    function E() {
        l = !0, i && (v(), d());
    }
    function x() {
        l = !1, i && !a && (null == n ? void 0 : n.isSettled()) && g();
    }
    const L = {
        init: function(t) {
            n = t, n.on("ready", m), n.on("click", P);
        },
        destroy: function() {
            c(), null == n || n.off("ready", m), null == n || n.off("click", P), n = void 0;
        },
        isEnabled: ()=>i,
        pause: function() {
            a = !0, d();
        },
        resume: function() {
            a = !1, i && !l && g();
        },
        start () {
            f();
        },
        stop () {
            c();
        },
        toggle () {
            i ? c() : f();
        }
    };
    return L;
};


/*! License details at fancyapps.com/license */ 






const $5aebe5144ead9aa9$var$r = {
    Carousel: {
        Lazyload: {
            showLoading: !1
        }
    },
    minCount: 2,
    showOnStart: !0,
    thumbTpl: '<button aria-label="Slide to #{{page}}"><img draggable="false" alt="{{alt}}" data-lazy-src="{{src}}" /></button>',
    type: "modern"
};
let $5aebe5144ead9aa9$var$u;
const $5aebe5144ead9aa9$export$73e055b807a6709 = ()=>{
    let a, d, c, f = 0, m = 0, g = !0;
    function h(e) {
        const n = null == a ? void 0 : a.getOptions().Thumbs;
        let i = ((0, $dc093197fa71c887$export$53b83ca8eaab0383)(n) ? Object.assign(Object.assign({}, $5aebe5144ead9aa9$var$r), n) : $5aebe5144ead9aa9$var$r)[e];
        return i && "function" == typeof i && a ? i(a) : i;
    }
    function v() {
        if (!a) return !1;
        if (!1 === (null == a ? void 0 : a.getOptions().Thumbs)) return !1;
        let t = 0;
        for (const e of a.getSlides())e.thumbSrc && t++;
        return t >= h("minCount");
    }
    function p() {
        return "modern" === h("type");
    }
    function b(t = !1) {
        var e;
        const n = null == a ? void 0 : a.getContainer();
        if (!a || !n || c) return;
        if (!v()) return;
        if (!c) {
            const t = n.nextElementSibling;
            (null == t ? void 0 : t.classList.contains("f-thumbs")) && (c = t);
        }
        if (!c) {
            c = document.createElement("div");
            const t = h("parentEl");
            t ? t.insertAdjacentElement("beforeend", c) : n.insertAdjacentElement("afterend", c);
        }
        const i = null === (e = h("Carousel")) || void 0 === e ? void 0 : e.classes;
        (null == i ? void 0 : i.container) && (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(c, i.container), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(c, "f-thumbs"), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(c, `is-${h("type")}`), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(c, "is-syncing"), t && (c.style.maxHeight = "0px");
    }
    function y(t) {
        const e = t.thumb ? t.thumb instanceof HTMLImageElement ? t.thumb.src : t.thumb : t.thumbSrc || void 0, i = void 0 === t.thumbAlt ? `Thumbnail #${t.index}` : t.thumbAlt + "";
        let o = h("thumbTpl");
        return o = (0, $6ef6108b8aa723b5$export$b8b3234b4edfc4c2)(o, "{{alt}}", i), o = (0, $6ef6108b8aa723b5$export$b8b3234b4edfc4c2)(o, "{{src}}", e + ""), o = (0, $6ef6108b8aa723b5$export$b8b3234b4edfc4c2)(o, "{{index}}", `${t.index}`), o = (0, $6ef6108b8aa723b5$export$b8b3234b4edfc4c2)(o, "{{page}}", `${t.index || 1}`), {
            html: o,
            class: t.thumbClass
        };
    }
    function S() {
        var t;
        if (!$5aebe5144ead9aa9$var$u) return;
        if (!a || !c || d) return;
        const n = [];
        for (const t of a.getSlides())n.push(y(t));
        n.length && (d = $5aebe5144ead9aa9$var$u(c, (0, $56a4b1af55519d9a$export$8b58be045bf06082)({}, {
            Sync: {
                target: a
            },
            Lazyload: {
                preload: 1
            },
            slides: n,
            classes: {
                container: "f-thumbs",
                viewport: "f-thumbs__viewport",
                slide: "f-thumbs__slide"
            },
            initialSlide: a.getOptions().initialPage,
            center: !0,
            fill: !p(),
            infinite: !1,
            dragFree: !0,
            rtl: a.getOptions().rtl || !1,
            slidesPerPage: (t)=>{
                let e = 0;
                return p() && (!function() {
                    if (!p()) return;
                    if (!c) return;
                    const t = (t)=>c && parseFloat(getComputedStyle(c).getPropertyValue("--f-thumb-" + t)) || 0;
                    f = t("width"), m = t("clip-width");
                }(), e = 4 * (f - m)), t && t.getTotalSlideDim() <= t.getViewportDim() - e ? 1 / 0 : 1;
            }
        }, $5aebe5144ead9aa9$var$r.Carousel || {}, h("Carousel") || {}), {
            Sync: (0, $93c33b89fb6377fd$export$2ae15352e0a80063),
            Lazyload: (0, $4accc7b78e8dfc04$export$6f539aaa4f74fdd1)
        }), d.on("ready", ()=>{
            null == a || a.emit("thumbs:ready");
        }), d.on("destroy", ()=>{
            null == a || a.emit("thumbs:destroy");
        }), d.init(), null === (t = d.getGestures()) || void 0 === t || t.on("start", ()=>{
            g = !1;
        }), d.on("click", (t, e)=>{
            const n = e.target;
            if (n) {
                const t = n.matches("button") ? n : n.firstElementChild;
                t && t.matches("button") && (e.preventDefault(), t.focus({
                    preventScroll: !0
                }));
            }
        }), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(a.getContainer(), "has-thumbs"), L());
    }
    function x() {
        v() && h("showOnStart") && (b(), S());
    }
    function C() {
        var t;
        v() && (null == a || a.on("addSlide", E), null == a || a.on("click", T), null === (t = null == a ? void 0 : a.getGestures()) || void 0 === t || t.on("start", P));
    }
    function P() {
        var t, e;
        g = !0;
        (null === (t = document.activeElement) || void 0 === t ? void 0 : t.closest(".f-thumbs")) && (null === (e = document.activeElement) || void 0 === e || e.blur());
    }
    function j() {
        var t, e;
        null == c || c.classList.toggle("is-syncing", !1 === (null == a ? void 0 : a.hasNavigated()) || (null === (t = null == a ? void 0 : a.getTween()) || void 0 === t ? void 0 : t.isRunning())), L(), (null === (e = null == a ? void 0 : a.getGestures()) || void 0 === e ? void 0 : e.isPointerDown()) && function() {
            if (!p()) return;
            if (!a || !d) return;
            if (!g) return;
            const t = d.getTween(), e = d.getPages(), n = a.getPageIndex() || 0, o = a.getPageProgress() || 0;
            if (!(a && e && e[n] && t)) return;
            const l = t.isRunning() ? t.getCurrentValues().pos : d.getPosition();
            if (void 0 === l) return;
            let s = e[n].pos + o * (f - m);
            s = (0, $73781947f6aacd25$export$7d15b64cf5a3a4c4)(e[0].pos, s, e[e.length - 1].pos), t.from({
                pos: l
            }).to({
                pos: s
            }).start();
        }();
    }
    function w() {
        g = !0;
    }
    function E(t, e) {
        null == d || d.add(y(e), e.index);
    }
    function T(t, e) {
        const n = e.target;
        n && !e.defaultPrevented && "toggle" === n.dataset.thumbsAction && function() {
            if (c || (b(!0), S()), !c) return;
            const t = (null == d ? void 0 : d.isVertical()) ? "maxWidth" : "maxHeight", e = c.style[t];
            c.style[t] = e ? "" : "0px";
        }();
    }
    function L() {
        if (!p()) return;
        if (!a || !d) return;
        const t = (null == d ? void 0 : d.getSlides()) || [];
        let e = -0.5 * f;
        for (const n of t){
            const t = n.el;
            if (!t) continue;
            let i = a.getPageProgress(n.index) || 0;
            i = Math.max(-1, Math.min(1, i)), i > -1 && i < 1 && (e += .5 * f * (1 - Math.abs(i))), i = Math.round(1e4 * i) / 1e4, e = Math.round(1e4 * e) / 1e4, t.style.setProperty("--progress", `${Math.abs(i)}`), t.style.setProperty("--shift", `${(null == a ? void 0 : a.isRTL()) ? -1 * e : e}px`), i > -1 && i < 1 && (e += .5 * f * (1 - Math.abs(i)));
        }
    }
    return {
        init: function(t, e) {
            $5aebe5144ead9aa9$var$u = e, a = t, a.on("ready", C), a.on("initSlides", x), a.on("render", j), a.on("change", w);
        },
        destroy: function() {
            var t, e;
            null == a || a.off("ready", C), null == a || a.off("initSlides", x), null == a || a.off("render", j), null == a || a.off("change", w), null == a || a.off("addSlide", E), null == a || a.off("click", T), null === (t = null == a ? void 0 : a.getGestures()) || void 0 === t || t.off("start", P), null === (e = null == a ? void 0 : a.getContainer()) || void 0 === e || e.classList.remove("has-thumbs"), a = void 0, null == d || d.destroy(), d = void 0, null == c || c.remove(), c = void 0;
        },
        getCarousel: function() {
            return d;
        },
        getContainer: function() {
            return c;
        },
        isEnabled: function() {
            return v();
        }
    };
};


/*! License details at fancyapps.com/license */ 

const $fae468ca688b98ca$var$a = {
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto"
    }
}, $fae468ca688b98ca$export$13f9d3c4397c4713 = ()=>{
    let i;
    function l(t, a) {
        let i = a.src;
        if (!(0, $585a18adb7d59904$export$844ec244b1367d54)(i)) return;
        let l = a.type;
        if (!l) {
            if (l || ("#" === i.charAt(0) ? l = "inline" : i.match(/(^data:image\/[a-z0-9+\/=]*,)|(\.((a)?png|avif|gif|jp(g|eg)|pjp(eg)?|jfif|svg|webp|bmp|ico|tif(f)?)((\?|#).*)?$)/i) ? l = "image" : i.match(/\.(pdf)((\?|#).*)?$/i) ? l = "pdf" : i.match(/\.(html|php)((\?|#).*)?$/i) && (l = "iframe")), !l) {
                const t = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:(?:(?:maps\/(?:place\/(?:.*)\/)?\@(.*),(\d+.?\d+?)z))|(?:\?ll=))(.*)?/i);
                t && (i = `https://maps.google.${t[1]}/?ll=${(t[2] ? t[2] + "&z=" + Math.floor(parseFloat(t[3])) + (t[4] ? t[4].replace(/^\//, "&") : "") : t[4] + "").replace(/\?/, "&")}&output=${t[4] && t[4].indexOf("layer=c") > 0 ? "svembed" : "embed"}`, l = "gmap");
            }
            if (!l) {
                const t = i.match(/(?:maps\.)?google\.([a-z]{2,3}(?:\.[a-z]{2})?)\/(?:maps\/search\/)(.*)/i);
                t && (i = `https://maps.google.${t[1]}/maps?q=${t[2].replace("query=", "q=").replace("api=1", "")}&output=embed`, l = "gmap");
            }
            a.src = i, a.type = l;
        }
    }
    function o(e, l) {
        "iframe" !== l.type && "pdf" !== l.type && "gmap" !== l.type || function(e) {
            if (!i || !e.el || !e.src) return;
            const l = document.createElement("iframe");
            l.classList.add("f-iframe");
            for (const [e, o] of Object.entries(function() {
                const e = null == i ? void 0 : i.getOptions().Html;
                return (0, $dc093197fa71c887$export$53b83ca8eaab0383)(e) ? Object.assign(Object.assign({}, $fae468ca688b98ca$var$a), e) : $fae468ca688b98ca$var$a;
            }().iframeAttr || {}))l.setAttribute(e, o);
            l.onerror = ()=>{
                i && 1 === i.getState() && i.showError(e, "{{IFRAME_ERROR}}");
            }, l.src = e.src;
            const o = document.createElement("div");
            if (o.classList.add("f-html"), o.append(l), e.width) {
                let t = `${e.width}`;
                t.match(/^\d+$/) && (t += "px"), o.style.maxWidth = `${t}`;
            }
            if (e.height) {
                let t = `${e.height}`;
                t.match(/^\d+$/) && (t += "px"), o.style.maxHeight = `${t}`;
            }
            if (e.aspectRatio) {
                const t = e.el.getBoundingClientRect();
                o.style.aspectRatio = `${e.aspectRatio}`, o.style[t.width > t.height ? "width" : "height"] = "auto", o.style[t.width > t.height ? "maxWidth" : "maxHeight"] = "none";
            }
            e.contentEl = l, e.htmlEl = o, e.el.classList.add("has-html"), e.el.classList.add("has-iframe"), e.el.classList.add(`has-${e.type}`), e.el.prepend(o), i.emit("contentReady", e);
        }(l);
    }
    function n(t, e) {
        var a, l;
        "iframe" !== e.type && "pdf" !== e.type && "gmap" !== e.type || (null == i || i.hideError(e), null === (a = e.contentEl) || void 0 === a || a.remove(), e.contentEl = void 0, null === (l = e.htmlEl) || void 0 === l || l.remove(), e.htmlEl = void 0);
    }
    return {
        init: function(t) {
            i = t, i.on("addSlide", l), i.on("attachSlideEl", o), i.on("detachSlideEl", n);
        },
        destroy: function() {
            null == i || i.off("addSlide", l), null == i || i.off("attachSlideEl", o), null == i || i.off("detachSlideEl", n), i = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 


const $d18a22e045bfac7b$var$n = (t, e = {})=>{
    const o = new URL(t), n = new URLSearchParams(o.search), i = new URLSearchParams;
    for (const [t, o] of [
        ...n,
        ...Object.entries(e)
    ]){
        let e = o + "";
        if ("t" === t) {
            let t = e.match(/((\d*)m)?(\d*)s?/);
            t && i.set("start", 60 * parseInt(t[2] || "0") + parseInt(t[3] || "0") + "");
        } else i.set(t, e);
    }
    let l = i + "", s = t.match(/#t=((.*)?\d+s)/);
    return s && (l += `#t=${s[1]}`), l;
}, $d18a22e045bfac7b$var$i = {
    autoplay: !1,
    html5videoTpl: '<video class="f-html5video" playsinline controls controlsList="nodownload" poster="{{poster}}">\n    <source src="{{src}}" type="{{format}}" />Sorry, your browser doesn\'t support embedded videos.</video>',
    iframeAttr: {
        allow: "autoplay; fullscreen",
        scrolling: "auto",
        credentialless: ""
    },
    vimeo: {
        byline: 1,
        color: "00adef",
        controls: 1,
        dnt: 1,
        muted: 0
    },
    youtube: {
        controls: 1,
        enablejsapi: 1,
        nocookie: 1,
        rel: 0,
        fs: 1
    }
}, $d18a22e045bfac7b$export$ae01dedf5c052bb = ()=>{
    let l, s = !1;
    function a() {
        const e = null == l ? void 0 : l.getOptions().Video;
        return (0, $dc093197fa71c887$export$53b83ca8eaab0383)(e) ? Object.assign(Object.assign({}, $d18a22e045bfac7b$var$i), e) : $d18a22e045bfac7b$var$i;
    }
    function r() {
        var t;
        return null === (t = null == l ? void 0 : l.getPage()) || void 0 === t ? void 0 : t.slides[0];
    }
    const c = (t)=>{
        var e;
        try {
            let o = JSON.parse(t.data);
            if ("https://player.vimeo.com" === t.origin) {
                if ("ready" === o.event) for (let o of Array.from((null === (e = null == l ? void 0 : l.getContainer()) || void 0 === e ? void 0 : e.getElementsByClassName("f-iframe")) || []))o instanceof HTMLIFrameElement && o.contentWindow === t.source && (o.dataset.ready = "true");
            } else if (t.origin.match(/^https:\/\/(www.)?youtube(-nocookie)?.com$/) && "onReady" === o.event) {
                const t = document.getElementById(o.id);
                t && (t.dataset.ready = "true");
            }
        } catch (t) {}
    };
    function d(t, o) {
        const i = o.src;
        if (!(0, $585a18adb7d59904$export$844ec244b1367d54)(i)) return;
        let l = o.type;
        if (!l || "html5video" === l) {
            const t = i.match(/\.(mp4|mov|ogv|webm)((\?|#).*)?$/i);
            t && (l = "html5video", o.html5videoFormat = o.html5videoFormat || "video/" + ("ogv" === t[1] ? "ogg" : t[1]));
        }
        if (!l || "youtube" === l) {
            const t = i.match(/(youtube\.com|youtu\.be|youtube\-nocookie\.com)\/(?:watch\?(?:.*&)?v=|v\/|u\/|shorts\/|embed\/?)?(videoseries\?list=(?:.*)|[\w-]{11}|\?listType=(?:.*)&list=(?:.*))(?:.*)/i);
            if (t) {
                const e = Object.assign(Object.assign({}, a().youtube), o.youtube || {}), s = `www.youtube${e.nocookie ? "-nocookie" : ""}.com`, r = $d18a22e045bfac7b$var$n(i, e), c = encodeURIComponent(t[2]);
                o.videoId = c, o.src = `https://${s}/embed/${c}?${r}`, o.thumb = o.thumb || `https://i.ytimg.com/vi/${c}/mqdefault.jpg`, l = "youtube";
            }
        }
        if (!l || "vimeo" === l) {
            const t = i.match(/^.+vimeo.com\/(?:\/)?(video\/)?([\d]+)((\/|\?h=)([a-z0-9]+))?(.*)?/);
            if (t) {
                const e = Object.assign(Object.assign({}, a().vimeo), o.vimeo || {}), s = $d18a22e045bfac7b$var$n(i, e), r = encodeURIComponent(t[2]), c = t[5] || "";
                o.videoId = r, o.src = `https://player.vimeo.com/video/${r}?${c ? `h=${c}${s ? "&" : ""}` : ""}${s}`, l = "vimeo";
            }
        }
        o.type = l;
    }
    function u(t, n) {
        "html5video" === n.type && function(t) {
            if (!l || !t.el || !t.src) return;
            const { el: n, src: i } = t;
            if (!n || !i) return;
            const s = t.html5videoTpl || a().html5videoTpl, r = t.html5videoFormat || a().html5videoFormat;
            if (!s) return;
            const c = t.poster || (t.thumb && (0, $585a18adb7d59904$export$844ec244b1367d54)(t.thumb) ? t.thumb : ""), d = (0, $81976219b3588213$export$b368690db5627d91)(s.replace(/\{\{src\}\}/gi, i + "").replace(/\{\{format\}\}/gi, r || "").replace(/\{\{poster\}\}/gi, c + ""));
            if (!d) return;
            const u = document.createElement("div");
            u.classList.add("f-html"), u.append(d), t.contentEl = d, t.htmlEl = u, n.classList.add(`has-${t.type}`), n.prepend(u), h(t), l.emit("contentReady", t);
        }(n), "youtube" !== n.type && "vimeo" !== n.type || function(t) {
            if (!l || !t.el || !t.src) return;
            const e = document.createElement("iframe");
            e.classList.add("f-iframe"), e.setAttribute("id", `f-iframe_${t.videoId}`);
            for (const [t, o] of Object.entries(a().iframeAttr || {}))e.setAttribute(t, o);
            e.onload = ()=>{
                var o;
                l && 1 === l.getState() && "youtube" === t.type && (null === (o = e.contentWindow) || void 0 === o || o.postMessage(JSON.stringify({
                    event: "listening",
                    id: e.getAttribute("id")
                }), "*"));
            }, e.onerror = ()=>{
                l && 1 === l.getState() && (null == l || l.showError(t, "{{IFRAME_ERROR}}"));
            }, e.src = t.src;
            const o = document.createElement("div");
            o.classList.add("f-html"), o.append(e), t.contentEl = e, t.htmlEl = o, t.el.classList.add("has-html"), t.el.classList.add("has-iframe"), t.el.classList.add(`has-${t.type}`), t.el.prepend(o), h(t), l.emit("contentReady", t);
        }(n);
    }
    function m(t, e) {
        var o, n;
        "html5video" !== e.type && "youtube" !== e.type && "vimeo" !== e.type || (null === (o = e.contentEl) || void 0 === o || o.remove(), e.contentEl = void 0, null === (n = e.htmlEl) || void 0 === n || n.remove(), e.htmlEl = void 0), e.poller && clearTimeout(e.poller);
    }
    function f() {
        s = !1;
    }
    function p() {
        if (s) return;
        s = !0;
        const t = r();
        (t && void 0 !== t.autoplay ? t.autoplay : a().autoplay) && (function() {
            var t;
            const e = r(), o = null == e ? void 0 : e.el;
            if (o && "html5video" === (null == e ? void 0 : e.type)) try {
                const t = o.querySelector("video");
                if (t) {
                    const e = t.play();
                    void 0 !== e && e.then(()=>{}).catch((e)=>{
                        t.muted = !0, t.play();
                    });
                }
            } catch (t) {}
            const n = null == e ? void 0 : e.htmlEl;
            n instanceof HTMLIFrameElement && (null === (t = n.contentWindow) || void 0 === t || t.postMessage('{"event":"command","func":"stopVideo","args":""}', "*"));
        }(), function() {
            const t = r(), e = null == t ? void 0 : t.type;
            if (!(null == t ? void 0 : t.el) || "youtube" !== e && "vimeo" !== e) return;
            const o = ()=>{
                if (t.contentEl && t.contentEl instanceof HTMLIFrameElement && t.contentEl.contentWindow) {
                    let e;
                    if ("true" === t.contentEl.dataset.ready) return e = "youtube" === t.type ? {
                        event: "command",
                        func: "playVideo"
                    } : {
                        method: "play",
                        value: "true"
                    }, e && t.contentEl.contentWindow.postMessage(JSON.stringify(e), "*"), void (t.poller = void 0);
                    "youtube" === t.type && (e = {
                        event: "listening",
                        id: t.contentEl.getAttribute("id")
                    }, t.contentEl.contentWindow.postMessage(JSON.stringify(e), "*"));
                }
                t.poller = setTimeout(o, 250);
            };
            o();
        }());
    }
    function h(t) {
        const e = null == t ? void 0 : t.htmlEl;
        if (t && e && ("html5video" === t.type || "youtube" === t.type || "vimeo" === t.type)) {
            if (e.style.aspectRatio = "", e.style.width = "", e.style.height = "", e.style.maxWidth = "", e.style.maxHeight = "", t.width) {
                let o = `${t.width}`;
                o.match(/^\d+$/) && (o += "px"), e.style.maxWidth = `${o}`;
            }
            if (t.height) {
                let o = `${t.height}`;
                o.match(/^\d+$/) && (o += "px"), e.style.maxHeight = `${o}`;
            }
            if (t.aspectRatio) {
                const o = t.aspectRatio.split("/"), n = parseFloat(o[0].trim()), i = o[1] ? parseFloat(o[1].trim()) : 0, l = n && i ? n / i : n;
                e.offsetHeight;
                const s = e.getBoundingClientRect(), a = l < (s.width || 1) / (s.height || 1);
                e.style.aspectRatio = `${t.aspectRatio}`, e.style.width = a ? "auto" : "", e.style.height = a ? "" : "auto";
            }
        }
    }
    function v() {
        h(r());
    }
    return {
        init: function(t) {
            l = t, l.on("addSlide", d), l.on("attachSlideEl", u), l.on("detachSlideEl", m), l.on("ready", p), l.on("change", f), l.on("settle", p), l.on("refresh", v), window.addEventListener("message", c);
        },
        destroy: function() {
            null == l || l.off("addSlide", d), null == l || l.off("attachSlideEl", u), null == l || l.off("detachSlideEl", m), null == l || l.off("ready", p), null == l || l.off("change", f), null == l || l.off("settle", p), null == l || l.off("refresh", v), window.removeEventListener("message", c), l = void 0;
        }
    };
};


/*! License details at fancyapps.com/license */ 
const $4234431e341bd47e$var$n = {
    autoStart: !1,
    btnTpl: '<button data-fullscreen-action="toggle" class="f-button" title="{{TOGGLE_FULLSCREEN}}"><svg><g><path d="M8 3H5a2 2 0 0 0-2 2v3M21 8V5a2 2 0 0 0-2-2h-3M3 16v3a2 2 0 0 0 2 2h3M16 21h3a2 2 0 0 0 2-2v-3"/></g><g><path d="M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"/></g></svg></button>'
}, $4234431e341bd47e$var$t = "in-fullscreen-mode", $4234431e341bd47e$export$159cd03be7087f39 = ()=>{
    let l;
    function u(t) {
        const u = null == l ? void 0 : l.getOptions().Fullscreen;
        let o = ((0, $dc093197fa71c887$export$53b83ca8eaab0383)(u) ? Object.assign(Object.assign({}, $4234431e341bd47e$var$n), u) : $4234431e341bd47e$var$n)[t];
        return o && "function" == typeof o && l ? o(l) : o;
    }
    function o() {
        var e;
        null === (e = null == l ? void 0 : l.getPlugins().Toolbar) || void 0 === e || e.add("fullscreen", {
            tpl: u("btnTpl")
        });
    }
    function c() {
        if (u("autoStart")) {
            const e = r();
            e && d(e);
        }
    }
    function i(e, n) {
        const t = n.target;
        t && !n.defaultPrevented && "toggle" === t.dataset.fullscreenAction && b();
    }
    function s(e) {
        r() && "Escape" === e.key && !e.defaultPrevented && b();
    }
    function r() {
        return u("el") || (null == l ? void 0 : l.getContainer()) || void 0;
    }
    function a() {
        const e = document;
        return e.fullscreenEnabled ? !!e.fullscreenElement : !!e.webkitFullscreenEnabled && !!e.webkitFullscreenElement;
    }
    function d(e) {
        const n = document;
        let l;
        return e || (e = n.documentElement), n.fullscreenEnabled ? l = e.requestFullscreen() : n.webkitFullscreenEnabled && (l = e.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT)), l && l.then(()=>{
            e.classList.add($4234431e341bd47e$var$t);
        }), l;
    }
    function f() {
        const e = document;
        let n;
        return e.fullscreenEnabled ? n = e.fullscreenElement && e.exitFullscreen() : e.webkitFullscreenEnabled && (n = e.webkitFullscreenElement && e.webkitExitFullscreen()), n && n.then(()=>{
            var e;
            null === (e = r()) || void 0 === e || e.classList.remove($4234431e341bd47e$var$t);
        }), n;
    }
    function b() {
        const e = r();
        e && (a() ? f() : d(e));
    }
    return {
        init: function(e) {
            l = e, l.on("initPlugins", o), l.on("ready", c), l.on("click", i);
        },
        destroy: function() {
            null == l || l.off("initPlugins", o), null == l || l.off("ready", c), null == l || l.off("click", i), document.removeEventListener("keydown", s, !0);
        },
        exit: f,
        inFullscreen: a,
        request: d,
        toggle: b
    };
};


/*! License details at fancyapps.com/license */ 
let $78c8c06ba8520dc5$var$n, $78c8c06ba8520dc5$var$e = !1, $78c8c06ba8520dc5$var$o = !1, $78c8c06ba8520dc5$var$i = !1, $78c8c06ba8520dc5$var$r = !1;
const $78c8c06ba8520dc5$var$a = ()=>{
    const t = new URL(document.URL).hash, n = t.slice(1).split("-"), e = n[n.length - 1], o = e && /^\+?\d+$/.test(e) && parseInt(n.pop() || "1", 10) || 1;
    return {
        hash: t,
        slug: n.join("-"),
        index: o
    };
}, $78c8c06ba8520dc5$var$s = ()=>{
    if (!$78c8c06ba8520dc5$var$n || $78c8c06ba8520dc5$var$n.getInstance()) return;
    const { slug: t, index: e } = $78c8c06ba8520dc5$var$a();
    if (!t) return;
    if (!$78c8c06ba8520dc5$var$n || $78c8c06ba8520dc5$var$n.getInstance()) return;
    const o = document.querySelectorAll(`[data-fancybox="${t}"]`);
    if (!o.length) return;
    const i = o[e - 1];
    i && i.dispatchEvent(new CustomEvent("click", {
        bubbles: !0,
        cancelable: !0
    }));
}, $78c8c06ba8520dc5$var$l = ()=>{
    var t, e;
    if (!$78c8c06ba8520dc5$var$n) return;
    if ($78c8c06ba8520dc5$var$i) return;
    const o = null == $78c8c06ba8520dc5$var$n ? void 0 : $78c8c06ba8520dc5$var$n.getInstance();
    if (!1 === (null == o ? void 0 : o.getOptions().Hash)) return;
    const { slug: l, index: c } = $78c8c06ba8520dc5$var$a(), u = (null === (t = null == o ? void 0 : o.getSlide()) || void 0 === t ? void 0 : t.fancybox) || void 0;
    o && u && (l === u ? null === (e = o.getCarousel()) || void 0 === e || e.goTo(c - 1) : ($78c8c06ba8520dc5$var$r = !0, o.close(), $78c8c06ba8520dc5$var$r = !1)), $78c8c06ba8520dc5$var$s();
}, $78c8c06ba8520dc5$var$c = ()=>{
    $78c8c06ba8520dc5$var$n && setTimeout(()=>{
        $78c8c06ba8520dc5$var$e = !0, $78c8c06ba8520dc5$var$s(), $78c8c06ba8520dc5$var$e = !1, window.addEventListener("hashchange", $78c8c06ba8520dc5$var$l, !1);
    }, 300);
}, $78c8c06ba8520dc5$export$ab85ecd77ce6a5cd = ()=>{
    let t, n = "auto", s = "";
    function l() {
        var i, r;
        if (!t || !t.isTopMost()) return;
        if (!1 === t.getOptions().Hash) return;
        const l = t.getCarousel();
        if (!l) return;
        const { hash: u, slug: d } = $78c8c06ba8520dc5$var$a(), f = t.getSlide();
        if (!f) return;
        let h = f.fancybox || "", w = parseInt(f.index + "", 10) + 1;
        if (!h) return;
        let g = `#${h}-${w}`;
        if (((null === (r = null === (i = t.getCarousel()) || void 0 === i ? void 0 : i.getPages()) || void 0 === r ? void 0 : r.length) || 0) < 2 && (g = `#${h}`), u !== g && (s = u), history.scrollRestoration && (n = history.scrollRestoration, history.scrollRestoration = "manual"), l.on("change", c), !$78c8c06ba8520dc5$var$e) {
            if (h === d) try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + g);
            } catch (t) {}
            else try {
                window.history.pushState({}, document.title, window.location.pathname + window.location.search + g), $78c8c06ba8520dc5$var$o = !0;
            } catch (t) {}
        }
    }
    function c() {
        if (!t || !t.isTopMost()) return;
        if (!1 === t.getOptions().Hash) return;
        const { slug: n } = $78c8c06ba8520dc5$var$a(), e = t.getSlide();
        if (!e) return;
        let o = e.fancybox || "", r = `#${o}-${e.index + 1}`;
        if (o === n) {
            $78c8c06ba8520dc5$var$i = !0;
            try {
                window.history.replaceState({}, document.title, window.location.pathname + window.location.search + r);
            } catch (t) {}
            $78c8c06ba8520dc5$var$i = !1;
        }
    }
    function u() {
        if ($78c8c06ba8520dc5$var$r) return;
        if (!t || !t.isTopMost()) return;
        if (!1 === t.getOptions().Hash) return;
        const n = t.getSlide();
        if (!n) return;
        if (n.fancybox || "") {
            $78c8c06ba8520dc5$var$i = !0;
            try {
                !$78c8c06ba8520dc5$var$o || $78c8c06ba8520dc5$var$e || function() {
                    if (window.parent === window) return !1;
                    try {
                        var t = window.frameElement;
                    } catch (n) {
                        t = null;
                    }
                    return null === t ? "data:" === location.protocol : t.hasAttribute("sandbox");
                }() ? window.history.replaceState({}, document.title, window.location.pathname + window.location.search + s) : window.history.back();
            } catch (t) {}
            $78c8c06ba8520dc5$var$i = !1;
        }
    }
    return {
        init: function(n) {
            t = n, t.on("ready", l), t.on("close", u);
        },
        destroy: function() {
            null == t || t.off("ready", l), null == t || t.off("close", u);
            const e = null == t ? void 0 : t.getCarousel();
            e && e.off("change", c), t = void 0, history.scrollRestoration && n && (history.scrollRestoration = n);
        }
    };
};
$78c8c06ba8520dc5$export$ab85ecd77ce6a5cd.startFromUrl = $78c8c06ba8520dc5$var$s, $78c8c06ba8520dc5$export$ab85ecd77ce6a5cd.setup = function(e) {
    $78c8c06ba8520dc5$var$n || ($78c8c06ba8520dc5$var$n = e, (0, $f96a9ede5ac3bcc5$export$71594e8a50f746f4)() && (/complete|interactive|loaded/.test(document.readyState) ? $78c8c06ba8520dc5$var$c() : document.addEventListener("DOMContentLoaded", $78c8c06ba8520dc5$var$c)));
};



/*! License details at fancyapps.com/license */ 
const $261e1c697c7c548b$export$30568d076ec2f42 = Object.assign(Object.assign({}, (0, $9ceb4493d65212ad$export$30568d076ec2f42)), {
    CLOSE: "Close",
    NEXT: "Next",
    PREV: "Previous",
    MODAL: "You can close this modal content with the ESC key",
    ELEMENT_NOT_FOUND: "HTML Element Not Found",
    IFRAME_ERROR: "Error Loading Page"
});





const $dbe674dd1f608c29$var$T = '<button class="f-button" title="{{CLOSE}}" data-fancybox-close><svg><path d="M19.286 4.714 4.714 19.286M4.714 4.714l14.572 14.572" /></svg></button>';
(0, $6c872b50f88d7027$export$4c260019440d418f)().add("close", {
    tpl: $dbe674dd1f608c29$var$T
});
const $dbe674dd1f608c29$var$A = (e)=>{
    e && e.dispatchEvent(new CustomEvent("animationend", {
        bubbles: !1,
        cancelable: !0,
        currentTarget: e
    }));
}, $dbe674dd1f608c29$var$M = (e = null, t = "", n)=>{
    if (!e || !e.parentElement || !t) return void (n && n());
    $dbe674dd1f608c29$var$A(e);
    const o = (i)=>{
        i.target === e && e.dataset.animationName && (e.removeEventListener("animationend", o), delete e.dataset.animationName, n && n(), e.classList.remove(t));
    };
    e.dataset.animationName = t, e.addEventListener("animationend", o), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(e, t);
};
var $dbe674dd1f608c29$export$b3af8f1b99ca9976;
!function(e) {
    e[e.Init = 0] = "Init", e[e.Ready = 1] = "Ready", e[e.Closing = 2] = "Closing", e[e.Destroyed = 3] = "Destroyed";
}($dbe674dd1f608c29$export$b3af8f1b99ca9976 || ($dbe674dd1f608c29$export$b3af8f1b99ca9976 = {}));
const $dbe674dd1f608c29$var$_ = {
    ajax: null,
    backdropClick: "close",
    Carousel: {},
    closeButton: "auto",
    closeExisting: !1,
    delegateEl: void 0,
    dragToClose: !0,
    fadeEffect: !0,
    groupAll: !1,
    groupAttr: "data-fancybox",
    hideClass: "f-fadeOut",
    hideScrollbar: !0,
    id: void 0,
    idle: !1,
    keyboard: {
        Escape: "close",
        Delete: "close",
        Backspace: "close",
        PageUp: "next",
        PageDown: "prev",
        ArrowUp: "prev",
        ArrowDown: "next",
        ArrowRight: "next",
        ArrowLeft: "prev"
    },
    l10n: (0, $261e1c697c7c548b$export$30568d076ec2f42),
    mainClass: "",
    mainStyle: {},
    mainTpl: '<dialog class="fancybox__dialog">\n    <div class="fancybox__container" tabindex="0" aria-label="{{MODAL}}">\n      <div class="fancybox__backdrop"></div>\n      <div class="fancybox__carousel"></div>\n    </div>\n  </dialog>',
    on: {},
    parentEl: void 0,
    placeFocusBack: !0,
    showClass: "f-zoomInUp",
    startIndex: 0,
    sync: void 0,
    theme: "dark",
    triggerEl: void 0,
    triggerEvent: void 0,
    zoomEffect: !0
}, $dbe674dd1f608c29$var$O = new Map;
let $dbe674dd1f608c29$var$D = 0;
const $dbe674dd1f608c29$var$R = "with-fancybox", $dbe674dd1f608c29$var$I = ()=>{
    let r, w, j, I, z, B = $dbe674dd1f608c29$export$b3af8f1b99ca9976.Init, N = Object.assign({}, $dbe674dd1f608c29$var$_), q = -1, V = {}, F = [], W = !1, $ = !0, K = 0;
    function U(e, ...t) {
        let n = N[e];
        return n && "function" == typeof n ? n(Se, ...t) : n;
    }
    function X(e, t = []) {
        const n = U("l10n") || {};
        e = String(e).replace(/\{\{(\w+)\}\}/g, (e, t)=>n[t] || e);
        for(let n = 0; n < t.length; n++)e = e.split(t[n][0]).join(t[n][1]);
        return e = e.replace(/\{\{(.*?)\}\}/g, (e, t)=>t);
    }
    const G = new Map;
    function Y(e, ...t) {
        const n = [
            ...G.get(e) || []
        ];
        for (const [t, o] of Object.entries(N.on || {}))(t === e || t.split(" ").indexOf(e) > -1) && n.push(o);
        for (const e of n)e && "function" == typeof e && e(Se, ...t);
        "*" !== e && Y("*", e, ...t);
    }
    function Z(t = [], n = {}) {
        B !== $dbe674dd1f608c29$export$b3af8f1b99ca9976.Init && (Se.destroy(), B = $dbe674dd1f608c29$export$b3af8f1b99ca9976.Init), N = (0, $56a4b1af55519d9a$export$8b58be045bf06082)({}, $dbe674dd1f608c29$var$_, n), q = U("id") || "fancybox-" + ++$dbe674dd1f608c29$var$D;
        const a = $dbe674dd1f608c29$var$O.get(q);
        if (a && a.destroy(), $dbe674dd1f608c29$var$O.set(q, Se), Y("init"), function() {
            for (const [e, t] of Object.entries(Object.assign(Object.assign({}, $dbe674dd1f608c29$export$cb45b08d97cdc4fd.Plugins), N.plugins || {})))if (e && !V[e] && t instanceof Function) {
                const n = t();
                n.init(Se), V[e] = n;
            }
            Y("initPlugins");
        }(), function(e = []) {
            Y("initSlides", e), F = [
                ...e
            ];
        }(t), function() {
            const t = U("parentEl") || document.body;
            if (!(t && t instanceof HTMLElement)) return;
            const n = X(U("mainTpl") || "");
            if (r = (0, $81976219b3588213$export$b368690db5627d91)(n) || void 0, !r) return;
            if (w = r.querySelector(".fancybox__container"), !(w && w instanceof HTMLElement)) return;
            const s = U("mainClass");
            s && (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(w, s);
            const a = U("mainStyle");
            if (a && (0, $dc093197fa71c887$export$53b83ca8eaab0383)(a)) for (const [e, t] of Object.entries(a))w.style.setProperty(e, t);
            const u = U("theme"), d = "auto" === u ? window.matchMedia("(prefers-color-scheme:light)").matches : "light" === u;
            w.setAttribute("theme", d ? "light" : "dark"), r.setAttribute("id", `${q}`), r.addEventListener("keydown", (e)=>{
                "Escape" === e.key && e.preventDefault();
            }), r.addEventListener("wheel", (e)=>{
                const t = e.target;
                let n = U("wheel", e);
                t.closest(".f-thumbs") && (n = "slide");
                const o = "slide" === n, l = [
                    -e.deltaX || 0,
                    -e.deltaY || 0,
                    -e.detail || 0
                ].reduce(function(e, t) {
                    return Math.abs(t) > Math.abs(e) ? t : e;
                }), s = Math.max(-1, Math.min(1, l)), r = Date.now();
                K && r - K < 300 ? o && e.preventDefault() : (K = r, Y("wheel", e, s), e.defaultPrevented || ("close" === n ? Le(e) : "slide" === n && I && !(0, $16dbdcd3a6f0d21d$export$e41e80160bed5714)(t) && (e.preventDefault(), I[s > 0 ? "prev" : "next"]())));
            }, {
                capture: !0,
                passive: !1
            }), r.addEventListener("cancel", (e)=>{
                Le(e);
            }), t.append(r), 1 === $dbe674dd1f608c29$var$O.size && (U("hideScrollbar") && (0, $b02d5d471dc29732$export$b539ed14f4f9e78)(!0), document.documentElement.classList.add($dbe674dd1f608c29$var$R));
            r instanceof HTMLDialogElement && r.showModal();
            Y("initLayout");
        }(), function() {
            if (j = (null == r ? void 0 : r.querySelector(".fancybox__carousel")) || void 0, !j) return;
            j.fancybox = Se;
            const e = (0, $56a4b1af55519d9a$export$8b58be045bf06082)({}, {
                Autoplay: {
                    autoStart: !1,
                    pauseOnHover: !1,
                    progressbarParentEl: (e)=>{
                        const t = e.getContainer();
                        return (null == t ? void 0 : t.querySelector(".f-carousel__toolbar [data-autoplay-action]")) || t;
                    }
                },
                Fullscreen: {
                    el: w
                },
                Toolbar: {
                    absolute: !0,
                    items: {
                        counter: {
                            tpl: '<div class="f-counter"><span data-fancybox-page></span>/<span data-fancybox-pages></span></div>'
                        }
                    },
                    display: {
                        left: [
                            "counter"
                        ],
                        right: [
                            "toggleFull",
                            "autoplay",
                            "fullscreen",
                            "thumbs",
                            "close"
                        ]
                    }
                },
                Video: {
                    autoplay: !0
                },
                Thumbs: {
                    minCount: 2,
                    Carousel: {
                        classes: {
                            container: "fancybox__thumbs"
                        }
                    }
                },
                classes: {
                    container: "fancybox__carousel",
                    viewport: "fancybox__viewport",
                    slide: "fancybox__slide"
                },
                spinnerTpl: '<div class="f-spinner" data-fancybox-close></div>',
                dragFree: !1,
                slidesPerPage: 1,
                plugins: {
                    Sync: (0, $93c33b89fb6377fd$export$2ae15352e0a80063),
                    Arrows: (0, $601560cf604299af$export$b6e350ab9915297a),
                    Lazyload: (0, $4accc7b78e8dfc04$export$6f539aaa4f74fdd1),
                    Zoomable: (0, $32041ffb9773f9eb$export$b7fc409e12a7dcec),
                    Html: (0, $fae468ca688b98ca$export$13f9d3c4397c4713),
                    Video: (0, $d18a22e045bfac7b$export$ae01dedf5c052bb),
                    Autoplay: (0, $ff8ddf44ec81951a$export$6c96167f46662e38),
                    Fullscreen: (0, $4234431e341bd47e$export$159cd03be7087f39),
                    Thumbs: (0, $5aebe5144ead9aa9$export$73e055b807a6709),
                    Toolbar: (0, $6c872b50f88d7027$export$4c260019440d418f)
                }
            }, U("Carousel") || {}, {
                slides: F,
                enabled: !0,
                initialPage: U("startIndex") || 0,
                l10n: U("l10n")
            });
            I = (0, $da1ac87b7e404694$export$144901db2ea8e967)(j, e), Y("initCarousel", I), I.on("*", (e, t, ...n)=>{
                Y(`Carousel.${t}`, e, ...n);
            }), I.on("attachSlideEl", Q), I.on("detachSlideEl", ee), I.on("contentReady", le), I.on("ready", oe), I.on("change", ne), I.on("settle", ie), I.on("thumbs:ready", se), I.on("thumbs:destroy", se), I.init();
        }(), r && w) {
            if (U("closeExisting")) for (const [e, t] of $dbe674dd1f608c29$var$O.entries())e !== q && t.close();
            U("fadeEffect") ? (setTimeout(()=>{
                J();
            }, 500), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(w, "is-revealing")) : J(), w.classList.add("is-ready"), B = $dbe674dd1f608c29$export$b3af8f1b99ca9976.Ready, Y("ready");
        }
    }
    function J() {
        (0, $e49a661321e90b65$export$c2255604a80b4506)(w, "is-revealing");
        try {
            if (document.activeElement === r) ((null == w ? void 0 : w.querySelector("[autofocus]")) || w).focus();
        } catch (e) {}
    }
    function Q(e, n) {
        var o;
        fe(n), re(), null === (o = n.el) || void 0 === o || o.addEventListener("click", te), "inline" !== n.type && "clone" !== n.type || function(e) {
            if (!I || !e || !e.el) return;
            let n = null;
            if ((0, $585a18adb7d59904$export$844ec244b1367d54)(e.src)) {
                const t = e.src.split("#", 2).pop();
                n = t ? document.getElementById(t) : null;
            }
            if (n) {
                if ((0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(n, "f-html"), "clone" === e.type || n.closest(".fancybox__carousel")) {
                    n = n.cloneNode(!0);
                    const t = n.dataset.animationName;
                    t && (n.classList.remove(t), delete n.dataset.animationName);
                    let o = n.getAttribute("id");
                    o = o ? `${o}--clone` : `clone-${q}-${e.index}`, n.setAttribute("id", o);
                } else if (n.parentNode) {
                    const t = document.createElement("div");
                    t.inert = !0, n.parentNode.insertBefore(t, n), e.placeholderEl = t;
                }
                e.htmlEl = n, (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(e.el, "has-html"), e.el.prepend(n), n.classList.remove("hidden"), "none" === n.style.display && (n.style.display = ""), "none" === getComputedStyle(n).getPropertyValue("display") && (n.style.display = n.dataset.display || "flex"), null == I || I.emit("contentReady", e);
            } else null == I || I.showError(e, "{{ELEMENT_NOT_FOUND}}");
        }(n), "ajax" === n.type && function(e) {
            const t = e.el;
            if (!t) return;
            if (e.htmlEl || e.xhr) return;
            null == I || I.showLoading(e), e.state = 0;
            const n = new XMLHttpRequest;
            n.onreadystatechange = function() {
                if (n.readyState === XMLHttpRequest.DONE && B === $dbe674dd1f608c29$export$b3af8f1b99ca9976.Ready) {
                    if (null == I || I.hideLoading(e), e.state = 1, 200 === n.status) {
                        let o = n.responseText + "", i = null, l = null;
                        if (e.filter) {
                            const t = document.createElement("div");
                            t.innerHTML = o, l = t.querySelector(e.filter + "");
                        }
                        l && l instanceof HTMLElement ? i = l : (i = document.createElement("div"), i.innerHTML = o), i.classList.add("f-html"), e.htmlEl = i, t.classList.add("has-html"), t.classList.add("has-ajax"), t.prepend(i), null == I || I.emit("contentReady", e);
                    } else null == I || I.showError(e);
                }
            };
            const o = U("ajax") || null;
            n.open(o ? "POST" : "GET", e.src + ""), n.setRequestHeader("Content-Type", "application/x-www-form-urlencoded"), n.setRequestHeader("X-Requested-With", "XMLHttpRequest"), n.send(o), e.xhr = n;
        }(n);
    }
    function ee(e, t) {
        var n;
        !function(e) {
            e.closeButtonEl && (e.closeButtonEl.remove(), e.closeButtonEl = void 0);
        }(t), null === (n = t.el) || void 0 === n || n.removeEventListener("click", te), "inline" !== t.type && "clone" !== t.type || function(e) {
            const t = e.htmlEl, n = e.placeholderEl;
            t && ("none" !== getComputedStyle(t).getPropertyValue("display") && (t.style.display = "none"), t.offsetHeight);
            n && (t && n.parentNode && n.parentNode.insertBefore(t, n), n.remove());
            e.htmlEl = void 0, e.placeholderEl = void 0;
        }(t), t.xhr && (t.xhr.abort(), t.xhr = void 0);
    }
    function te(e) {
        if (!pe()) return;
        if (B !== $dbe674dd1f608c29$export$b3af8f1b99ca9976.Ready) return e.preventDefault(), void e.stopPropagation();
        if (e.defaultPrevented) return;
        if (!(0, $fff24a5500e60204$export$1f911e2d31b2843e).isClickAllowed()) return;
        const t = e.composedPath()[0];
        t.closest(".fancybox__carousel") && t.classList.contains("fancybox__slide") && ae(e);
    }
    function ne() {
        $ = !1, w && I && w.classList.remove("is-revealing"), re();
        const e = U("sync");
        if (I && e) {
            const t = e.getPageIndex(I.getPageIndex()) || 0;
            e.goTo(t, {
                transition: !1
            });
        }
    }
    function oe() {
        var e;
        if (B !== $dbe674dd1f608c29$export$b3af8f1b99ca9976.Ready) return;
        me(ge()), function() {
            if (!U("dragToClose")) return;
            if (!I) return;
            const e = I.getViewport();
            if (!e) return;
            const t = (0, $fff24a5500e60204$export$1f911e2d31b2843e)(e).init();
            if (!t) return;
            let n = 0, o = 0, l = (0, $6f48c3b0d4f5e032$export$208a41d6b4e37b97)().on("step", (e)=>{
                n = e.y;
                const t = null == I ? void 0 : I.getViewport();
                if (w && t) {
                    const e = (0, $cc0f4c55c8b6e1bf$export$871de8747c9eaa88)(Math.abs(n), 0, .5 * t.getBoundingClientRect().height, 1, .5);
                    w.style.setProperty("--f-drag-opacity", e + ""), w.style.setProperty("--f-drag-offset", n + "px");
                }
            }).on("end", ()=>{
                if (!n) {
                    w && w.style.removeProperty("--f-opacity");
                    const e = null == I ? void 0 : I.getViewport();
                    e && (e.style.transform = "");
                }
            });
            t.on("start", function() {
                l.pause();
            }).on("panstart", (e)=>{
                var t;
                const n = e.srcEvent.target;
                n && !(0, $16dbdcd3a6f0d21d$export$e41e80160bed5714)(n) && (null === (t = null == I ? void 0 : I.getViewport()) || void 0 === t || t.classList.add("is-dragging"));
            }).on("pan", function(e) {
                const t = e.srcEvent.target;
                if (t && (0, $16dbdcd3a6f0d21d$export$e41e80160bed5714)(t)) return;
                (null == I ? void 0 : I.getViewport()) && "y" === e.axis && (o += e.deltaY, l.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 860,
                    friction: 17,
                    restDelta: .01,
                    restSpeed: .01
                }).from({
                    y: n
                }).to({
                    y: o
                }).start());
            }).on("end", function(e) {
                l.pause(), "y" === e.axis && Math.abs(e.velocityY) > 5 && Math.abs(o) > 0 && (Le(e.srcEvent, "f-throwOut" + (e.velocityY > 0 ? "Down" : "Up")), B === $dbe674dd1f608c29$export$b3af8f1b99ca9976.Closing) || 0 !== o && (o = 0, l.spring({
                    clamp: !0,
                    mass: 1,
                    tension: 140,
                    friction: 25,
                    restDelta: .1,
                    restSpeed: .1,
                    maxSpeed: 1 / 0
                }).from({
                    y: n
                }).to({
                    y: o
                }).start());
            });
        }(), document.body.addEventListener("click", de), document.body.addEventListener("keydown", ue, {
            passive: !1,
            capture: !0
        }), re(), be();
        const t = U("sync");
        t && (null === (e = t.getTween()) || void 0 === e || e.start());
    }
    function ie() {
        (null == I ? void 0 : I.canGoNext()) ? be() : we();
    }
    function le(e, t) {
        fe(t), me(t);
    }
    function se() {
        var e;
        const t = null == I ? void 0 : I.getPlugins().Thumbs;
        (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(w, "has-thumbs", (null == t ? void 0 : t.isEnabled()) || !1), (0, $0ff753c965c9dc10$export$4a80062ca50b57c7)(w, "has-vertical-thumbs", (null === (e = null == t ? void 0 : t.getCarousel()) || void 0 === e ? void 0 : e.isVertical()) || !1);
    }
    function re() {
        if (w) {
            const e = (null == I ? void 0 : I.getPages()) || [], t = (null == I ? void 0 : I.getPageIndex()) || 0;
            for (const e of w.querySelectorAll("[data-fancybox-index]"))e.innerHTML = t + "";
            for (const e of w.querySelectorAll("[data-fancybox-page]"))e.innerHTML = t + 1 + "";
            for (const t of w.querySelectorAll("[data-fancybox-pages]"))t.innerHTML = e.length + "";
        }
    }
    function ae(e) {
        if (!!e.composedPath()[0].closest("[data-fancybox-close]")) return void Le(e);
        if (Y("backdropClick", e), e.defaultPrevented) return;
        U("backdropClick") && Le(e);
    }
    function ce() {
        xe();
    }
    function ue(e) {
        if (!pe()) return;
        if (B !== $dbe674dd1f608c29$export$b3af8f1b99ca9976.Ready) return;
        const t = e.key, o = U("keyboard");
        if (!o) return;
        if (e.ctrlKey || e.altKey || e.shiftKey) return;
        const i = e.composedPath()[0];
        if (!(0, $72eb7366a788e3d9$export$8ee0fc9ee280b4ee)(i)) return;
        if ("Escape" !== t && ((e)=>{
            const t = [
                "input",
                "textarea",
                "select",
                "option",
                "video",
                "iframe",
                "[contenteditable]",
                "[data-selectable]",
                "[data-draggable]"
            ].join(",");
            return e.matches(t) || e.closest(t);
        })(i)) return;
        if (Y("keydown", e), e.defaultPrevented) return;
        const l = o[t];
        if (l) switch(l){
            case "close":
                Le(e);
                break;
            case "next":
                e.preventDefault(), null == I || I.next();
                break;
            case "prev":
                e.preventDefault(), null == I || I.prev();
        }
    }
    function de(e) {
        if (!pe()) return;
        if (B !== $dbe674dd1f608c29$export$b3af8f1b99ca9976.Ready) return;
        if (xe(), e.defaultPrevented) return;
        const t = e.composedPath()[0], n = !!t.closest("[data-fancybox-close]"), o = t.classList.contains("fancybox__backdrop");
        (n || o) && ae(e);
    }
    function fe(e) {
        var t;
        const { el: n, htmlEl: i, closeButtonEl: l } = e;
        if (!n || !i || l) return;
        let s = U("closeButton");
        if ("auto" === s && (s = !0 !== (null === (t = null == I ? void 0 : I.getPlugins().Toolbar) || void 0 === t ? void 0 : t.isEnabled())), s) {
            const t = (0, $81976219b3588213$export$b368690db5627d91)(X($dbe674dd1f608c29$var$T));
            t && (e.closeButtonEl = i.insertAdjacentElement("afterbegin", t), n.classList.add("has-close-btn"));
        }
    }
    function me(e) {
        if (!($ && I && 1 === I.getState() && e && e.index === I.getOptions().initialPage && e.el && e.el.parentElement)) return;
        if (void 0 !== e.state && 1 !== e.state) return;
        $ = !1;
        const t = e.panzoomRef, n = null == t ? void 0 : t.getTween(), o = U("zoomEffect") && n ? ye(e) : void 0;
        if (t && n && o) {
            const { x: e, y: i, scale: l } = t.getStartPosition();
            return void n.spring({
                tension: 225,
                friction: 25,
                restDelta: .001,
                restSpeed: .001,
                maxSpeed: 1 / 0
            }).from(o).to({
                x: e,
                y: i,
                scale: l
            }).start();
        }
        const i = (null == t ? void 0 : t.getContent()) || e.htmlEl;
        i && $dbe674dd1f608c29$var$M(i, U("showClass", e));
    }
    function pe() {
        var e;
        return (null === (e = $dbe674dd1f608c29$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getId()) === q;
    }
    function ge() {
        var e;
        return null === (e = null == I ? void 0 : I.getPage()) || void 0 === e ? void 0 : e.slides[0];
    }
    function ve() {
        const e = ge();
        return e ? e.triggerEl || U("triggerEl") : void 0;
    }
    function ye(e) {
        var t, n;
        const o = e.thumbEl;
        if (!o || !((e)=>{
            const t = e.getBoundingClientRect(), n = e.closest("[style]"), o = null == n ? void 0 : n.parentElement;
            if (n && n.style.transform && o) {
                const e = o.getBoundingClientRect();
                if (t.left < e.left || t.left > e.left + e.width - t.width) return !1;
                if (t.top < e.top || t.top > e.top + e.height - t.height) return !1;
            }
            const i = Math.max(document.documentElement.clientHeight, window.innerHeight), l = Math.max(document.documentElement.clientWidth, window.innerWidth);
            return !(t.bottom < 0 || t.top - i >= 0 || t.right < 0 || t.left - l >= 0);
        })(o)) return;
        const i = null === (n = null === (t = e.panzoomRef) || void 0 === t ? void 0 : t.getWrapper()) || void 0 === n ? void 0 : n.getBoundingClientRect(), l = null == i ? void 0 : i.width, s = null == i ? void 0 : i.height;
        if (!l || !s) return;
        const r = o.getBoundingClientRect();
        let a = r.width, c = r.height, u = r.left, d = r.top;
        if (!r || !a || !c) return;
        if (o instanceof HTMLImageElement) {
            const e = window.getComputedStyle(o).getPropertyValue("object-fit");
            if ("contain" === e || "scale-down" === e) {
                const { width: t, height: n } = ((e, t, n, o, i = "contain")=>{
                    if ("contain" === i || e > n || t > o) {
                        const i = n / e, l = o / t, s = Math.min(i, l);
                        e *= s, t *= s;
                    }
                    return {
                        width: e,
                        height: t
                    };
                })(o.naturalWidth, o.naturalHeight, a, c, e);
                u += .5 * (a - t), d += .5 * (c - n), a = t, c = n;
            }
        }
        if (Math.abs(l / s - a / c) > .1) return;
        return {
            x: u + .5 * a - (i.left + .5 * l),
            y: d + .5 * c - (i.top + .5 * s),
            scale: a / l
        };
    }
    function he() {
        z && clearTimeout(z), z = void 0, document.removeEventListener("mousemove", ce);
    }
    function be() {
        if (W) return;
        if (z) return;
        const e = U("idle");
        e && (z = setTimeout(Ee, e));
    }
    function Ee() {
        w && (he(), (0, $8d1d8b176a38106a$export$d2cf6cd1dc7067d3)(w, "is-idle"), document.addEventListener("mousemove", ce), W = !0);
    }
    function xe() {
        W && (we(), be());
    }
    function we() {
        he(), null == w || w.classList.remove("is-idle"), W = !1;
    }
    function Le(e, t) {
        var n, o, i, l, r, a;
        if (B === $dbe674dd1f608c29$export$b3af8f1b99ca9976.Closing || B === $dbe674dd1f608c29$export$b3af8f1b99ca9976.Destroyed) return;
        const c = new Event("shouldClose", {
            bubbles: !0,
            cancelable: !0
        });
        if (Y("shouldClose", c, e), c.defaultPrevented) return;
        if (he(), e) {
            if (e.defaultPrevented) return;
            e.cancelable && e.preventDefault(), e.stopPropagation(), e.stopImmediatePropagation();
        }
        if (B = $dbe674dd1f608c29$export$b3af8f1b99ca9976.Closing, I) {
            null === (n = I.getGestures()) || void 0 === n || n.destroy(), null === (o = I.getTween()) || void 0 === o || o.pause();
            const e = ge(), t = null == e ? void 0 : e.panzoomRef;
            e && t && (0, $56a4b1af55519d9a$export$8b58be045bf06082)(t.getOptions(), {
                clickAction: !1,
                wheelAction: !1,
                bounds: !1,
                minScale: 0,
                maxScale: 1 / 0
            });
            for (const e of I.getSlides())null === (l = null === (i = e.panzoomRef) || void 0 === i ? void 0 : i.getGestures()) || void 0 === l || l.destroy(), null === (a = null === (r = e.panzoomRef) || void 0 === r ? void 0 : r.getTween()) || void 0 === a || a.pause();
        }
        const u = null == I ? void 0 : I.getPlugins().fullscreen;
        u && u.inFullscreen() ? Promise.resolve(u.exit()).then(()=>{
            setTimeout(()=>{
                je(e, t);
            }, 150);
        }) : je(e, t);
    }
    function je(e, t) {
        var n, o, i, l, s;
        if (B !== $dbe674dd1f608c29$export$b3af8f1b99ca9976.Closing) return;
        if (Y("close", e), U("placeFocusBack")) {
            const e = ve();
            !e || (s = e.getBoundingClientRect()).bottom > 0 && s.right > 0 && s.left < (window.innerWidth || document.documentElement.clientWidth) && s.top < (window.innerHeight || document.documentElement.clientHeight) || e.scrollIntoView({
                behavior: "instant",
                block: "center",
                inline: "center"
            });
        }
        U("fadeEffect") && (null == w || w.classList.remove("is-ready"), null == w || w.classList.add("is-hiding")), null == w || w.classList.add("is-closing");
        const r = ge(), a = null == r ? void 0 : r.panzoomRef, c = null === (n = null == r ? void 0 : r.panzoomRef) || void 0 === n ? void 0 : n.getTween(), d = t || U("hideClass");
        let f = !1, m = !1;
        if (I && r && a && c) {
            let e;
            U("zoomEffect") && ((null === (i = null === (o = I.getTween()) || void 0 === o ? void 0 : o.getCurrentVelocities()) || void 0 === i ? void 0 : i.pos) || 0) < 700 && 1 === r.state && (e = ye(r)), e && (f = !0, I.on("refresh", ()=>{
                const e = ye(r);
                e && c.to(Object.assign(Object.assign({}, (0, $868588f20a38800c$export$15463f5204f2871f)), e));
            }), c.easing((0, $6f48c3b0d4f5e032$export$208a41d6b4e37b97).Easings.EaseOut).duration(350).from(Object.assign({}, a.getTransform())).to(Object.assign(Object.assign({}, (0, $868588f20a38800c$export$15463f5204f2871f)), e)).start());
        }
        const p = (null == r ? void 0 : r.htmlEl) || (null === (l = null == r ? void 0 : r.panzoomRef) || void 0 === l ? void 0 : l.getWrapper());
        p && $dbe674dd1f608c29$var$A(p), !f && d && p && (m = !0, $dbe674dd1f608c29$var$M(p, d, ()=>{
            Pe();
        })), f || m ? setTimeout(()=>{
            Pe();
        }, 350) : Pe();
    }
    function Pe() {
        var e, t, n, o, i, s;
        if (B === $dbe674dd1f608c29$export$b3af8f1b99ca9976.Destroyed) return;
        B = $dbe674dd1f608c29$export$b3af8f1b99ca9976.Destroyed, document.body.removeEventListener("click", de), document.body.removeEventListener("keydown", ue, {
            passive: !1,
            capture: !0
        });
        const a = ve();
        Y("destroy"), null === (t = null === (e = U("sync")) || void 0 === e ? void 0 : e.getPlugins().Autoplay) || void 0 === t || t.resume(), null === (o = null === (n = U("sync")) || void 0 === n ? void 0 : n.getPlugins().Autoscroll) || void 0 === o || o.resume(), r instanceof HTMLDialogElement && r.close(), null === (i = null == I ? void 0 : I.getContainer()) || void 0 === i || i.classList.remove("is-idle"), null == I || I.destroy();
        for (const e of Object.values(V))null == e || e.destroy();
        if (V = {}, null == r || r.remove(), r = void 0, w = void 0, I = void 0, $dbe674dd1f608c29$var$O.delete(q), !$dbe674dd1f608c29$var$O.size) {
            if ((0, $b02d5d471dc29732$export$b539ed14f4f9e78)(!1), document.documentElement.classList.remove($dbe674dd1f608c29$var$R), U("placeFocusBack")) try {
                null == a || a.focus({
                    preventScroll: !0
                });
            } catch (e) {}
            else null === (s = document.activeElement) || void 0 === s || s.blur();
        }
    }
    const Se = {
        close: Le,
        destroy: Pe,
        getCarousel: function() {
            return I;
        },
        getContainer: function() {
            return w;
        },
        getId: function() {
            return q;
        },
        getOptions: function() {
            return N;
        },
        getPlugins: function() {
            return V;
        },
        getSlide: function() {
            return ge();
        },
        getState: function() {
            return B;
        },
        init: function(e = [], t = {}) {
            return Z(e, t), Se;
        },
        isCurrentSlide: function(e) {
            const t = ge();
            return !(!e || !t) && t.index === e.index;
        },
        isTopMost: function() {
            return pe();
        },
        off: function(e, t) {
            return G.has(e) && G.set(e, G.get(e).filter((e)=>e !== t)), Se;
        },
        on: function(e, t) {
            return G.set(e, [
                ...G.get(e) || [],
                t
            ]), Se;
        },
        toggleIdle (e) {
            (W || !0 === e) && Ee(), W && !1 !== e || we();
        }
    };
    return Se;
};
const $dbe674dd1f608c29$export$cb45b08d97cdc4fd = {
    Plugins: {
        Hash: (0, $78c8c06ba8520dc5$export$ab85ecd77ce6a5cd)
    },
    version: "6.0.29",
    openers: new Map,
    bind: function(e, n, o) {
        if (!(0, $f96a9ede5ac3bcc5$export$71594e8a50f746f4)()) return;
        let i = document.body, l = "[data-fancybox]", s = {};
        if ((0, $585a18adb7d59904$export$844ec244b1367d54)(e) ? (i = document.body, l = e, "object" == typeof n && (s = n || {})) : e instanceof Element && (i = e, (0, $585a18adb7d59904$export$844ec244b1367d54)(n) && (l = n), "object" == typeof o && (s = o || {})), !(i && i instanceof Element && l)) return !1;
        const a = $dbe674dd1f608c29$export$cb45b08d97cdc4fd.openers.get(i) || new Map;
        if (a.set(l, s), $dbe674dd1f608c29$export$cb45b08d97cdc4fd.openers.set(i, a), 1 === a.size) {
            i.addEventListener("click", $dbe674dd1f608c29$export$cb45b08d97cdc4fd.fromEvent);
            for (const e of Object.values($dbe674dd1f608c29$export$cb45b08d97cdc4fd.Plugins)){
                const t = e.setup;
                "function" == typeof t && t($dbe674dd1f608c29$export$cb45b08d97cdc4fd);
            }
        }
        return !0;
    },
    close: function(e = !0, ...t) {
        if (e) for (const e of $dbe674dd1f608c29$var$O.values())e.close(...t);
        else {
            const e = $dbe674dd1f608c29$export$cb45b08d97cdc4fd.getInstance();
            e && e.close(...t);
        }
    },
    destroy: function() {
        let e;
        for(; e = $dbe674dd1f608c29$export$cb45b08d97cdc4fd.getInstance();)e.destroy();
        for (const e of $dbe674dd1f608c29$export$cb45b08d97cdc4fd.openers.keys())e.removeEventListener("click", $dbe674dd1f608c29$export$cb45b08d97cdc4fd.fromEvent);
        $dbe674dd1f608c29$export$cb45b08d97cdc4fd.openers.clear();
    },
    fromEvent: function(e) {
        var t, n, o;
        if (e.defaultPrevented) return;
        if (e.button && 0 !== e.button) return;
        if (e.ctrlKey || e.metaKey || e.shiftKey) return;
        let i = e.composedPath()[0];
        if (i.closest(".fancybox__container.is-hiding")) return e.preventDefault(), void e.stopPropagation();
        const l = i.closest("[data-fancybox-delegate]") || void 0;
        if (l) {
            const e = l.dataset.fancyboxDelegate || "", t = document.querySelectorAll(`[data-fancybox="${e}"]`);
            i = t[parseInt(l.dataset.fancyboxIndex || "", 10) || 0] || t[0];
        }
        if (!(i && i instanceof Element)) return;
        let r, a, c = {};
        for (const [e, t] of $dbe674dd1f608c29$export$cb45b08d97cdc4fd.openers)if (t && e.contains(i)) for (const [n, o] of t){
            let t = null;
            try {
                t = i.closest(n);
            } catch (e) {}
            t && (i = t, r = e, a = n, (0, $56a4b1af55519d9a$export$8b58be045bf06082)(c, o || {}));
        }
        if (!r || !a) return;
        e.preventDefault();
        const u = (0, $56a4b1af55519d9a$export$8b58be045bf06082)({}, $dbe674dd1f608c29$var$_, {
            triggerEvent: e,
            triggerEl: i,
            delegateEl: l
        }, c), d = u.groupAll, f = u.groupAttr, m = f && i ? i.getAttribute(`${f}`) : "";
        let p = [];
        const g = null === (t = i.closest(".f-carousel")) || void 0 === t ? void 0 : t.carousel;
        if (g) {
            const e = [];
            for (const t of null == g ? void 0 : g.getSlides()){
                const n = t.el;
                n && (n.matches(a) ? e.push(n) : e.push(...[].slice.call(n.querySelectorAll(a))));
            }
            e.length && (p = [
                ...e
            ], null === (n = g.getPlugins().Autoplay) || void 0 === n || n.pause(), null === (o = g.getPlugins().Autoscroll) || void 0 === o || o.pause(), u.sync = g);
        } else (!i || m || d) && (p = [].slice.call(r.querySelectorAll(a)));
        if (i && !d && (p = f && m ? p.filter((e)=>e.getAttribute(`${f}`) === m) : [
            i
        ]), !p.length) return;
        const v = $dbe674dd1f608c29$export$cb45b08d97cdc4fd.getInstance();
        if (v) {
            const e = v.getOptions().triggerEl;
            if (e && p.indexOf(e) > -1) return;
        }
        return Object.assign({}, u.Carousel || {}).rtl && (p = p.reverse()), i && (u.startIndex = p.indexOf(i)), $dbe674dd1f608c29$export$cb45b08d97cdc4fd.fromNodes(p, u);
    },
    fromNodes: function(e, t) {
        t = (0, $56a4b1af55519d9a$export$8b58be045bf06082)({}, $dbe674dd1f608c29$var$_, t || {});
        const n = [], o = (e)=>e instanceof HTMLImageElement ? e : e instanceof HTMLElement ? e.querySelector("img:not([aria-hidden])") : void 0;
        for (const i of e){
            const l = i.dataset || {}, s = t.delegateEl && e.indexOf(i) === t.startIndex ? t.delegateEl : void 0, r = o(s) || o(i) || void 0, a = l.src || i.getAttribute("href") || i.getAttribute("currentSrc") || i.getAttribute("src") || void 0, c = l.thumb || l.thumbSrc || (null == r ? void 0 : r.getAttribute("currentSrc")) || (null == r ? void 0 : r.getAttribute("src")) || (null == r ? void 0 : r.dataset.lazySrc) || void 0, u = {
                src: a,
                alt: l.alt || (null == r ? void 0 : r.getAttribute("alt")) || void 0,
                thumbSrc: c,
                thumbEl: r,
                triggerEl: i,
                delegateEl: s
            };
            for(const e in l){
                let t = l[e] + "";
                t = "false" !== t && ("true" === t || t), u[e] = t;
            }
            n.push(u);
        }
        return $dbe674dd1f608c29$export$cb45b08d97cdc4fd.show(n, t);
    },
    fromSelector: function(e, n, o) {
        let i = document.body, l = "", r = {};
        if ((0, $585a18adb7d59904$export$844ec244b1367d54)(e) ? l = e : e instanceof Element && (i = e, (0, $585a18adb7d59904$export$844ec244b1367d54)(n) && (l = n), "object" == typeof o && (r = o || {})), !(i && i instanceof Element && l)) return;
        const a = $dbe674dd1f608c29$export$cb45b08d97cdc4fd.openers.get(i);
        return a ? (r = (0, $56a4b1af55519d9a$export$8b58be045bf06082)({}, a.get(l) || {}, r), r ? $dbe674dd1f608c29$export$cb45b08d97cdc4fd.fromNodes(Array.from(i.querySelectorAll(l)), r) : void 0) : void 0;
    },
    getCarousel: function() {
        var e;
        return (null === (e = $dbe674dd1f608c29$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getCarousel()) || void 0;
    },
    getDefaults: function() {
        return $dbe674dd1f608c29$var$_;
    },
    getInstance: function(e) {
        if (e) {
            const t = $dbe674dd1f608c29$var$O.get(e);
            return t && t.getState() !== $dbe674dd1f608c29$export$b3af8f1b99ca9976.Destroyed ? t : void 0;
        }
        return Array.from($dbe674dd1f608c29$var$O.values()).reverse().find((e)=>{
            if (e.getState() !== $dbe674dd1f608c29$export$b3af8f1b99ca9976.Destroyed) return e;
        }) || void 0;
    },
    getSlide: function() {
        var e;
        return (null === (e = $dbe674dd1f608c29$export$cb45b08d97cdc4fd.getInstance()) || void 0 === e ? void 0 : e.getSlide()) || void 0;
    },
    show: function(e = [], t = {}) {
        return $dbe674dd1f608c29$var$I().init(e, t);
    },
    unbind: function(e, n) {
        let o = document.body, i = "";
        if ((0, $585a18adb7d59904$export$844ec244b1367d54)(e) ? i = e : e instanceof Element && (o = e, (0, $585a18adb7d59904$export$844ec244b1367d54)(n) && (i = n)), o) {
            const e = $dbe674dd1f608c29$export$cb45b08d97cdc4fd.openers.get(o);
            e && i && e.delete(i), (null == e ? void 0 : e.size) && i || $dbe674dd1f608c29$export$cb45b08d97cdc4fd.openers.delete(o), o.removeEventListener("click", $dbe674dd1f608c29$export$cb45b08d97cdc4fd.fromEvent);
        }
    }
};
















/*! License details at fancyapps.com/license */ 






const $f7d395a565a87b0b$var$startingWith = (subject, replacement)=>({ name: name, value: value })=>{
        if (name.startsWith(subject)) name = name.replace(subject, replacement);
        return {
            name: name,
            value: value
        };
    };
const $f7d395a565a87b0b$export$135d5ebe5fa56b46 = ()=>{
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefix("data-js-");
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-alt", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("bind:alt")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-fancybox", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("bind:data-fancybox")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-href", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("bind:href")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-key", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("bind:key")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-style", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("bind:style")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-src", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("bind:src")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-class", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("bind:class")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-change", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("on:change")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-click", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("on:click")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-dragover", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("on:dragover")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-dragleave", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("on:dragleave")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-drop", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("on:drop")));
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).mapAttributes($f7d395a565a87b0b$var$startingWith("data-js-submit", (0, $f347e48613385d9c$export$2e2bcd8739ae039).prefixed("on:submit")));
};


document.addEventListener("alpine:init", ()=>{
    window.Arrows = (0, $601560cf604299af$export$b6e350ab9915297a);
    window.Carousel = (0, $da1ac87b7e404694$export$144901db2ea8e967);
    window.Fancybox = (0, $dbe674dd1f608c29$export$cb45b08d97cdc4fd);
    window.Hammer = (0, (/*@__PURE__*/$parcel$interopDefault($9e1724f0f41c40ad$exports)));
    window.Lazyload = (0, $4accc7b78e8dfc04$export$6f539aaa4f74fdd1);
    window.Thumbs = (0, $5aebe5144ead9aa9$export$73e055b807a6709);
    (0, $f347e48613385d9c$export$2e2bcd8739ae039).plugin([
        (0, $ojnWK.default)
    ]);
    (0, $f7d395a565a87b0b$export$135d5ebe5fa56b46)();
});
(0, $f347e48613385d9c$export$2e2bcd8739ae039).start();

})();
//# sourceMappingURL=init.js.map
